import React, { Component, Fragment } from 'react'
import { SourcingCompareEventBuyerStyle } from './styled'
import { checkFileType } from '../../helpers/functions/checkFileType'
import {
  Breadcrumbs,
  Button,
  Checkbox,
  ConfirmModalRequestUnseal,
  DatePickerInput,
  Image,
  Input,
  InputTextarea,
  Loaders,
  Modal,
  Section,
  SelectBox,
  Spinner,
  Tabber,
  Table,
  Text,
  ToggleCompareEvent,
  AttachedFile,
  Paginate,
  Loading,
} from '../../components'
import NumberFormat from 'react-number-format'
import {
  auctionController,
  eventNewController,
  mySupplierCompanyController,
  rfqController,
} from '../../apiService'
import Countdown from 'react-countdown'
import { ICONS } from '../../themes'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import {
  allowcateType,
  dateMonDayYearTime,
  dateMonDayYearTimeFull,
  formatNumberWithCommaN2Decimal,
  funcCheckStatusProject,
  localStorageService,
  ROUTE_PATH,
  selectionType,
  STRING,
  toastActive,
  toastFail,
  toFixedSpecial,
  isAllowedChangePage,
} from '../../helpers'
import { sealStatus } from '../../helpers/constants'
import FileDownload from 'js-file-download'
import { connect } from 'react-redux'
import moment from 'moment'
import Numeral from 'numeral'
import TooltipBuyer from '../../components/TooltipBuyer'
import {
  sendApiRequestUnseal,
  sendApiRequestUnsealTec,
  startApiRequestUnseal,
  startApiRequestUnsealTec,
} from '../../store/actions'
import { store } from 'store'
import {
  activityRoles,
  controller,
  pageSourcingBuyerController,
  rolesObj,
} from '../../middleware'
import { pageCompareEventApprovalController } from '../../middleware/pageFunctionMultiRole'
import { filter, find, has, isEmpty, isUndefined, map, some } from 'lodash'
import { companyController } from '../../apiService/index'
import auctionService from '../../apiService/services/auctionService'
import ModalHistoryOfSupplier from './element/ModalHistoryOfSupplier'

import ApprovalWorkflow from './components/ApprovalWorkflow/ApprovalWorkflow'
import CompareListTable from './components/CompareListTable/CompareListTable'
import { mockQuotationList } from './mocks/quotationList.mock'
import { mockWorkflow } from './mocks'

export class SourcingCompareEventBuyerContainers extends Component {
  _isMounted = false
  _clicksOneSubmit = 0
  _clicksOneReqSubmit = 0
  constructor(props) {
    super(props)
    this.state = {
      showSaving: false,
      idRFQ: '',
      modals: [
        { name: 'supplier-description', isOpen: false },
        { name: 'reschedule', isOpen: false },
        { name: 'purchasing', isOpen: false },
        { name: 'cancelevent', isOpen: false },
        { name: 'attachment', isOpen: false },
        { name: 'note-to-buyer', isOpen: false },
        { name: 'request-unseal', isOpen: false },
        { name: 'confirm-request-unseal', isOpen: false },
        { name: 'tec-unseal', isOpen: false },
        { name: 'allow-selection', isOpen: false },
        { name: 'items-information', isOpen: false },
        { name: 'modals-savingtype', isOpen: false },
        { name: 'modals-clear-all', isOpen: false },
        { name: 'modals-submit-award', isOpen: false },
        { name: 'modals-check-award', isOpen: false },
        { name: 'modals-re-submit-award', isOpen: false },
        { name: 'modals-approve-award', isOpen: false },
        { name: 'modals-approval-contact', isOpen: false },
        { name: 'modals-history-approval', isOpen: false },
        { name: 'modals-history-of-supplier', isOpen: false },
        { name: 'cancel-request', isOpen: false },
        { name: 'modal-submit-reject', isOpen: false },
        { name: 'modal-no-selection-reason', isOpen: false },
        { name: 'modal-edit-exchange-rate', isOpen: false },
      ],
      isFromDetail: false,
      activeStep: 0,
      eventHaveAwaApp: false,
      cancelReasonValue: null,
      cancelReasonText: '',
      isErrOther: false,
      cancelReason: [],
      noSelectionReasonValue: null,
      noSelectionReasonText: '',
      noSelectionReason: [],
      businessCategory: [],
      products: {
        items: [],
      },
      formData: {
        purchasing_type_id: 1,
        is_vat: 0,
        currency_id: 2,
        bidding_type: '',
      },
      newScheduleDate: {
        start_date: null,
        end_date: null,
      },
      UOM: [],
      contactInformation: {
        name: null,
        email: null,
        phone: null,
      },
      itemBidHistory: [],
      itemBidClick: '',
      loadingBid: true,

      optionsPredecessor: [],
      quotationList: [],
      quotationDetail: null,
      supplierList: [],
      selectSuppliersRfq: [],
      checkAllSupplier: true,
      statusRFQ: 0,
      internalFile: [],
      externalFile: [],
      isErrMsgEndDate: '',
      isErrMsgStartDate: '',
      isErrMsgReasonValue: '',
      isErrMsgReasonText: '',
      isErrMsgNoSelectionReasonText: '',
      paginationTecContacts: {
        search: '',
        page: 1,
        next_page: 2,
      },
      tempTec: [],
      stackTec: [],
      loadingUserTecContacts: false,
      userTecContacts: [],
      modalsOpenConfirm: false,
      modalsOpenReqUnseal: false,
      savePositionPrev: [],
      checkAllRequestUnseal: [],
      loadingUserTecTable: true,
      dataInitTableTec: [],
      modalSave: null,
      tableSave: false,
      searchValue: false,
      checkBoxDataTable: [],
      searchSaveTemp: [],
      checkRole: '',
      checkMultiRole: '',
      quotationCheckBox: {},
      supplierNameTableItem: [],
      setDataInit: [],
      itemAction: {
        selectedBySupplier: [],
      },
      tempData: [],
      savingType: {
        error: false,
        res: '',
      },
      allocateItems: {},
      resultCheckBoxSelected: [],
      quotaSelected: [],
      errorSelect: [],
      resultSelect: [],
      totalNumberSelect: 0,
      allowSupplierSelected: [],
      setNoItemSelect: [],
      idProject: '',
      dataProject: '',
      valueBsCategories: '',
      predecessorValue: '',
      eventListProject: [],
      internalFileProject: [],
      checkAward: {
        submitaward: 'Budget price',
        selected: 'Budget price',
      },
      submitAward: false,
      reSubmitAward: false,
      eventTypes: [],
      statuses: [],
      awardStatuses: [],
      approValWorkflow: null,
      statusAppVal: {
        requester: 'Requester',
        approved: 'Approved',
        reject: 'Reject',
        padding: 'Pending',
        inactive: 'Inactive',
      },
      approvalNote: '',
      approvalFiels: [],
      loadingApprovalFiels: false,
      statusRolesApp: 0,
      rolesCheck: null,
      approvalHisRes: [],
      reasonCancelRequest: '',
      isLoading: false,
      baseCurrency: 'THB',
      exchangeRate: 0,

      searchPage: 1,
      activePage: 1,
      limit: 1000,
      total_record: 0,
      offset: 0,
      event_id: '',
      recordsItem: [],

      eventListHaveApprove: false,
      eventIsApproving: false,
      isConfirming: false,
      showButtonSubmit: true,
      // showButtonApprove: true,
      showButtonCancel: true,
      showButtonNoSelect: true,
      isHavingListEventOpen: false,

      loadingDownloadFile: [],
    }
  }
  componentDidMount = () => {
    this.checkToken()
  }
  checkToken = async () => {
    const tokens = new URLSearchParams(this.props.location.search).get('token')
    // console.log('tokens', tokens)
    if (tokens) {
      try {
        const resToken = await eventNewController().getVerifyTokenEmail(tokens)
        // console.log('resToken', resToken)
        if (resToken && resToken.is_verify) {
          // localStorageService.clearSourcingDetail()
          this.getCompareEvent()
        } else {
          toastFail(resToken.message)
          // this.goBack()
          controller().redirectToLogin()
        }
      } catch (e) {
        // this.goBack()
        controller().redirectToLogin()
      }
    } else {
      // localStorageService.clearSourcingDetail()
      this.getCompareEvent()
    }
  }

  getCompareEvent = () => {
    const { match } = this.props
    const { params } = match
    const { id, rfqid, eventType } = params

    document
      .getElementById('sourcing_request_unseal')
      .addEventListener('scroll', this._handleScroll.bind(this))
    const isFromDetail = localStorage.getItem('isFromDetail')
      ? localStorage.getItem('isFromDetail')
      : false
    this.getMaster.getCancelReason()
    this.getMaster.getReasonNoSelectionSourcingProject()
    this.getMaster.getUOM()
    this._isMounted = true
    localStorageService.clearSourcingCompare()
    localStorage.removeItem('idProject')
    localStorage.removeItem('rfqid')
    localStorage.removeItem('save_data')
    store.dispatch(startApiRequestUnseal())
    store.dispatch(startApiRequestUnsealTec())
    const roles = pageSourcingBuyerController().asset()
    const multiRole = pageSourcingBuyerController().getMultiRole()
    const checkRole = pageCompareEventApprovalController().asset()
    this.setState({
      isFromDetail,
      checkRole: roles,
      checkMultiRole: multiRole,
      idProject: id,
      idRFQ: rfqid,
      rolesCheck: checkRole,
    })

    if (Number(eventType) === 1) {
      this.fetchTecTableContacts()
    }
    this.getApprovalWorkflow(rfqid)
    this.funcGetSavingType()
    this.getEventById(rfqid)
    // this.getSupplierListCompare(rfqid)
    this.funcGetSourcingProject()
    // this.funcGetEventProject()
    this.funcGetBusinessCategory()
    this.funcGetPredecessor()
    this.funcGetInternalFileProject()
    this.getEventStatus()
    this.getEventTypes()
    this.getEventAwardStatus()

    this.funcGetApprovalHistory(rfqid)
    this.getCompany()
  }

  refreshPage = () => {
    window.location.reload()
  }
  getCompany = async () => {
    try {
      const res = await companyController().getCompany()

      console.log('res company', res)
      if (res) {
        this.setState({
          baseCurrency: res.base_currency.name,
        })
      }
    } catch (error) {
      console.log(error)
    }
  }

  async funcCheckEventAwaitingApprove(res, isCancelReq) {
    // functions check event Award status มี Awaiting Approve หรือ Awarded
    try {
      const filterArrEvent = map(res.events, (value, index) => {
        const { rfq_detail, auction_detail } = value
        let detail = []
        if (rfq_detail && rfq_detail.id) {
          detail.push(rfq_detail)
        }
        if (auction_detail && auction_detail.id) {
          detail.push(auction_detail)
        }
        const filterAward = filter(
          detail,
          value =>
            value.rfq_award_status === 'Awaiting Approve' ||
            value.rfq_award_status_id === 4 ||
            value.rfq_award_status === 'Awarded' ||
            value.rfq_award_status_id === 6 ||
            value.auction_award_status === 'Awaiting Approve' ||
            value.auction_award_status_id === 4 ||
            value.auction_award_status === 'Awarded' ||
            value.auction_award_status_id === 6
        )
        return filterAward[0]
      })
      const removeUndefined = filter(
        filterArrEvent,
        value => value !== undefined
      )
      removeUndefined.length > 0
        ? this.setState({ eventHaveAwaApp: true })
        : this.setState({ eventHaveAwaApp: false })

      if (res.events) {
        const { rfqid } = this.props.match.params
        res.events.map((item, i) => {
          const { rfq_detail, auction_detail } = item
          // console.log('eventListHaveApprove', res.events.length)
          const award_status =
            item.event_type_id === 1
              ? rfq_detail.rfq_award_status
              : auction_detail.auction_award_status
          const award_status_id =
            item.event_type_id === 1
              ? rfq_detail.rfq_award_status_id
              : auction_detail.auction_award_status_id

          // console.log('award_status', award_status, award_status_id)
          if (res.events.length > 1) {
            if (
              (award_status === 'Awaiting Approve' || award_status_id === 4) &&
              rfqid !== item.sourcing_id
            ) {
              console.log('TRUE')
              this.setState({ eventListHaveApprove: true })
            } else if (
              award_status === 'Awaiting Approve' &&
              rfqid === item.sourcing_id
            ) {
              console.log('FALSE 1')
              this.setState({ eventListHaveApprove: false })
            } else if (
              isCancelReq &&
              (award_status === 'Awaiting Selection' || award_status_id === 3)
            ) {
              console.log('FALSE 2')
              this.setState({ eventListHaveApprove: false })
            }
          } else {
            // console.log('FALSE List <= 1')
            this.setState({ eventListHaveApprove: false })
          }
        })
      }
    } catch (error) {
      console.log(error)
    }
  }

  async funcCheckButtonReSubmitAward() {
    const { dataProject } = this.state
    const { created_by_id } = dataProject
    const createby = created_by_id ? created_by_id.toString() : ''
    // functions check roles ที่สามารถ ReSubmitAward ได้
    const objRoles = {
      action: {
        actions: ['button_resubmit_award'],
        create_by: createby,
      },
      page: 'sourcing-compare-events',
    }
    return activityRoles().checkRolesActions(objRoles)
  }
  funcCheckSelectionsRole() {
    const { dataProject } = this.state
    const { created_by_id } = dataProject
    const createby = created_by_id ? created_by_id.toString() : ''
    // functions check roles ที่สามารถ selections ได้
    const objRoles = {
      action: {
        actions: ['selections_roles'],
        create_by: createby,
      },
      page: 'sourcing-compare-events',
    }
    return activityRoles().checkRolesActions(objRoles)
  }
  funcCheckExportRole() {
    // functions check roles ที่สามารถ export ได้
    const objRoles = {
      action: {
        actions: ['button_export'],
      },
      page: 'sourcing-compare-events',
    }
    return activityRoles().checkRolesActions(objRoles)
  }
  funcCheckCopyRole() {
    // functions check roles ที่สามารถเห็น Button copy ได้
    const objRoles = {
      action: {
        actions: ['button_copy'],
      },
      page: 'sourcing-compare-events',
    }
    return activityRoles().checkRolesActions(objRoles)
  }
  funcCheckSubmitAwardRole() {
    // functions check roles ที่สามารถเห็น Button SubmitAward ได้
    const { dataProject } = this.state
    const { created_by_id } = dataProject
    const createby = created_by_id ? created_by_id.toString() : ''
    const objRoles = {
      action: {
        actions: ['submit_award'],
        create_by: createby,
      },
      page: 'sourcing-compare-events',
    }
    return activityRoles().checkRolesActions(objRoles)
  }
  funcShowSavingClearAll = () => {
    const { formData, statusRFQ } = this.state
    const { seal_status_name, seal_type } = formData
    // เช็ค user ที่สามารถมองเห็น ปุ่ม Saving Type และ Clear All ได้
    const objRoles = {
      action: {
        actions: ['button_saving_type_clear'],
        sealtypeRes: seal_type,
        seal_status: seal_status_name,
      },
      page: 'sourcing-compare-events',
    }
    const checkActions = activityRoles().checkRolesActions(objRoles)
    if (statusRFQ === 4) {
      return checkActions
    } else {
      return false
    }
  }

  funcShowButtonNoSelection = () => {
    const { dataProject } = this.state
    const { created_by_id } = dataProject
    const createby = created_by_id ? created_by_id.toString() : ''
    // เช็ค user ที่สามารถมองเห็น ปุ่ม NoSelection ได้
    const objRoles = {
      action: {
        actions: ['button_no_selection'],
        create_by: createby,
      },
      page: 'sourcing-compare-events',
    }

    return activityRoles().checkRolesActions(objRoles)
  }
  async getApprovalWorkflow(rfqid = '') {
    const { eventType } = this.props.match.params
    const resRoles = pageCompareEventApprovalController().asset()
    const { roles } = resRoles
    const userIdFw = localStorage.getItem('buyerId')
    const userId = parseInt(userIdFw, 10)
    let fileIdApproval = ''
    let noteApprover = ''
    if (rfqid) {
      let {
        approValWorkflow,
        approvalNote,
        approvalFiels,
        statusRolesApp,
      } = this.state
      let result = await eventNewController().getApproValWorkflow(rfqid)
      if (typeof result.levels !== 'undefined') {
        const { levels } = result
        const filterArrLevels = map(levels, (value, index) => {
          const { approvers } = value
          const filterId = filter(approvers, value => value.id === userId)
          return filterId[0]
        })
        const removeUndefined = filter(
          filterArrLevels,
          value => value !== undefined
        )
        if (removeUndefined.length !== 0) {
          const {
            approval_level_id,
            note_for_approver,
            status,
          } = removeUndefined[0]
          statusRolesApp = status
          fileIdApproval = approval_level_id
        }

        approValWorkflow = result
        this.setState({
          approValWorkflow,
          statusRolesApp,
        })
      }
    }
  }
  async funcGetApprovalHistory(rfqid = '') {
    let { approvalHisRes } = this.state
    const { eventType } = this.props.match.params
    if (rfqid) {
      let result = await eventNewController().getApprovalHistory(rfqid)
      if (result) {
        approvalHisRes = result
        this.setState({ approvalHisRes })
      }
    }
  }
  funCheckButtonReopen = () => {
    const { formData, awardStatuses, dataProject, statuses } = this.state
    const {
      rfq_status_id,
      rfq_award_status_id,
      auction_status_id,
      auction_award_status_id,
    } = formData
    const projectStatus = dataProject
      ? funcCheckStatusProject(dataProject.project_status_id)
      : ''
    const eventStatus = this.matchValue(
      statuses,
      rfq_status_id || auction_status_id
    )
    const awardStatus = this.matchValue(
      awardStatuses,
      rfq_award_status_id || auction_award_status_id
    )
    const { match } = this.props
    const { params } = match
    const { rfqid: compareRfqId } = params
    // console.log({ awardStatus })
    if (dataProject) {
      if (
        projectStatus === 'WIP' &&
        eventStatus === 'Closed' &&
        awardStatus !== 'Awaiting Approve' &&
        awardStatus !== 'No Selection'
      ) {
        return true
      } else {
        return false
      }
    }
  }
  funCheckButtonReschedule = () => {
    const { formData, awardStatuses, dataProject, statuses } = this.state
    const {
      rfq_status_id,
      rfq_award_status_id,
      auction_status_id,
      auction_award_status_id,
    } = formData
    const projectStatus = dataProject
      ? funcCheckStatusProject(dataProject.project_status_id)
      : ''
    const eventStatus = this.matchValue(
      statuses,
      rfq_status_id || auction_status_id
    )
    const awardStatus = this.matchValue(
      awardStatuses,
      rfq_award_status_id || auction_award_status_id
    )
    const { match } = this.props
    const { params } = match
    const { rfqid: compareRfqId } = params
    if (dataProject) {
      if (
        projectStatus === 'WIP' &&
        (eventStatus === 'Awaiting Open' || eventStatus === 'Open') &&
        eventStatus !== 'Closed'
      ) {
        return true
      } else {
        return false
      }
    }
  }

  getItemOfBidHistory = async supplier => {
    const { rfqid } = this.props.match.params

    const itemOfBidHistory = await auctionService.getAuctionBiddingHistoryByAuctionIdNUserId(
      rfqid,
      supplier.supplier_id
    )
    // console.log('bid item supplier ', itemOfBidHistory)
    this.setState({
      itemBidHistory: itemOfBidHistory,
      itemBidClick: supplier,
      loadingBid: false,
    })
  }
  renderAttachmentFile() {
    let {
      approvalFiels,
      approvalNote,
      statusRolesApp,
      awardStatuses,
      formData,
      rolesCheck,
      loadingApprovalFiels,
    } = this.state
    const { seal_status_name, seal_type } = formData
    const { unsealed } = sealStatus
    const matchValuePer = this.matchValue(
      awardStatuses,
      formData.rfq_award_status_id || formData.auction_award_status_id
    )
    const funcRenderInternalFile = () => {
      const handlerClick = (e, v) => {
        if (e.detail === 1) {
          if (v.id) {
            return this.downloadInternalApprovalNote(v)
          } else {
            return null
          }
        }
      }
      const handlersDeleteFile = (e, k) => {
        // if (e.detail === 1) {
        //   approvalFiels[k].status = false
        //   this.setState({ approvalFiels })
        // }
        const { approvalFiels } = this.state
        if (e) {
          approvalFiels.map(file => {
            if (file.id === e.id) {
              file.is_deleted = true
            }
          })
          this.setState({ approvalFiels })
        }
      }
      return map(approvalFiels, (value, index) => {
        const { status } = value
        if (status) {
          return (
            <Section className="attached-file-list" key={index}>
              <a
                target="_blank"
                className="file-link removable"
                rel="noopener noreferrer"
              >
                <span
                  onClick={e => handlerClick(e, value)}
                  className="file-name"
                >
                  {value.file_name}
                </span>
                <Button
                  className="link"
                  onClick={e => handlersDeleteFile(e, index)}
                >
                  <Image
                    className="delete-circle-icon"
                    src={ICONS['icon-delete-circle-red.svg']}
                    alt="delete circle"
                  />
                </Button>
              </a>
            </Section>
          )
        }
      })
    }
    const handlerClickAttachFile = e => {
      let { detail, target } = e
      if (!detail || detail === 1) {
        target.value = null
        return target.value
      }
    }
    const handlerChangeAttachFile = async e => {
      // const { target } = e
      const file = e
      const size = 50000000
      if (file) {
        loadingApprovalFiels = true
        this.setState({ loadingApprovalFiels })
        const isFilesType = await checkFileType(file)
        if (isFilesType) {
          if (file.size > size) {
            toastFail('File size exceeded 50 Mb')
            loadingApprovalFiels = false
            this.setState({ loadingApprovalFiels })
          } else {
            const formData = new FormData()
            formData.append('file', file)
            const res = await rfqController().createApprovalFile(formData)
            if (res === '4010: File contains code') {
              toast.error('Wrong file format.')
              loadingApprovalFiels = false
            } else if (res && res.id) {
              loadingApprovalFiels = false
              const resultData = {
                ...res,
                is_deleted: false,
              }
              approvalFiels.push(resultData)
              this.setState({ approvalFiels, loadingApprovalFiels })
            }
          }
        } else {
          loadingApprovalFiels = false
          this.setState({ loadingApprovalFiels })
        }
      }
    }
    const hideFileNote = this.funcHideAppWorkNoteFile()
    const onDeleteApprovalAttachFile = e => {
      // if (e.detail === 1) {
      //   approvalFiels[k].status = false
      //   this.setState({ approvalFiels })
      // }
      const { approvalFiels } = this.state
      if (e) {
        approvalFiels.map(file => {
          if (file.id === e.id) {
            file.is_deleted = true
          }
        })
        this.setState({ approvalFiels })
      }
    }
    return (
      <Section className="form-col col-12 attachment-approval">
        <Section className="form-group">
          <label className="tooltip-upload">
            Attachment <br /> (Optional)
            <Section className="link tooltip-attachment">
              <Image
                src={ICONS['icon-help.svg']}
                alt="help"
                tootipValue={`(*File type must be jpg, gif, png, bmp, tif, tiff, pdf, doc, docx, \n xls, xlsx, ppt, pptx, txt and Maximum File Size 50 Mb)`}
                useTootipFor="FileType"
                offset="{'top': -10 }"
                useTootip={true}
              />
            </Section>
          </label>
          {/* <Section className="form-group-control">
            <Section
              className="form-group-inner-wrapper"
              style={{ position: 'relative', marginBottom: '0.5em' }}
            >
              <InputUpload
                id="upload"
                isHideIput={true}
                browseButtonText="Attach"
                onClick={handlerClickAttachFile}
                onChange={handlerChangeAttachFile}
                isDisable={
                  this.state.eventListHaveApprove ||
                  this.state.isHavingListEventOpen
                    ? this.state.eventListHaveApprove ||
                      this.state.isHavingListEventOpen
                    : !hideFileNote
                    ? true
                    : false
                }
              />
            </Section>
            {funcRenderInternalFile()}
          </Section> */}
          <Section className="form-group-control">
            <AttachedFile
              maxFileSizeMb={50}
              classNameInput={'form-group-inner-wrapper'}
              onSelect={(file, e, cb) => {
                console.log('file', file)
                if (file != null) {
                  handlerChangeAttachFile(file)
                  cb()
                }
              }}
              isUpload={this.state.dataProject.project_status_id === 2}
              isHideIput={true}
              isDisableInput={
                this.state.eventListHaveApprove ||
                this.state.isHavingListEventOpen
                  ? this.state.eventListHaveApprove ||
                    this.state.isHavingListEventOpen
                  : !hideFileNote
                  ? true
                  : false
              }
              isIcon={true}
              hasRemove={true}
              fileList={this.state.approvalFiels}
              onDownload={e => {
                this.setLoadingDownloadFile(e)
                this.downloadInternalApprovalNote(e)
              }}
              onClickRemove={e => onDeleteApprovalAttachFile(e)}
              loadingDownload={this.state.loadingDownloadFile}
            />
          </Section>
        </Section>
      </Section>
    )
  }
  renderNote() {
    const {
      approvalNote,
      statusRolesApp,
      awardStatuses,
      formData,
      rolesCheck,
      dataProject,
    } = this.state
    const { seal_status_name, seal_type } = formData
    const { unsealed } = sealStatus
    const matchValuePer = this.matchValue(
      awardStatuses,
      formData.rfq_award_status_id
    )
    const hideFileNote = this.funcHideAppWorkNoteFile()
    const handlersChangeTextArea = e => {
      const noteValue = e.target.value
      this.setState({ approvalNote: noteValue })
    }
    return (
      <Section className="form-row note-approval">
        <Section className="form-col col-12">
          <Section className="form-group">
            <label>
              Note <br /> (Optional)
            </label>
            <Section className="form-group-control">
              <Section className="form-group-inner-wrapper">
                <InputTextarea
                  value={approvalNote}
                  isDisable={
                    this.state.eventListHaveApprove ||
                    this.state.isHavingListEventOpen
                      ? this.state.eventListHaveApprove ||
                        this.state.isHavingListEventOpen
                      : !hideFileNote
                      ? true
                      : false
                  }
                  onChange={handlersChangeTextArea}
                  id="approval-note"
                  placeholder="Note to Approver"
                />
              </Section>
            </Section>
          </Section>
        </Section>
        {this.renderAttachmentFile()}
      </Section>
    )
  }
  funcFormatNumber(price, fix = 2) {
    if (price && fix == 2) {
      let numberFormat = Numeral(price).format('0,0.00')
      return numberFormat
    } else {
      let numberFormat = Numeral(price).format('0,0.0000')
      return numberFormat
    }
  }
  getEventAwardStatus = async () => {
    const res = await eventNewController().getEventAwardStatus()
    if (res) {
      let option = []
      res.map(e => {
        const data = { value: parseInt(e.id), label: e.name }
        option.push(data)
      })
      return this.setState({ awardStatuses: option })
    }
  }
  getEventStatus = async () => {
    const res = await eventNewController().getEventStatus()
    if (res) {
      let option = []
      res.map(e => {
        const data = { value: parseInt(e.id), label: e.name }
        option.push(data)
      })
      return this.setState({ statuses: option })
    }
  }
  matchValue = (option, selectedId) => {
    if (selectedId) {
      const matchOption = option.find(
        value => value.value.toString() === selectedId.toString()
      )
      if (matchOption) {
        return matchOption.label
      }
    }
  }
  getEventTypes = async () => {
    const res = await rfqController().getEventTypes()
    if (res) {
      let option = []
      res.map(e => {
        const data = { value: e.ID, label: e.name }
        option.push(data)
      })
      return this.setState({ eventTypes: option })
    }
  }
  funcGetInternalFileProject = async () => {
    let { internalFileProject } = this.state
    const { match } = this.props
    const { params } = match
    const { id, rfqid } = params
    if (id) {
      const res = await rfqController().getInternalFileProject(id)
      if (res) {
        internalFileProject = res
        this.setState({ internalFileProject })
      }
      return res
    }
  }
  renderReopenAwaiting = (formData, roleTec) => {
    const { statusRFQ, awardStatuses } = this.state
    const rolesCheck = activityRoles().checkMultiRole(
      true,
      'reopen',
      'sourcing-compare-events'
    )
    const buyerId = localStorage.getItem('buyerId')
    const createby = formData.created_by_id
      ? formData.created_by_id.toString()
      : ''
    const isCreate = buyerId === createby ? true : false
    const { seal_status_name } = formData
    const matchValuePer = this.matchValue(
      awardStatuses,
      formData.rfq_award_status_id || formData.auction_award_status_id
    )
    const renderButtonReAction = () => {
      const { checkMultiRole } = this.state
      const handleOnClick = e => {
        const newScheduleDate = {
          ...formData,
        }
        if (this._isMounted) {
          return this.setState(
            {
              newScheduleDate,
            },
            this.toggleModal('reschedule')
          )
        }
      }
      const renderButtonEvent = () => {
        return (
          <Section className="page-button">
            {(statusRFQ === 2 || statusRFQ === 3 || statusRFQ === 4) &&
              !formData.is_cancel &&
              formData.rfq_award_status_id !== 7 && (
                <Button
                  className="page-button"
                  onClick={handleOnClick}
                  disabled={
                    this.state.eventListHaveApprove ||
                    this.state.isHavingListEventOpen
                  }
                >
                  <Image
                    src={ICONS['icon-calendar-white.svg']}
                    alt="add icon"
                  />

                  {statusRFQ === 4 &&
                    formData.rfq_award_status_id !== 7 &&
                    'Reopen Event'}
                </Button>
              )}
          </Section>
        )
      }
      const renderButtonReschedule = () => {
        return (
          <Section className="page-button">
            {(statusRFQ === 2 || statusRFQ === 3 || statusRFQ === 4) &&
              !formData.is_cancel && (
                <Button className="page-button" onClick={handleOnClick}>
                  <Image
                    src={ICONS['icon-calendar-white.svg']}
                    alt="add icon"
                  />
                  {statusRFQ !== 4 && 'Reschedule Event'}
                </Button>
              )}
          </Section>
        )
      }
      if (rolesCheck && isCreate) {
        const checkReopen = this.funCheckButtonReopen()
        const checkReschedule = this.funCheckButtonReschedule()
        if (
          matchValuePer !== 'Awaiting Approve' ||
          matchValuePer !== 'Awarded'
        ) {
          if (checkReopen) {
            return renderButtonEvent()
          } else if (checkReschedule && !checkReopen) {
            return renderButtonReschedule()
          }
        }
      }
    }
    if (seal_status_name != 'Awaiting Unseal') {
      return renderButtonReAction()
    }
  }
  renderAuctionEventLog = () => {
    return (
      <Section className="page-button">
        <Button
          className="page-button"
          onClick={async () => {
            await this.getAuctionEventCloseLog()
          }}
        >
          <Image src={ICONS['icon-export-white.svg']} alt="event-log icon" />
          Auction Event Log
        </Button>
      </Section>
    )
  }
  getAuctionEventCloseLog = async () => {
    const { formData } = this.state
    if (formData && formData.event_no) {
      return auctionController()
        .getAuctionEventCloseLog(formData.event_no)
        .then(res => {
          if (res.data) {
            FileDownload(res.data, `auction_${formData.event_no}` + '.txt')
            toast.success('Download Auction Event Log Success')
          }
        })
        .catch(error => {
          toast.error('Download Auction Event Log Error')
        })
    }
  }

  funcGetPredecessor = async () => {
    try {
      const resPredecessor = await rfqController().getPredecessor()
      if (resPredecessor) {
        const arrPredecessor = map(resPredecessor, (value, index) => {
          const { id, name } = value
          return {
            value: id,
            label: name,
          }
        })
        this.setState({ optionsPredecessor: arrPredecessor })
      }
    } catch (error) {
      console.log(error)
    }
  }
  async funcGetBusinessCategory() {
    let { businessCategory } = this.state
    const catBuyerId = localStorageService.getBuyerId()
    try {
      const res = await rfqController().getBusinessCategory({ catBuyerId })
      if (res) {
        businessCategory = res
        this.setState({ businessCategory })
      }
    } catch (error) {
      console.log(error)
    }
  }
  async funcGetSourcingProject(isCancelReq = false) {
    let {
      dataProject,
      valueBsCategories,
      predecessorValue,
      isHavingListEventOpen,
    } = this.state
    const { match } = this.props
    const { params } = match
    const { id, rfqid } = params
    try {
      // const res = await rfqController().getSourcingProject({ id, eventId: '' })
      // const res = await eventNewController().getEventDetailBuyer(rfqid)
      const res = await eventNewController().getProjectBuyer(id)
      if (res) {
        this.funcCheckEventAwaitingApprove(res, isCancelReq)
        const { categories, predecessors, events } = res
        const { ID, name } = categories
        dataProject = { ...res }
        const objCategories = {
          value: ID ? ID : '',
          label: name ? name : '-',
        }
        const objPredecessor = {
          value: predecessors ? predecessors.id : '',
          label: predecessors ? predecessors.name : '-',
        }
        valueBsCategories = objCategories
        predecessorValue = objPredecessor

        // if (events.length !== 0) {
        //   events.map((event, i) => {
        //     if (event.event_type_id === 1) {
        //       if (
        //         event.rfq_detail.rfq_status_id === 2 ||
        //         event.rfq_detail.rfq_status_id === 3 ||
        //         event.rfq_detail.rfq_status_id === 1 ||
        //         dataProject.project_status_id !== 2
        //       ) {
        //         isHavingListEventOpen = true
        //       }
        //     }
        //     if (event.event_type_id === 2) {
        //       if (
        //         event.auction_detail.auction_status_id === 2 ||
        //         event.auction_detail.auction_status_id === 3 ||
        //         event.auction_detail.auction_status_id === 1 ||
        //         dataProject.project_status_id !== 2
        //       ) {
        //         isHavingListEventOpen = true
        //       }
        //     }
        //   })
        // }

        this.setState({
          dataProject,
          valueBsCategories,
          predecessorValue,
          isHavingListEventOpen,
        })
      }
    } catch (error) {
      console.log(error)
      setTimeout(() => {
        toast.dismiss()
        this.props.history.push(ROUTE_PATH.HOME.LINK)
      }, 800)
    }
  }

  funcGetNoItemsSelect(res = '') {
    const { noSelection } = selectionType
    let { setNoItemSelect } = this.state
    try {
      if (res) {
        const filterData = filter(res, (value, index) => {
          const { selected_type } = value
          if (selected_type === noSelection) return value
        })
        if (filterData.length !== 0) {
          setNoItemSelect = filterData
        } else {
          setNoItemSelect = []
        }
        this.setState({ setNoItemSelect })
      }
    } catch (error) {
      console.log(error)
    }
  }
  async funcGetSavingType() {
    const { rfqid, eventType } = this.props.match.params
    const { savingType } = this.state
    let { submitAward } = this.state
    const errorSavingType = '53003: please select all items'
    try {
      let res = await eventNewController().getSavingType(rfqid)
      if (res === errorSavingType || res.award_price_fcy === '') {
        submitAward = true
        savingType.error = true
        savingType.res = ''
      } else {
        submitAward = false
        savingType.error = false
        savingType.res = { ...res }
      }
      this.setState({
        savingType,
        submitAward,
        exchangeRate: savingType.res.exchange_rate,
      })
    } catch (error) {
      console.log(error)
    }
  }
  funcGetSupplierSelected(res = '') {
    let { allowSupplierSelected } = this.state
    if (res) {
      const dataSelectItems = filter(res, (value, index) => {
        const { selected_type } = value
        if (selected_type === 'Allocated') return value
      })
      if (dataSelectItems.length !== 0) {
        const arraySelect = map(dataSelectItems, (selectValue, selectIndex) => {
          const {
            id,
            event_item_supplier,
            auction_item_supplier_response,
          } = selectValue
          return {
            id,
            ...(event_item_supplier && {
              event_item_supplier: event_item_supplier,
            }),
            ...(auction_item_supplier_response && {
              auction_item_supplier_response: auction_item_supplier_response,
            }),
          }
        })
        allowSupplierSelected = arraySelect
        this.setState({ allowSupplierSelected })
      } else {
        allowSupplierSelected = []
        this.setState({ allowSupplierSelected })
      }
    }
  }
  funcHideAppWork = () => {
    const {
      formData,
      rolesCheck,
      awardStatuses,
      statusRolesApp,
      checkMultiRole,
      dataProject,
      approValWorkflow,
    } = this.state
    const projectStatus = dataProject
      ? funcCheckStatusProject(dataProject.project_status_id)
      : ''
    const userIdFw = localStorage.getItem('buyerId')
    const userId = parseInt(userIdFw, 10)
    const { created_by_id } = dataProject
    const { roles } = rolesCheck
    const { seal_status_name, seal_type } = formData
    const { unsealed } = sealStatus
    const { eventType } = this.props.match.params

    const matchValuePer = this.matchValue(
      awardStatuses,
      formData.rfq_award_status_id || formData.auction_award_status_id
    )
    const awaApp = this.matchValue(
      awardStatuses,
      formData.rfq_award_status_id || formData.auction_award_status_id
    )
    const rejectedApp = this.matchValue(
      awardStatuses,
      formData.rfq_award_status_id || formData.auction_award_status_id
    )
    const createby = created_by_id ? created_by_id.toString() : ''
    const approvedStatus = () => {
      const flowApp = has(approValWorkflow, 'levels')
      if (flowApp) {
        const { levels } = approValWorkflow
        const filterArrLevels = map(levels, (value, index) => {
          const { approvers } = value
          const filterId = filter(
            approvers,
            value => value.id === userId && value.status !== 2
          )
          return filterId[0]
        })
        const removeUndefined = filter(
          filterArrLevels,
          value => value !== undefined
        )
        if (removeUndefined.length !== 0) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    }
    const approvedFlow = () => {
      const flowApp = has(approValWorkflow, 'levels')
      if (flowApp) {
        const { levels } = approValWorkflow
        const filterArrLevels = map(levels, (value, index) => {
          const { approvers } = value
          const filterId = filter(
            approvers,
            value => value.id === userId && value.status === 1
          )
          return filterId[0]
        })
        const removeUndefined = filter(
          filterArrLevels,
          value => value !== undefined
        )
        if (removeUndefined.length !== 0) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    }
    const resApprovedStatus = approvedStatus()
    const resFlowApprove = approvedFlow()
    // awaApp , rejectedApp = rfq_award_status
    const objRoles = {
      action: {
        actions: ['approval_workflow'],
        awaiting_approve: awaApp,
        create_by: createby,
        approved_status: resApprovedStatus,
        rejected: rejectedApp,
        flow_approve: resFlowApprove,
        sealtypeRes: seal_type, // รอ Auction มี seal (แล้วค่อยไปปรับใน activityRoles checkRolesActions เพิ่ม)
        seal_status: seal_status_name,
      },
      page: 'sourcing-compare-events',
    }
    const checkActions = activityRoles().checkRolesActions(objRoles)
    if (checkActions) {
      if (projectStatus) {
        return true
      } else {
        return false
      }
    } else {
      return false
    }
  }
  funcHideAppWorkNoteFile = () => {
    const {
      formData,
      rolesCheck,
      awardStatuses,
      statusRolesApp,
      checkMultiRole,
      dataProject,
      approValWorkflow,
    } = this.state
    const userIdFw = localStorage.getItem('buyerId')
    const userId = parseInt(userIdFw, 10)
    const { seal_status_name, seal_type } = formData
    const awaApp = this.matchValue(
      awardStatuses,
      formData.rfq_award_status_id || formData.auction_award_status_id
    )
    const rejectedApp = this.matchValue(
      awardStatuses,
      formData.rfq_award_status_id || formData.auction_award_status_id
    )
    const { created_by_id } = dataProject
    const createby = created_by_id ? created_by_id.toString() : ''
    const approvedStatus = () => {
      const flowApp = has(approValWorkflow, 'levels')
      if (flowApp) {
        const { levels } = approValWorkflow
        const filterArrLevels = map(levels, (value, index) => {
          const { approvers } = value
          const filterId = filter(
            approvers,
            value => value.id === userId && value.status !== 2
          )
          return filterId[0]
        })
        const removeUndefined = filter(
          filterArrLevels,
          value => value !== undefined
        )
        if (removeUndefined.length !== 0) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    }
    const approvedFlow = () => {
      const flowApp = has(approValWorkflow, 'levels')
      if (flowApp) {
        const { levels } = approValWorkflow
        const filterArrLevels = map(levels, (value, index) => {
          const { approvers } = value
          const filterId = filter(
            approvers,
            value => value.id === userId && value.status === 1
          )
          return filterId[0]
        })
        const removeUndefined = filter(
          filterArrLevels,
          value => value !== undefined
        )
        if (removeUndefined.length !== 0) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    }
    const checkApproverLast = () => {
      if (approValWorkflow === null) {
        return ''
      } else {
        const { levels } = approValWorkflow
        const filterArrLevels = map(levels, (value, index) => {
          const { approvers } = value
          const filterId = filter(
            approvers,
            value => value.status_string === 'Awaiting Approve'
          )
          if (filterId.length > 1) {
            return filterId
          } else {
            return filterId[0]
          }
        })
        const removeUndefined = filter(
          filterArrLevels,
          value => value !== undefined
        )
        return removeUndefined[0]
      }
    }

    const approverlast = checkApproverLast()

    const checkUserMatchApproverlast = () => {
      if (!approverlast) {
        return true
      } else {
        if (approverlast.length > 1) {
          const filterApprover = filter(
            approverlast,
            value => value.id === userId
          )
          if (!filterApprover[0]) {
            return false
          } else {
            if (userId === filterApprover[0].id) {
              return true
            } else {
              return false
            }
          }
        } else {
          if (userId === approverlast.id) {
            return true
          } else {
            return false
          }
        }
      }
    }

    const resApprovedStatus = approvedStatus()
    const resFlowApprove = approvedFlow()
    const objRoles = {
      action: {
        actions: ['note', 'attached'],
        awaiting_approve: awaApp,
        create_by: createby,
        approved_status: resApprovedStatus,
        rejected: rejectedApp,
        flow_approve: resFlowApprove,
        sealtypeRes: seal_type,
        seal_status: seal_status_name,
      },
      page: 'sourcing-compare-events',
    }
    const checkActions = activityRoles().checkRolesActions(objRoles)
    if (checkActions && checkUserMatchApproverlast()) {
      return true
    } else {
      return false
    }
  }
  funcShowbuttonAppRe = () => {
    const {
      formData,
      rolesCheck,
      awardStatuses,
      statusRolesApp,
      checkMultiRole,
      dataProject,
      approValWorkflow,
    } = this.state
    const userIdFw = localStorage.getItem('buyerId')
    const userId = parseInt(userIdFw, 10)
    const { created_by } = dataProject
    const { roles } = rolesCheck
    const { seal_status_name, seal_type } = formData
    const { unsealed } = sealStatus
    const matchValuePer = this.matchValue(
      awardStatuses,
      formData.rfq_award_status_id || formData.auction_award_status_id
    )
    const awaApp = this.matchValue(
      awardStatuses,
      formData.rfq_award_status_id || formData.auction_award_status_id
    )
    const rejectedApp = this.matchValue(
      awardStatuses,
      formData.rfq_award_status_id || formData.auction_award_status_id
    )
    const createby = created_by
    const approvedStatus = () => {
      const flowApp = has(approValWorkflow, 'levels')
      if (flowApp) {
        const { levels } = approValWorkflow
        const filterArrLevels = map(levels, (value, index) => {
          if (value.condition !== 'requester') {
            const { approvers } = value

            const filterId = filter(
              approvers,
              value => value.id === userId && value.status !== 2
            )
            return filterId[0]
          }
        })
        const removeUndefined = filter(
          filterArrLevels,
          value => value !== undefined
        )
        if (removeUndefined.length !== 0) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    }
    const approvedFlow = () => {
      const flowApp = has(approValWorkflow, 'levels')
      if (flowApp) {
        const { levels } = approValWorkflow
        const filterArrLevels = map(levels, (value, index) => {
          const { approvers } = value

          const filterId = filter(
            approvers,
            value => value.id === userId && value.status === 1
          )
          return filterId[0]
        })
        const removeUndefined = filter(
          filterArrLevels,
          value => value !== undefined
        )
        if (removeUndefined.length !== 0) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    }
    const resApprovedStatus = approvedStatus()
    const resFlowApprove = approvedFlow()
    const objRoles = {
      action: {
        actions: ['approve', 'reject'],
        awaiting_approve: awaApp,
        create_by: createby,
        approved_status: resApprovedStatus,
        rejected: rejectedApp,
        flow_approve: resFlowApprove,
        sealtypeRes: seal_type,
        seal_status: seal_status_name,
      },
      page: 'sourcing-compare-events',
    }
    const checkActions = activityRoles().checkRolesActions(objRoles)
    if (checkActions) {
      return true
    } else {
      return false
    }
  }
  renderCheckAllSupplier = (checkAllSupplier, e, ei) => {
    const { supplierList, formData } = this.state
    const funcMap = () => {
      const arr = []
      if (supplierList) {
        return supplierList.map((value, index) => {
          const data = {
            checked: value.checked,
          }
          return data
        })
      } else {
        return arr
      }
    }
    const check = funcMap()
    const funcElmHeight = () => {
      const elm = document.querySelectorAll('tr.supplier-item-row')
      elm.forEach(el => {
        const elm = el.getElementsByClassName('item')
        elm[0].style.paddingBottom = '8em'
      })
    }
    try {
      check.map((value, index) => {
        if (value.checked !== true && checkAllSupplier === false) {
          funcElmHeight()
        }
      })
    } catch (error) {
      console.log(error)
    }
    return check.map((value, index) => {
      if (value.checked) {
        const funcElmHeight = () => {
          const elm = document.querySelectorAll('tr.supplier-item-row')
          elm.forEach(el => {
            const elm = el.getElementsByClassName('item')
            elm[0].style.paddingBottom = 'unset'
          })
        }
        try {
          funcElmHeight()
        } catch (error) {
          console.log(error)
        }
        return (
          <Section
            className="header-calculate button-save"
            key={index}
            onClick={() => {
              if (check[index]) {
                this.onClickSaving(ei)
              }
            }}
          >
            Saving/Earning Calculation
            <Button className="arrow">
              <Image
                src={
                  e.checked
                    ? ICONS['caret-arrow-down.svg']
                    : ICONS['caret-arrow-up.svg']
                }
              />
            </Button>
          </Section>
        )
      } else {
        return ''
      }
    })
  }
  renderCreatedDate = formData => {
    const { created_at } = formData
    if (created_at) {
      const time = created_at
      // const IsoDateTo = moment(time, 'YYYY/MM/DD HH:mm:ss').utc(time).toDate()
      const IsoDateTo = moment(time, 'YYYY/MM/DD HH:mm:ss').toDate()
      return (
        <React.Fragment>
          <Input disabled={true} value={dateMonDayYearTime(IsoDateTo)} />
        </React.Fragment>
      )
    }
  }
  renderTargetDate = formData => {
    const { target_date } = formData
    if (target_date) {
      const time = target_date
      // const IsoDateTo = moment(time, 'YYYY/MM/DD HH:mm:ss').utc(time).toDate()
      const IsoDateTo = moment(time, 'YYYY/MM/DD HH:mm:ss').toDate()
      return IsoDateTo
    }
  }

  // sendApi request unseal
  modalUnsealTec = async () => {
    const { match } = this.props
    const { id, rfqid } = match.params
    const dataParams = {
      rfq_id: rfqid ? rfqid : '',
    }
    this._clicksOneSubmit += 1
    if (this._clicksOneSubmit === 1) {
      /*
      code: 51101
      result: "51101: event not ready to unseal"
      status: "error"
      */
      const res = await rfqController().submitUnseal(dataParams)
      const { data } = res
      // data.code
      /*
        51101: event not ready to unseal
        51102: event already unsealed
        51103: cannot unseal by this user
      */
      if (data) {
        this.toggleModal()
        switch (data.code) {
          case 51101: {
            this.goToSourcing()
            return store.dispatch(
              sendApiRequestUnsealTec('Event not ready to unseal')
            )
          }
          case 51102: {
            this.goToSourcing()
            return store.dispatch(
              sendApiRequestUnsealTec('Unsealed by Other TEC')
            )
          }
          case 51103: {
            this.goToSourcing()
            return store.dispatch(
              sendApiRequestUnsealTec('Cannot unseal by this user')
            )
          }
          default: {
            const { formData } = this.state
            this.getEventById(formData.id)
            this.getSupplierListCompare(formData.event_id)
            let newFromData = this.state.formData
            newFromData.seal_status_name = 'Unsealed'
            this.setState({ formData: newFromData })
            toast.success('Unseal completed')
          }
        }
      } else {
        this.toggleModal()
        this._clicksOneSubmit = 0
      }
    }
  }
  // notifyError
  notifyError = message => {
    if (message) {
      return toast.error(message)
    }
  }
  // renderUnsealButton
  renderUnsealButton = formData => {
    const { seal_status_name, rfq_award_status } = formData
    const awaitingSelection = 'Awaiting Selection'
    const handleOnclick = async () => {
      this.toggleModal('tec-unseal')
    }
    const renderUnsealButton = () => {
      return (
        <React.Fragment>
          <Button className="theme-green" onClick={handleOnclick}>
            Unseal
          </Button>
        </React.Fragment>
      )
    }
    const renderButtonAwaitingUnseal = () => {
      const roles = pageSourcingBuyerController().assetAwaiting()
      const multiRole = pageSourcingBuyerController().getMultiRole()
      const tecMultiRole = find(multiRole, data => {
        return data.id === rolesObj.tec
      })
      const resUserid = localStorageService.getBuyerId()
      const isTec = find(this.state.dataInitTableTec, data => {
        return data.id.toString() === resUserid && data.request_at
      })
      if (roles === rolesObj.admin || roles === rolesObj.systemadmin) {
        return renderUnsealButton()
      } else {
        if (isTec) {
          return renderUnsealButton()
        }
      }
    }
    if (
      seal_status_name === sealStatus.awaitingunseal &&
      rfq_award_status === awaitingSelection
    ) {
      return renderButtonAwaitingUnseal()
    }
  }
  fetchTecTableContacts = async () => {
    const { match } = this.props
    const { id, rfqid } = match.params
    const params = {
      idRfq: rfqid,
    }
    const res = await rfqController().getRequestUserTecTable(params)

    if (res.length >= 1) {
      if (this._isMounted) {
        this.setState({
          dataInitTableTec: this.state.dataInitTableTec.concat(res),
          stackTec: this.state.dataInitTableTec.concat(res),
          searchSaveTemp: this.state.searchSaveTemp.concat(res),
          loadingUserTecTable: false,
        })
      }
    } else {
      if (this._isMounted) {
        this.setState(
          { loadingUserTecTable: false },
          await this.fetchTecContacts('', 1, true)
        )
      }
    }
  }
  renderHtmlDataTabe = data => {
    if (data) {
      const renderRequest_atOrStatus = value => {
        const renderText = () => {
          if (value.request_at) {
            const dateTime = dateMonDayYearTime(value.request_at)
            return dateTime
          } else if (value.request_status) {
            return value.request_status
          } else {
            return 'Awaiting submit'
          }
        }
        return (
          <React.Fragment>
            {value.request_at ? (
              <Text
                style={{
                  color: '#4b4acb',
                  textTransform: 'none',
                }}
              >
                {renderText()}
              </Text>
            ) : (
              <Text
                style={{
                  textTransform: 'capitalize',
                  color: '#F68521',
                }}
              >
                {renderText()}
              </Text>
            )}
          </React.Fragment>
        )
      }
      // renderFullName
      const renderFullName = value => {
        const renderText = () => {
          return (
            <Text
              tootipValue={value.name}
              useTootipFor="date-fullname"
              useTootip={true}
            >
              {value.name}
            </Text>
          )
        }
        return <React.Fragment>{renderText()}</React.Fragment>
      }
      // renderEmail
      const renderEmail = value => {
        const renderText = () => {
          return (
            <Text
              tootipValue={value.email}
              useTootipFor="date-email"
              useTootip={true}
            >
              {value.email}
            </Text>
          )
        }
        return <React.Fragment>{renderText()}</React.Fragment>
      }
      // renderPhone
      const renderPhone = value => {
        const renderText = () => {
          return (
            <Text
              tootipValue={value.phone}
              useTootipFor="date-phone"
              useTootip={true}
            >
              {value.phone}
            </Text>
          )
        }
        return <React.Fragment>{renderText()}</React.Fragment>
      }
      // renderAction
      const removeTecUser = async (e, index) => {
        const { match } = this.props
        let { stackTec, dataInitTableTec } = this.state
        const { id, rfqid } = match.params

        dataInitTableTec.splice(index, 1)
        const dataResult = {
          rfq_id: rfqid ? rfqid : '',
          tec_request: [],
        }
        const data = {
          id: e.rfq_buyer_seal_id ? e.rfq_buyer_seal_id : '',
          buyer_id: e.id,
          is_request: false,
        }
        dataResult.tec_request.push(data)

        const res = await rfqController().createRequestUnseal(dataResult)
        if (res) {
          this.setState({
            dataInitTableTec,
            stackTec: [...dataInitTableTec],
          })
        }
      }
      return data.map((value, index) => {
        return (
          <React.Fragment key={index}>
            <Table.TR>
              <Table.TD className="requestunseal_date_init">
                {renderRequest_atOrStatus(value)}
              </Table.TD>
              <Table.TD className="requestunseal_fullname_body">
                {renderFullName(value)}
              </Table.TD>
              <Table.TD className="requestunseal_email_body">
                {renderEmail(value)}
              </Table.TD>
              <Table.TD className="requestunseal_phone_body">
                {renderPhone(value)}
              </Table.TD>
              <Table.TD className="requestunseal_action_init">
                {(value.request_status === 'Awaiting submit' ||
                  value.request_status === '') &&
                  value.request_at === '' && (
                    <Section
                      style={{
                        width: '25%',
                        display: 'flex',
                        justifyContent: 'center',
                      }}
                    >
                      <Button
                        className="link"
                        onClick={() => removeTecUser(value, index)}
                      >
                        <Image
                          className="delete-icon"
                          src={ICONS['icon-trash.svg']}
                          alt="Delete"
                          tootipValue={`Delete`}
                          useTootipFor="Delete"
                          useTootip={true}
                        />
                      </Button>
                    </Section>
                  )}
              </Table.TD>
            </Table.TR>
          </React.Fragment>
        )
      })
    }
  }
  renderNoteToBuyerSeal = (data = '', formData = '') => {
    const { seal_status_name } = formData
    const { term_status, response_status } = data
    if (
      (seal_status_name === sealStatus.sealed ||
        seal_status_name === sealStatus.awaitingunseal) &&
      response_status != 'Rejected'
    ) {
      return (
        <React.Fragment>
          <Image
            className="padlock-icon-center"
            src={ICONS['icon-padlock.svg']}
            alt="padlock icon"
          />
        </React.Fragment>
      )
    } else {
      return (
        <React.Fragment>
          {data.note_to_buyer ? (
            <Button
              className="theme-blue details-note"
              onClick={() => {
                this.toggleModal('note-to-buyer')
                if (this._isMounted) {
                  this.setState({
                    noteToBuyer: data,
                  })
                }
              }}
            >
              Detail
            </Button>
          ) : (
            '-'
          )}
        </React.Fragment>
      )
    }
  }
  renderRequestUnSealTable = formData => {
    const { checkRole, checkMultiRole, dataProject } = this.state
    const { created_by_id } = dataProject
    const buyerId = localStorage.getItem('buyerId')
    const purchaserMultiRole = find(checkMultiRole, data => {
      return data.id === rolesObj.purchaser
    })
    const createby = created_by_id ? created_by_id.toString() : ''
    const isCreate = buyerId === createby ? true : false
    const { rfq_status_id, seal_status_name, rfq_award_status } = formData
    /*
       purchaser กับ admin add tec ได้ กรณี Awaiting unseal
       หรือ purchaser กับ admin add tec ได้ กรณี sealed ด้วย
    */
    const renderUnseal = () => {
      if (
        (rfq_status_id === 4 &&
          seal_status_name === sealStatus.sealed &&
          rfq_award_status === 'Awaiting Selection') ||
        (rfq_status_id === 4 &&
          seal_status_name === sealStatus.sealed &&
          rfq_award_status === 'Awaiting Selection') ||
        (rfq_status_id === 4 &&
          seal_status_name === sealStatus.awaitingunseal &&
          rfq_award_status === 'Awaiting Selection') ||
        (rfq_status_id === 4 &&
          seal_status_name === sealStatus.awaitingunseal &&
          rfq_award_status === 'Awaiting Selection')
      ) {
        return (
          <React.Fragment>
            {this.renderRequestUnsealButton()}
            <Section className="table-wrapper">
              <Table className="sourcing">
                <Table.THEAD>
                  <Table.TR>
                    <Table.TH className="requestunseal_date_init">
                      Requested Date
                    </Table.TH>
                    <Table.TH className="requestunseal_fullname_init">
                      Full Name
                    </Table.TH>
                    <Table.TH className="requestunseal_email_init">
                      Email
                    </Table.TH>
                    <Table.TH className="requestunseal_phone_init">
                      Phone
                    </Table.TH>
                    <Table.TH className="requestunseal_action_init">
                      Action
                    </Table.TH>
                  </Table.TR>
                </Table.THEAD>
                <Table.TBODY>
                  {this.state.loadingUserTecTable ? (
                    <Spinner />
                  ) : (
                    this.renderHtmlDataTabe(this.state.dataInitTableTec)
                  )}
                </Table.TBODY>
              </Table>
            </Section>
          </React.Fragment>
        )
      }
    }
    if (
      checkRole === rolesObj.admin ||
      checkRole === rolesObj.systemadmin ||
      checkRole === rolesObj.purchaser
    ) {
      return renderUnseal()
    } else {
      if (purchaserMultiRole && isCreate) {
        return renderUnseal()
      }
    }
  }
  renderBidHistory = (data = '', formData = '') => {
    // console.log('data-->', data)
    return (
      <>
        <Button
          className="link is-transparent"
          onClick={() => {
            this.setState({
              itemBidHistory: [],
              itemBidClick: '',
              loadingBid: true,
            })
            this.getItemOfBidHistory(data)
            this.toggleModal('modals-history-of-supplier')
          }}
          disabled={
            data.response_status.includes('Rejected') ||
            data.response_status.includes('No response') ||
            !data.bid_history
          }
        >
          <Image
            className={`history-icon ${
              (data.response_status.includes('Rejected') ||
                data.response_status.includes('No response') ||
                !data.bid_history) &&
              'icon-disabled'
            }`}
            src={ICONS['icon-history.svg']}
            alt="history"
            tootipValue={`History`}
            useTootipFor="History"
            useTootip={true}
          />
        </Button>
      </>
    )
  }
  renderStatusSeal = (data = '', formData = '') => {
    const { seal_status_name } = formData
    const { term_status, response_status } = data
    if (
      (seal_status_name === sealStatus.sealed ||
        seal_status_name === sealStatus.awaitingunseal) &&
      response_status != 'Rejected'
    ) {
      return (
        <React.Fragment>
          <Image
            className="padlock-icon-center"
            src={ICONS['icon-padlock.svg']}
            alt="padlock icon"
          />
        </React.Fragment>
      )
    } else {
      return (
        <React.Fragment>
          {data.is_event_supplier_file ? (
            <Button
              className="theme-blue details-note"
              onClick={() => {
                this.onClickShowAttachment(data.id)
                this.toggleModal('attachment')
              }}
            >
              Detail
            </Button>
          ) : (
            '-'
          )}
        </React.Fragment>
      )
    }
  }
  selectAllSelectItem(obj) {
    return this.funcWrapData(obj)
  }
  async funcWrapData(
    dataObs = {
      dataCheckBox: {
        id: '',
        data: '',
        idSup: '',
      },
      selectItem: '',
      unCheckItem: '',
      allocateItem: '',
      noSelection: '',
    },
    selectAll
  ) {
    const hasDataCheckBox = ['dataCheckBox'].every(prop => prop in dataObs)
    const hasUnCheckItem = ['unCheckItem'].every(prop => prop in dataObs)
    const hasSelectItem = ['selectItem'].every(prop => prop in dataObs)
    const { dataCheckBox, selectItem, unCheckItem } = dataObs
    const { eventType, rfqid } = this.props.match.params
    const { setDataInit } = this.state
    const { selectedbyItem, allocated, selectedbySupplier } = selectionType
    if (hasDataCheckBox) {
      const { id, data, idSup } = dataCheckBox
      const filterDataCheckBox = filter(data, (value, index) => {
        if (index === 0) {
          return value
        }
      })
      const findIdSup = find(filterDataCheckBox[0][id], (value, index) => {
        if (value.idSup === idSup) return value
      })
      const resultSendApi = map(setDataInit, (value, index) => {
        const {
          id,
          rfq_id,
          auction_id,
          event_item_supplier,
          auction_item_supplier_response,
          req_amount,
        } = value
        const reqAmount = parseFloat(req_amount)
        let supplierResponse =
          event_item_supplier || auction_item_supplier_response
        const findSupId = find(supplierResponse, (value, index) => {
          let supplierId = value.event_supplier_id || value.auction_supplier_id
          if (supplierId === findIdSup.idSup) {
            return value
          }
        })
        return {
          id,
          ...(rfq_id && { rfq_id: rfq_id }),
          ...(auction_id && { auction_id: auction_id }),
          ...(findSupId.event_supplier_id && {
            event_item_supplier: [
              {
                event_supplier_id: findSupId.event_supplier_id,
                allocate_type: '',
                selected_amount: findIdSup.checked ? reqAmount : 0,
              },
            ],
          }),
          ...(findSupId.auction_supplier_id && {
            auction_item_supplier_response: [
              {
                auction_supplier_id: findSupId.auction_supplier_id,
                allocate_type: '',
                selected_amount: findIdSup.checked ? reqAmount : 0,
              },
            ],
          }),
          selected_type: findIdSup.checked ? selectedbySupplier : '',
        }
      })
      try {
        console.log('selection Supplier 1')
        let resApiSelection
        // Old เทสผ่านค่อยลบ
        // if (Number(eventType) === 1) {
        //   resApiSelection = await rfqController().selectionSupplier(
        //     resultSendApi
        //   )
        // }
        // if (Number(eventType) === 2) {
        //   resApiSelection = await auctionController().selectionSupplier(
        //     resultSendApi
        //   )
        // }
        // console.log('selectAll', selectAll)
        resApiSelection = await eventNewController().selectionSupplierAll(
          this.state.formData.event_id,
          selectAll
        )
        if (!isEmpty(resApiSelection)) {
          if (resApiSelection.data && resApiSelection.data.status === 'error') {
            toastFail('Select Supplier Error')
          } else {
            await this.getItemCompare(
              this.state.supplierList,
              this.state.event_id,
              this.state.activePage
            )
            this.funcGetSavingType()
            setTimeout(() => {
              this.getApprovalWorkflow(rfqid)
            }, 800)
          }
        }
      } catch (error) {
        console.log(error)
      }
    }
    const initMapSelectItem = res => {
      return map(res, (value, index) => {
        const { event_item_supplier, auction_item_supplier_response } = value
        const itemSupplierResponse =
          event_item_supplier || auction_item_supplier_response
        const rfqItemMap = map(itemSupplierResponse, (vRfq, kRfq) => {
          const action = () => {
            if (
              value.selected_type === selectedbyItem &&
              vRfq.selected_amount > 0
            ) {
              return 'checked'
            } else {
              return 'un_checked'
            }
          }
          if (
            value.selected_type === selectedbySupplier &&
            vRfq.selected_amount > 0
          ) {
            return {
              idItem: value.id,
              idSup: vRfq.event_supplier_id || vRfq.auction_supplier_id,
              action: action(),
            }
          } else if (
            value.selected_type === selectedbyItem &&
            vRfq.selected_amount > 0
          ) {
            return {
              idItem: value.id,
              idSup: vRfq.event_supplier_id || vRfq.auction_supplier_id,
              action: action(),
            }
          }
        })
        const filterArr = filter(rfqItemMap, value => !isUndefined(value))
        const [rfqSelect] = filterArr
        return { ...rfqSelect }
      })
    }
    if (hasSelectItem) {
      const findEmptySelectedAmount = map(setDataInit, (value, key) => {
        const { event_item_supplier, auction_item_supplier_response } = value
        const itemSupplierResponse =
          event_item_supplier || auction_item_supplier_response
        return map(itemSupplierResponse, (item, index) => {
          if (item.selected_amount <= 0 && value.selected_type === '') {
            return false
          }
        })
      })
      const [
        emptySelectedAmount1,
        emptySelectedAmount2,
      ] = findEmptySelectedAmount
      const checkEmpty1 = some(emptySelectedAmount1, item => item === false)
      const checkEmpty2 = some(emptySelectedAmount2, item => item === false)
      const checkEmptyFalse = some(this.state.quotationCheckBox, item => {
        const filterRfq = find(item[selectItem.idEvent], (value, index) => {
          if (selectItem.rfq_sup === value.idSup) return value
        })
        if (filterRfq) {
          if (filterRfq.checked === false) return true
        }
      })
      const funcMapArraySelect = () => {
        const mapArraySelectItem = map(setDataInit, (value, index) => {
          const reqAmount = parseFloat(value.req_amount)
          let findSup = ''
          const { event_item_supplier, auction_item_supplier_response } = value
          const itemSupplierResponse =
            event_item_supplier || auction_item_supplier_response
          if (value.id === selectItem.idEvent) {
            const findSupArr = map(
              itemSupplierResponse,
              (valueItem, valueIndex) => {
                const supplierId =
                  valueItem.event_supplier_id || valueItem.auction_supplier_id
                if (supplierId === selectItem.rfq_sup) {
                  return {
                    ...(valueItem.event_supplier_id && {
                      rfq_supplier_id: valueItem.event_supplier_id,
                      event_supplier_id: valueItem.event_supplier_id,
                    }),
                    ...(valueItem.auction_supplier_id && {
                      auction_supplier_id: valueItem.auction_supplier_id,
                    }),
                    allocate_type: '',
                    selected_amount: reqAmount,
                  }
                }
              }
            )
            findSup = filter(findSupArr, value => !isUndefined(value))
          } else {
            const findSupArr = map(
              itemSupplierResponse,
              (valueSup, valueRfqSupIndex) => {
                if (valueSup.selected_amount > 0) {
                  return {
                    ...(valueSup.event_supplier_id && {
                      rfq_supplier_id: valueSup.event_supplier_id,
                      event_supplier_id: valueSup.event_supplier_id,
                    }),
                    ...(valueSup.auction_supplier_id && {
                      auction_supplier_id: valueSup.auction_supplier_id,
                    }),
                    allocate_type: '',
                    selected_amount: reqAmount,
                  }
                }
              }
            )
            findSup = filter(findSupArr, value => !isUndefined(value))
          }
          return {
            id: value.id,
            ...(value.event_id && {
              rfq_id: this.state.idRFQ,
              event_id: value.event_id,
            }),
            ...(value.auction_id && { auction_id: value.auction_id }),
            ...(value.event_id && {
              rfq_item_supplier_response: findSup,
              event_item_supplier: findSup,
            }),
            ...(value.auction_id && {
              auction_item_supplier_response: findSup,
            }),
            selected_type: selectionType.selectedbyItem,
          }
        })
        return mapArraySelectItem
      }
      const funcMapArraySelectOne = () => {
        return map(setDataInit, (value, index) => {
          const { selected_type } = value
          const reqAmount = parseFloat(value.req_amount)
          if (value.id === selectItem.idEvent && selected_type !== allocated) {
            const {
              event_item_supplier,
              auction_item_supplier_response,
            } = value
            const itemSupplierResponse =
              event_item_supplier || auction_item_supplier_response
            const findSupArr = map(itemSupplierResponse, (value, index) => {
              const {
                event_supplier_id,
                auction_supplier_id,
                supplier_id,
              } = value
              const supplierID = event_supplier_id || auction_supplier_id
              if (supplierID === selectItem.rfq_sup) {
                return {
                  ...(event_supplier_id && {
                    event_supplier_id: event_supplier_id,
                    rfq_supplier_id: event_supplier_id,
                  }),
                  ...(auction_supplier_id && {
                    auction_supplier_id: auction_supplier_id,
                  }),
                  supplier_id: supplier_id,
                  // allocate_type: '',
                  // selected_amount: reqAmount,
                  selected_amount: 100,
                }
              }
            })
            const findSup = filter(findSupArr, value => !isUndefined(value))
            return {
              id: value.id,
              ...(value.event_id && {
                event_id: value.event_id,
                rfq_id: this.state.idRFQ,
              }),
              // ...(value.auction_id && { auction_id: value.auction_id }),
              // ...(value.event_id && {
              //   event_item_supplier: findSup,
              //   rfq_item_supplier_response: findSup,
              // }),
              // ...(value.auction_id && {
              //   auction_item_supplier_response: findSup,
              // }),
              suppliers: findSup,
              selected_type: selectionType.selectedbyItem,
              allocate_type: '',
            }
          }
        })
      }
      const checkLengthAllow = this.state.allowSupplierSelected
      const checkNoSelect = this.state.setNoItemSelect
      if (
        checkEmpty1 &&
        checkEmpty2 &&
        checkLengthAllow.length === 0 &&
        checkNoSelect.length === 0
      ) {
        const resSelect = funcMapArraySelectOne()
        const resFilter = filter(resSelect, value => !isUndefined(value))
        // console.log(resFilter)
        try {
          console.log('selection Supplier 2')
          // const resApiSelection = await rfqController().selectionSupplier(
          //   resFilter
          // )
          const resApiSelection = await eventNewController().selectionSupplier(
            this.state.event_id,
            resFilter[0]
          )
          if (resApiSelection) {
            if (
              resApiSelection.data &&
              resApiSelection.data.status === 'error'
            ) {
              toastFail('Select Item Error')
            } else {
              this.getItemCompare(
                this.state.supplierList,
                this.state.event_id,
                this.state.activePage
              )
              const selectOne = initMapSelectItem(resApiSelection)
              this.funcGetSavingType()
              this.funcGetSupplierSelected(resApiSelection)
              this.funcGetNoItemsSelect(resApiSelection)
              this.setQuotaSelected(resApiSelection)
              this.setTypeCheckBoxSelected(resApiSelection)

              this.setState({
                tempData: resFilter,
                itemAction: { selectedBySupplier: selectOne },
                setDataInit: resApiSelection,
              })
            }
          }
        } catch (error) {
          console.log(error)
        }
      } else if (
        (checkEmpty1 === false &&
          checkLengthAllow.length === 0 &&
          checkNoSelect.length === 0) ||
        (checkEmpty2 === false &&
          checkLengthAllow.length === 0 &&
          checkNoSelect.length === 0)
      ) {
        const funcSelectByItem = async () => {
          // const resSelect = funcMapArraySelect()
          const resSelect = funcMapArraySelectOne()
          const resFilter = filter(resSelect, value => !isUndefined(value))
          // const filterArrayNotEmpty = filter(resSelect, (value, index) => {
          //   console.log('value', value)
          //   if (
          //     value.rfq_item_supplier_response &&
          //     value.rfq_item_supplier_response.length !== 0
          //   ) {
          //     return true
          //   }
          //   if (
          //     value.auction_item_supplier_response &&
          //     value.auction_item_supplier_response.length !== 0
          //   ) {
          //     return true
          //   }
          // })
          try {
            console.log('selection Supplier 3')
            // console.log(resFilter)
            // const resApiSelection = await rfqController().selectionSupplier(
            //   filterArrayNotEmpty
            // )
            const resApiSelection = await eventNewController().selectionSupplier(
              this.state.event_id,
              resFilter[0]
            )
            if (resApiSelection) {
              this.funcGetSavingType()
              const selectOne = initMapSelectItem(resApiSelection)
              this.setState(
                {
                  // tempData: filterArrayNotEmpty,
                  itemAction: { selectedBySupplier: selectOne },
                  setDataInit: resApiSelection,
                },
                () => {
                  this.getItemCompare(
                    this.state.supplierList,
                    this.state.event_id,
                    this.state.activePage
                  )
                  // this.funcGetSupplierSelected(resApiSelection)
                  // this.funcGetNoItemsSelect(resApiSelection)
                  // this.setQuotaSelected(resApiSelection)
                  // this.setTypeCheckBoxSelected(resApiSelection)
                  // console.log('this.state.setDataInit', this.state.setDataInit)
                  // const mapSupSelectAll = map(
                  //   this.state.setDataInit,
                  //   (value, index) => {
                  //     const {
                  //       event_item_supplier,
                  //       auction_item_supplier_response,
                  //     } = value
                  //     const mapEvent = find(
                  //       event_item_supplier || auction_item_supplier_response,
                  //       (eventValue, eventIndex) => {
                  //         const supplierId =
                  //           eventValue.event_supplier_id ||
                  //           eventValue.auction_supplier_id
                  //         if (supplierId === selectItem.rfq_sup) {
                  //           return eventValue
                  //         }
                  //       }
                  //     )
                  //     return mapEvent
                  //   }
                  // )
                  // const mapSupSelectCount = map(
                  //   this.state.setDataInit,
                  //   (value, index) => {
                  //     const {
                  //       event_item_supplier,
                  //       auction_item_supplier_response,
                  //     } = value
                  //     const mapEvent = find(
                  //       event_item_supplier || auction_item_supplier_response,
                  //       (eventValue, eventIndex) => {
                  //         const { selected_amount } = eventValue
                  //         const supplierId =
                  //           eventValue.event_supplier_id ||
                  //           eventValue.auction_supplier_id
                  //         if (
                  //           supplierId === selectItem.rfq_sup &&
                  //           selected_amount > 0
                  //         ) {
                  //           return eventValue
                  //         }
                  //       }
                  //     )
                  //     return mapEvent
                  //   }
                  // )
                  // const selectAllFilter = filter(
                  //   mapSupSelectAll,
                  //   value => !isUndefined(value)
                  // )
                  // const selectAllFilterCount = filter(
                  //   mapSupSelectCount,
                  //   value => !isUndefined(value)
                  // )
                  // if (selectAllFilter.length === selectAllFilterCount.length) {
                  //   const supplierId =
                  //     selectAllFilter[0].event_supplier_id ||
                  //     selectAllFilter[0].auction_supplier_id
                  //   const funcChecked = value => {
                  //     if (supplierId === value.idSup) {
                  //       return !value.checked
                  //     } else if (value.checked === true) {
                  //       return false
                  //     } else {
                  //       return value.checked
                  //     }
                  //   }
                  //   const checkBox = map(
                  //     this.state.quotationCheckBox,
                  //     (value, index) => {
                  //       const dataId = this.state.setDataInit[index].id
                  //       const arrayMapCheckBox = map(
                  //         value[dataId],
                  //         (chakValue, key) => {
                  //           return {
                  //             ...chakValue,
                  //             checked: funcChecked(chakValue),
                  //           }
                  //         }
                  //       )
                  //       return {
                  //         [dataId]: arrayMapCheckBox,
                  //       }
                  //     }
                  //   )
                  //   const dataCheckBox = {
                  //     dataCheckBox: {
                  //       id: this.state.setDataInit[0].id,
                  //       data: checkBox,
                  //       idSup:
                  //         selectAllFilter[0].event_supplier_id ||
                  //         selectAllFilter[0].auction_supplier_id,
                  //     },
                  //   }
                  //   this.selectAllSelectItem(dataCheckBox)
                  // }
                }
              )
            }
          } catch (error) {
            console.log(error)
          }
        }
        return funcSelectByItem()
      } else if (checkLengthAllow.length !== 0 || checkNoSelect.length !== 0) {
        const { qty, percent } = allowcateType
        let { setDataInit, itemAction } = this.state
        const { idEvent, rfq_sup } = selectItem
        const filterDataAllow = filter(setDataInit, (value, index) => {
          if (
            value.selected_type !== allocated &&
            value.id === selectItem.idEvent
          )
            return value
        })
        // const mapData = map(filterDataAllow, (value, index) => {
        //   const {
        //     event_item_supplier,
        //     auction_item_supplier_response,
        //     req_amount,
        //     id,
        //     event_id,
        //     auction_id,
        //     selected_type,
        //   } = value
        //   const reqAmount = Number(req_amount)
        //   const itemSupplierResponse =
        //     event_item_supplier || auction_item_supplier_response
        //   const filterRfq = filter(itemSupplierResponse, (rfqV, rfqK) => {
        //     const { event_supplier_id, auction_supplier_id } = rfqV
        //     if ((event_supplier_id || auction_supplier_id) === rfq_sup)
        //       return value
        //   })
        //   const mapRfq = map(filterRfq, (mapRfqV, mapRfqK) => {
        //     const { event_supplier_id, auction_supplier_id } = mapRfqV
        //     return {
        //       allocate_type: '',
        //       ...(event_supplier_id && {
        //         event_supplier_id: event_supplier_id,
        //         rfq_supplier_id: event_supplier_id,
        //       }),
        //       ...(auction_supplier_id && {
        //         auction_supplier_id: auction_supplier_id,
        //       }),
        //       selected_amount: reqAmount,
        //     }
        //   })
        //   return {
        //     id,
        //     ...(event_id && { event_id: event_id, rfq_id: this.state.idRFQ }),
        //     ...(auction_id && { auction_id: auction_id }),
        //     ...(event_id && {
        //       event_item_supplier: mapRfq,
        //       rfq_item_supplier_response: mapRfq,
        //       suppliers: mapRfq,
        //     }),
        //     ...(auction_id && { auction_item_supplier_response: mapRfq }),
        //     selected_type: selected_type ? selected_type : selectedbyItem,
        //   }
        // })
        let mapRfq = []
        let idItem
        filterDataAllow.map((val, index) => {
          idItem = val.id
          val.event_item_supplier.filter((rfqV, rfqK) => {
            const {
              event_supplier_id,
              auction_supplier_id,
              supplier_id,
              selected_amount,
            } = rfqV
            if ((event_supplier_id || auction_supplier_id) === rfq_sup)
              mapRfq.push({ supplier_id, selected_amount: 100 })
          })
        })

        const mapData = {
          id: idItem,
          allocate_type: '',
          selected_type: selectedbyItem,
          suppliers: mapRfq,
        }
        try {
          console.log('selection Supplier 4 : ')
          // const res = await rfqController().selectionSupplier(mapData)
          const res = await eventNewController().selectionSupplier(
            this.state.event_id,
            mapData
          )
          if (res) {
            const selectOne = initMapSelectItem(res)
            this.funcGetSavingType()
            this.getItemCompare(
              this.state.supplierList,
              this.state.event_id,
              this.state.activePage
            )
            // this.setTypeCheckBoxSelected(res)
            this.funcGetSupplierSelected(res)
            if (this._isMounted) {
              this.setState({
                itemAction: { selectedBySupplier: selectOne },
                setDataInit: res,
              })
            }
          }
        } catch (error) {
          console.log(error)
        }
      }
    }
    if (hasUnCheckItem) {
      console.log('hasUnCheckItem', hasUnCheckItem)
      console.log('unCheckItem', unCheckItem)
      const { idEvent, idSup } = unCheckItem
      const funcMapArraySelect = () => {
        // const mapArraySelectItem = map(setDataInit, (value, index) => {
        //   const {
        //     selected_type,
        //     event_item_supplier,
        //     auction_item_supplier_response,
        //   } = value
        //   const itemSupplierResponse =
        //     event_item_supplier || auction_item_supplier_response
        //   const reqAmount = parseFloat(value.req_amount)
        //   let findSup = ''
        //   // if (value.id === idEvent && selected_type !== allocated) {
        //   //   console.log('check 1')
        //   //   const findSupArr = map(itemSupplierResponse, (val, ind) => {
        //   //     const { selected_type } = value
        //   //     const { event_supplier_id, auction_supplier_id } = val
        //   //     if (
        //   //       (event_supplier_id === idSup.event_supplier_id ||
        //   //         auction_supplier_id === idSup.auction_supplier_id) &&
        //   //       selected_type !== allocated
        //   //     ) {
        //   //       return {
        //   //         ...(event_supplier_id && {
        //   //           event_supplier_id: event_supplier_id,
        //   //           rfq_supplier_id: event_supplier_id,
        //   //         }),
        //   //         ...(auction_supplier_id && {
        //   //           auction_supplier_id: auction_supplier_id,
        //   //         }),
        //   //         allocate_type: '',
        //   //         selected_amount: 0,
        //   //       }
        //   //     }
        //   //   })
        //   //   findSup = filter(findSupArr, value => !isUndefined(value))
        //   // } else {
        //   //   console.log('check 2')
        //   //   const findSupArr = map(itemSupplierResponse, (valSup, ind) => {
        //   //     const { event_supplier_id, auction_supplier_id } = valSup
        //   //     const supplierId = event_supplier_id || auction_supplier_id
        //   //     if (valSup.selected_amount > 0 && selected_type !== allocated) {
        //   //       return {
        //   //         ...(event_supplier_id && {
        //   //           event_supplier_id: event_supplier_id,
        //   //           rfq_supplier_id: event_supplier_id,
        //   //         }),
        //   //         ...(auction_supplier_id && {
        //   //           auction_supplier_id: auction_supplier_id,
        //   //         }),
        //   //         allocate_type: '',
        //   //         selected_amount: reqAmount,
        //   //       }
        //   //     }
        //   //   })
        //   //   findSup = filter(findSupArr, value => !isUndefined(value))
        //   // }
        //   return {
        //     id: value.id,
        //     ...(value.event_id && {
        //       event_id: value.event_id,
        //       rfq_id: this.state.idRFQ,
        //     }),
        //     ...(value.auction_id && { auction_id: value.auction_id }),
        //     // ...(value.event_id && {
        //     //   event_item_supplier: findSup,
        //     //   rfq_item_supplier_response: findSup,
        //     // }),
        //     // ...(value.auction_id && {
        //     //   auction_item_supplier_response: findSup,
        //     // }),
        //     suppliers: [],
        //     selected_type: '',
        //     // value.id === idEvent ? '' : selectionType.selectedbyItem,
        //   }
        // })
        const mapArraySelectItem = {
          id: idEvent,
          // ...(value.event_id && {
          //   event_item_supplier: findSup,
          //   rfq_item_supplier_response: findSup,
          // }),
          // ...(value.auction_id && {
          //   auction_item_supplier_response: findSup,
          // }),
          suppliers: [],
          selected_type: '',
          allocate_type: '',
          // value.id === idEvent ? '' : selectionType.selectedbyItem,
        }
        return mapArraySelectItem
      }

      const funcSendApi = async () => {
        const resUnCheckItem = funcMapArraySelect()
        // console.log('resUnCheckItem', resUnCheckItem)
        // const resFilter = filter(resUnCheckItem, value => !isUndefined(value))
        // console.log('resFilter', resFilter)
        try {
          console.log('selection Supplier 5 : UnSelect item')
          // const resApiSelection = await rfqController().selectionSupplier(
          //   filterArrayNotEmpty
          // )
          const resApiSelection = await eventNewController().selectionSupplier(
            this.state.event_id,
            resUnCheckItem
          )
          if (resApiSelection) {
            this.getItemCompare(
              this.state.supplierList,
              this.state.event_id,
              this.state.activePage
            )
            this.funcGetSavingType()
            // const selectOne = initMapSelectItem(resApiSelection)
            // this.funcGetSupplierSelected(resApiSelection)
            // this.setQuotaSelected(resApiSelection)
            // this.setTypeCheckBoxSelected(resApiSelection)
            // this.funcGetNoItemsSelect(resApiSelection)
            // if (this._isMounted) {
            //   let { itemAction, setDataInit } = this.state
            //   setDataInit = resApiSelection
            //   itemAction = { selectedBySupplier: selectOne }
            //   this.setState({ setDataInit, itemAction })
            // }
          }
        } catch (error) {
          console.log(error)
        }
      }
      return funcSendApi()
    }
  }
  handlerChangeCheckBox = (e, subId, idHeaderSup, selectAll) => {
    const { quotationCheckBox, setDataInit } = this.state
    const funcChecked = value => {
      if (subId === value.idSup) {
        return !value.checked
      } else if (value.checked === true) {
        return false
      } else {
        return value.checked
      }
    }
    const checkBox = map(quotationCheckBox, (value, index) => {
      const dataId = setDataInit[index].id
      const arrayMapCheckBox = map(value[dataId], (chakValue, key) => {
        return {
          ...chakValue,
          checked: funcChecked(chakValue),
        }
      })
      return {
        [dataId]: arrayMapCheckBox,
      }
    })
    const dataCheckBox = {
      dataCheckBox: { id: idHeaderSup, data: checkBox, idSup: subId },
    }
    this.funcWrapData(dataCheckBox, selectAll)
    this.setState({ quotationCheckBox: checkBox })
  }
  renderElmSupNameTitle = (data, dataSup, idHeaderSup) => {
    const {
      quotationCheckBox,
      supplierList,
      awardStatuses,
      formData,
      rolesCheck,
    } = this.state
    const awaiting_approve = this.matchValue(
      awardStatuses,
      formData.rfq_award_status_id || formData.auction_award_status_id
    )
    const {
      event_supplier_id,
      auction_supplier_id,
      unit_price,
      response_status,
    } = dataSup
    const notlock = response_status
    const textNotLock = 'Rejected'
    const sealedCheck = formData.seal_status_name !== sealStatus.sealed
    const awaUnSealedCheck =
      formData.seal_status_name !== sealStatus.awaitingunseal
    const matchValueAwa = this.matchValue(
      awardStatuses,
      formData.rfq_award_status_id || formData.auction_award_status_id
    )
    const checkAwaSel = 'Awaiting Selection'
    const funcRenderLockItem = () => {
      return (
        <React.Fragment>
          <Image
            className="padlock-icon-company"
            src={ICONS['icon-padlock.svg']}
            alt="padlock icon"
          />
        </React.Fragment>
      )
    }
    const funcRenderCheckItem = () => {
      if (quotationCheckBox) {
        const { id } = formData
        const rejectedAll = 'Rejected'
        const checkBox = find(quotationCheckBox[0][idHeaderSup], data => {
          if (data.idSup === event_supplier_id) {
            return true
          }
          if (data.idSup === auction_supplier_id) {
            return true
          }
        })
        const findCheckBox = find(supplierList, data => {
          if (data.id === dataSup.event_supplier_id) {
            return true
          }
          if (data.id === dataSup.auction_supplier_id) {
            return true
          }
        })
        const hasResponseStatus = has(findCheckBox, 'response_status')
        let checkResponse =
          hasResponseStatus && findCheckBox.response_status === rejectedAll
        return (
          <React.Fragment>
            <Checkbox
              style={{ maxWidth: '25px' }}
              name="item_sup_check"
              id={event_supplier_id || auction_supplier_id}
              isDisable={
                this.state.eventListHaveApprove ||
                this.state.isHavingListEventOpen
                  ? this.state.eventListHaveApprove ||
                    this.state.isHavingListEventOpen
                  : checkResponse
              }
              checked={!checkResponse && (checkBox ? checkBox.checked : false)}
              onChange={e => {
                if (!checkResponse) {
                  const supplier_id = event_supplier_id || auction_supplier_id
                  const { supplierList } = this.state
                  let supplier
                  if (supplierList && supplierList.length > 0) {
                    supplier = supplierList.find(
                      item => item.id === supplier_id
                    )
                  }
                  let selectAll = {
                    supplier_id: supplier.supplier_id,
                    is_select: e.target.checked,
                  }
                  this.handlerChangeCheckBox(
                    e,
                    supplier_id,
                    idHeaderSup,
                    selectAll
                  )
                }
              }}
            />
          </React.Fragment>
        )
      }
    }
    // funcRenderCheckItemAwa | rles PURCHASER = Awaiting Approve
    const funcRenderCheckItemAwa = () => {
      if (quotationCheckBox) {
        const checkBox = find(quotationCheckBox[0][idHeaderSup], data => {
          if (data.idSup === event_supplier_id) {
            return true
          }
          if (data.idSup === auction_supplier_id) {
            return true
          }
        })
        if (checkBox.checked) {
          return (
            <React.Fragment>
              <Checkbox
                style={{ maxWidth: '25px' }}
                name="item_sup_check"
                id={event_supplier_id || auction_supplier_id}
                checked={checkBox.checked}
                onChange={() => {}}
                isDisable
              />
            </React.Fragment>
          )
        }
      }
    }
    if (
      data.seal_status_name === sealStatus.sealed ||
      data.seal_status_name === sealStatus.awaitingunseal
    ) {
      if (notlock !== textNotLock) {
        return funcRenderLockItem()
      }
    } else {
      // show selections not role TEC
      const showSelections = this.funcCheckSelectionsRole()
      if (
        this.state.allowSupplierSelected.length === 0 &&
        this.state.setNoItemSelect.length === 0
      ) {
        if (sealedCheck && awaUnSealedCheck && matchValueAwa === checkAwaSel) {
          if (
            rolesCheck.roles !== 'approver' &&
            unit_price !== '' &&
            !unit_price.includes('Reject') &&
            notlock !== textNotLock
          ) {
            if (showSelections) {
              return funcRenderCheckItem()
            }
          }
        } else if (awaiting_approve === 'Awaiting Approve' && showSelections) {
          return funcRenderCheckItemAwa()
        }
      }
    }
  }
  renderBudgetPriceSealed = (item, data) => {
    console.log('item.budget_price', item.budget_price)
    return (
      <React.Fragment>
        <Section className="item-list">
          Budget Price:{' '}
          {item.budget_price && Numeral(item.budget_price).format('0,0.0000')}{' '}
        </Section>
      </React.Fragment>
    )
  }
  renderHistoricalPriceSealed = (item, data) => {
    return (
      <React.Fragment>
        <Section className="item-list">
          Historical Price:{' '}
          {item.historical_price
            ? Numeral(item.historical_price).format('0,0.0000')
            : '-'}{' '}
        </Section>
      </React.Fragment>
    )
  }
  renderMarketPriceSealed = (item, data) => {
    return (
      <React.Fragment>
        <Section className="item-list">
          Market Price :{' '}
          {item.market_price
            ? Numeral(item.market_price).format('0,0.0000')
            : '-'}{' '}
        </Section>
      </React.Fragment>
    )
  }
  //x1x1
  fetchTecContacts = async (search, page, onClickSearch) => {
    const { match } = this.props
    const { id, rfqid } = match.params
    let {
      paginationTecContacts,
      tempTec,
      loadingUserTecContacts,
      stackTec,
      dataInitTableTec,
    } = this.state
    if (!loadingUserTecContacts) {
      this.setState({ loadingUserTecContacts: true })
      const params = {
        idRfq: rfqid ? rfqid : '',
        search: search,
        page: page,
      }
      const res = await rfqController().getRequestUserTec(params)
      if (res) {
        if (onClickSearch) {
          res.records.map((e, i) => {
            e.check = false
          })
          tempTec = [...res.records]
        } else {
          res.records.map((e, i) => {
            e.check = false
          })
          tempTec = [...tempTec, ...res.records]
        }

        paginationTecContacts.search = search ? search : ''
        paginationTecContacts.page = page ? page : res.page
        paginationTecContacts.next_page = res.next_page

        stackTec.map((e, i) => {
          const indexTEC = tempTec.findIndex(tec => e.id === tec.id)
          if (indexTEC !== -1) {
            tempTec[indexTEC].check = true
          }
        })
        this.setState({
          paginationTecContacts,
          tempTec,
          stackTec,
          loadingUserTecContacts: false,
        })
      }
    }
  }

  checkBoxAwaitingSubmit = async ({ id, is_request, data }) => {
    const { match } = this.props
    const { id: idRfq } = match.params
    const { userTecContacts } = this.state
    function getUniqueListBy(arr, key) {
      if (arr) {
        return [...new Map(arr.map(item => [item[key], item])).values()]
      }
    }
    function getUniqueListByNextpage(arr, key) {
      let newArr = []
      const tempArr = arr
      newArr = [...new Map(arr.map(item => [item[key], item])).values()]
      newArr.map(e => {
        tempArr.map(ex => {
          if (e.id === ex.id && ex.is_request) {
            e.is_request = true
          }
        })
      })
      return newArr
    }
    const funcMapTemp = () => {
      const dataTempMap = userTecContacts.map((value, index) => {
        if (id === value.id) {
          const data = { ...value }
          return data
        }
      })
      return dataTempMap
    }
    try {
      const saveTemp = funcMapTemp()
      const datatableFilter = saveTemp.filter(element => {
        return element !== undefined
      })
      const saveTempLast = getUniqueListBy(datatableFilter, 'id')
      this.state.searchSaveTemp.push(...saveTempLast)
    } catch (error) {
      console.log(error)
    }
    if (is_request) {
      this.state.savePositionPrev.push({ id, is_request })
      const checkTec = getUniqueListByNextpage(
        this.state.savePositionPrev,
        'id'
      )
      if (this._isMounted) {
        this.setState({ savePositionPrev: checkTec })
      }
    } else {
      let index = this.state.savePositionPrev.findIndex(x => x.id === id)
      this.state.savePositionPrev.splice(index, 1)
      const checkTec = getUniqueListByNextpage(
        this.state.savePositionPrev,
        'id'
      )
      if (this._isMounted) {
        this.setState({ savePositionPrev: checkTec })
      }
    }
    if (userTecContacts) {
      if (is_request) {
        const checkTecSing = getUniqueListBy(this.state.savePositionPrev, 'id')
        const checkTecSingBox = getUniqueListBy(
          this.state.userTecContacts,
          'id'
        )
        const data = checkTecSingBox.map((value, index) => {
          const result = checkTecSing.filter(
            (word, index) => word.id === value.id
          )
          const dataResult = {
            ...value,
            request_status:
              value.request_at === '' &&
              result.length >= 1 &&
              result[0].is_request === true &&
              result[0].id === value.id
                ? 'Awaiting submit'
                : '',
            is_request:
              result.length >= 1 && result[0].id === value.id
                ? result[0].is_request
                : false,
          }
          return dataResult
        })
        const checkTec = getUniqueListBy(data, 'id')
        const checkBoxMap = () => {
          let data = []
          if (this.state.searchSaveTemp) {
            this.state.searchSaveTemp.map((value, index) => {
              const dataValue = {
                ...value,
                is_request: value.id === id ? true : value.is_request,
                request_status:
                  value.id === id ? 'Awaiting submit' : value.request_status,
              }
              data.push(dataValue)
            })
          }
          return data
        }
        const dataMapCheck = checkBoxMap()
        const dataMapCheckUniq = getUniqueListBy(dataMapCheck, 'id')
        if (this._isMounted) {
          this.setState({
            userTecContacts: checkTec,
            searchSaveTemp: dataMapCheckUniq,
          })
        }
      } else {
        const checkTecSing = getUniqueListBy(this.state.savePositionPrev, 'id')
        const checkTecSingBox = getUniqueListBy(
          this.state.userTecContacts,
          'id'
        )
        const data = checkTecSingBox.map((value, index) => {
          const result = checkTecSing.filter(
            (word, index) => word.id === value.id
          )
          const dataResult = {
            ...value,
            request_status:
              value.request_at === '' &&
              result.length >= 1 &&
              result[0].is_request === true &&
              result[0].id === value.id
                ? value.request_status
                : result.length >= 1 &&
                  result[0].is_request === true &&
                  result.length >= 1 &&
                  result[0].id === value.id
                ? 'Awaiting submit'
                : '',
            is_request:
              result.length >= 1 && result[0].id === value.id
                ? result[0].is_request
                : false,
          }
          return dataResult
        })
        const checkTec = getUniqueListBy(data, 'id')
        const checkBoxMap = () => {
          let data = []
          if (this.state.searchSaveTemp) {
            this.state.searchSaveTemp.map((value, index) => {
              const dataValue = {
                ...value,
                is_request: value.id === id ? false : value.is_request,
                request_status: value.id === id ? '' : value.request_status,
              }
              data.push(dataValue)
            })
          }
          return data
        }
        const dataMapCheck = checkBoxMap()
        const dataMapCheckUniq = getUniqueListBy(dataMapCheck, 'id')
        if (this._isMounted) {
          this.setState(prevState => ({
            userTecContacts: checkTec,
            searchSaveTemp: dataMapCheckUniq,
          }))
        }
      }
    }
  }
  getMaster = {
    getCancelReason: async () => {
      const res = await rfqController().getCancelReason()
      if (res) {
        let option = []
        res.map(e => {
          const data = { value: e.id, label: e.name }
          option.push(data)
        })
        if (this._isMounted) {
          this.setState({ cancelReason: option })
        }
      } else {
        console.log('error', 'getCancelReason')
        toastFail('error')
      }
    },
    getReasonNoSelectionSourcingProject: async () => {
      const res = await rfqController().getReasonNoSelectionSourcingProject()
      if (res) {
        let option = []
        res.map(e => {
          if (e.id !== 1 && e.id !== 2 && e.id !== 0) {
            const data = { value: e.id, label: e.name }
            option.push(data)
          }
        })
        if (this._isMounted) {
          this.setState({ noSelectionReason: option })
        }
      } else {
        console.log('error', 'getReasonNoSelectionSourcingProject')
        toastFail('error')
      }
    },
    getUOM: async () => {
      const UOM = await rfqController().getUOM()
      if (UOM) {
        let option = []
        UOM.map(e => {
          const data = { value: e.id, label: e.name }
          option.push(data)
        })
        if (this._isMounted) {
          this.setState({ UOM: option })
        }
      } else {
        console.log('error', 'getUOM')
        toastFail('error')
      }
    },
  }

  getEventById = async id => {
    const { eventType } = this.props.match.params
    let { formData } = this.state
    try {
      let res
      if (Number(eventType) === 1) {
        res = await rfqController().getRFQById(id)
      }
      if (Number(eventType) === 2) {
        res = await auctionController().getAuctionById(id)
      }
      if (res) {
        formData = res
        if (formData.estimate_budget) {
          formData.estimate_budget = toFixedSpecial(
            parseFloat(res.estimate_budget),
            4
          )
        }
        const targetDateIso = moment(
          res.target_date,
          'YYYY/MM/DD HH:mm:ss'
        ).toDate()
        // .utc(res.target_date)
        // .toDate()
        const startDateIso = moment(
          res.start_date,
          'YYYY/MM/DD HH:mm:ss'
        ).toDate()
        // .utc(res.start_date)
        // .toDate()
        const endDateIso = moment(res.end_date, 'YYYY/MM/DD HH:mm:ss').toDate()
        // .utc(res.end_date)
        // .toDate()
        console.log({ startDateIso, endDateIso })
        formData.target_date = res.target_date ? targetDateIso : null
        formData.start_date = res.start_date ? startDateIso : null
        formData.end_date = res.end_date ? endDateIso : null
        formData.bidding_type = res.bidding_type
        formData.event_id = res.event_id
        if (this._isMounted) {
          this.setState(
            {
              statusRFQ: res.rfq_status_id || res.auction_status_id,
              statusAuction: res.auction_status_id,
              formData,
              event_id: res.event_id,
            },
            await this.getProductById(res.id, res.event_id),
            await this.getSupplierListCompare(res.event_id) // ย้ายจากเรียกใน DidMount มาที่นี้ เพราะต้องใช้ event_id
          )
        }
      } else {
        console.log('error', 'getEventById')
        toastFail('error')
      }
    } catch (error) {
      console.log(error)
      setTimeout(() => {
        toast.dismiss()
        this.props.history.push(ROUTE_PATH.HOME.LINK)
      }, 800)
    }
  }

  getProductById = async (id, eventId) => {
    const { eventType } = this.props.match.params
    let { products } = this.state
    let params = {
      page: 1,
      limit: 1000,
    }
    let res = await eventNewController().getEventItemById(eventId, params)

    if (res && res.records && res.records.length > 0) {
      products.items = res.records
      if (this._isMounted) {
        this.setState({ products }, await this.getSupplierById(id, eventId))
      }
    } else {
      console.log('error', 'getProductById')
      toastFail('error')
    }
  }

  getSupplierById = async (id, eventId) => {
    const { eventType } = this.props.match.params
    let { selectSuppliersRfq, stackSelectSuppliersRfq } = this.state
    let res = await eventNewController().getEventSupplierById(eventId)
    if (res) {
      selectSuppliersRfq = []
      const supplierNameTableItem = map(res, (value, key) => {
        const { id, company_name } = value
        return {
          id,
          company_name,
        }
      })
      res.map((e, i) => {
        const selectSupplier = {}
        selectSupplier.Branch = e.branch
        selectSupplier.CompanyName = e.company_name
        selectSupplier.ContactEmail = e.email
        selectSupplier.ContactName = e.name
        selectSupplier.ContactPhone = e.phone
        selectSupplier.VendorCode = e.vendor_code
        selectSupplier.StatusContact = 1
        selectSupplier.StatusSupplier = 1
        selectSupplier.SupplierID = e.supplier_id
        selectSupplier.TaxID = e.tax_id
        selectSupplier.checked = true
        selectSupplier.disabled = false
        selectSupplier.response_status = e.response_status
        selectSuppliersRfq.push(selectSupplier)
      })
      stackSelectSuppliersRfq = [...selectSuppliersRfq]
      await this.getInternalFileById(eventId)
      await this.getExternalFileById(eventId)
      if (this._isMounted) {
        this.setState({
          selectSuppliersRfq,
          stackSelectSuppliersRfq,
          supplierNameTableItem,
        })
      }
    } else {
      console.log('error', 'getSupplierById')
      toastFail('error')
    }
  }

  getInternalFileById = async id => {
    const { eventType } = this.props.match.params
    let { internalFile } = this.state
    let res = await eventNewController().getInternalFileById(id)

    if (res) {
      internalFile = res
      if (this._isMounted) {
        this.setState({ isEdit: true, internalFile })
      }
    } else {
      console.log('error', 'getInternalFileById')
      toastFail('error')
    }
  }

  getExternalFileById = async id => {
    const { eventType } = this.props.match.params
    let { externalFile } = this.state
    try {
      let res = await eventNewController().getExternalFileById(id)

      if (res.length !== 0) {
        externalFile = res
        this.setState({ isEdit: true, externalFile })
      }
    } catch (error) {
      console.log('error', 'getExternalFileById')
      toastFail('error')
    }
  }
  clearSelectedItem(res = '') {
    if (res) {
      const initMapSelectItem = map(res, (value, index) => {
        const rfqItemMap = map(value.event_item_supplier, (vRfq, kRfq) => {
          const action = () => {
            if (
              value.selected_type === selectionType.selectedbySupplier &&
              vRfq.selected_amount > 0
            ) {
              return 'checked'
            } else if (
              value.selected_type === selectionType.selectedbyItem &&
              vRfq.selected_amount > 0
            ) {
              return 'checked'
            } else {
              return 'un_checked'
            }
          }
          if (
            value.selected_type === selectionType.selectedbySupplier &&
            vRfq.selected_amount > 0
          ) {
            return {
              idItem: value.id,
              idSup: vRfq.event_supplier_id || vRfq.auction_supplier_id,
              action: action(),
            }
          } else if (
            value.selected_type === selectionType.selectedbyItem &&
            vRfq.selected_amount > 0
          ) {
            return {
              idItem: value.id,
              idSup: vRfq.event_supplier_id || vRfq.auction_supplier_id,
              action: action(),
            }
          }
        })
        const filterArr = filter(rfqItemMap, value => !isUndefined(value))
        const [rfqSelect] = filterArr
        return { ...rfqSelect }
      })
      return initMapSelectItem
    }
  }
  clearSelectBox(res = '') {
    const { selectedbySupplier: selectedSup } = selectionType
    if (res) {
      const arrayCheckBoxItemSup = map(res, (value, index) => {
        const { selected_type, id } = value
        let itemSupplierResponse =
          value.event_item_supplier || value.auction_item_supplier_response
        const arrayItemSupplier = map(
          itemSupplierResponse,
          (item, keyRfqItem) => {
            const { selected_amount } = item
            return {
              idSup: item.event_supplier_id || item.auction_supplier_id,
              checked: selected_type === selectedSup && selected_amount > 0,
              selectItem: false,
            }
          }
        )
        return {
          [`${id}`]: arrayItemSupplier,
        }
      })
      return arrayCheckBoxItemSup
    }
  }
  getItemCompare = async (supplierList, event_id, activePage = '') => {
    // console.log('getItemCompare')
    const { eventType, rfqid } = this.props.match.params
    let supplier = ''
    supplierList.map(e => {
      if (e.checked) {
        supplier = supplier + e.supplier_id + ','
      }
    })
    if (supplier.length > 0) {
      supplier = supplier.substring(0, supplier.length - 1)
    }
    let paginate = {
      page: activePage ? activePage : this.state.activePage,
      limit: this.state.limit,
      supplier_id: supplier,
    }
    let res
    res = await eventNewController().getBuyerItemCompare(event_id, paginate)
    // if (Number(eventType) === 1) {
    //   res = await rfqController().getBuyerCompare(rfqid, supplier)
    // }
    // if (Number(eventType) === 2) {
    //   res = await auctionController().getBuyerCompare(rfqid, supplier)
    // }
    if (res) {
      this.setTypeCheckBoxSelected(res.records)
      const quotationList = res.records.map(sup => {
        return { ...sup, checked: true }
      })
      this.setState({
        total_record: res.total_record,
        offset: res.offset,
      })
      // this.setTotalPriceSupplier(supplierList, res.records)
      this.funcGetSupplierSelected(res.records)
      this.setQuotaSelected(res.records)
      this.funcGetNoItemsSelect(res.records)
      const resTempData = map(quotationList, (value, index) => {
        const { id, event_id, selected_type, event_item_supplier } = value
        const { auction_id, auction_item_supplier_response } = value
        const itemSupplierResponse =
          event_item_supplier || auction_item_supplier_response
        let arrayItemSupplier = []
        let filterArrayItemSupplier = []
        arrayItemSupplier = map(itemSupplierResponse, (item, index) => {
          const { event_id, auction_id, selected_amount, allocate_type } = item
          return {
            ...(event_id && { rfq_id: event_id, auction_id: event_id }),
            // ...(event_id && { auction_id: event_id }),
            allocate_type,
            selected_amount,
          }
        })
        filterArrayItemSupplier = filter(
          arrayItemSupplier,
          value => !isUndefined(value)
        )
        return {
          id,
          ...(event_id && { rfq_id: event_id }),
          ...(auction_id && { auction_id: auction_id }),
          selected_type,
          ...(event_item_supplier && {
            event_item_supplier: event_item_supplier,
          }),
          ...(auction_item_supplier_response && {
            auction_item_supplier_response: auction_item_supplier_response,
          }),
        }
      })
      // console.log('quotationList', quotationList)
      // HERE => เส้น Compare selected_type ไม่มีค่า
      const arrayCheckBoxItemSup = map(quotationList, (value, index) => {
        const { selected_type, id } = value
        const arrayItemSupplier = map(
          value.event_item_supplier || value.auction_item_supplier_response,
          (item, key) => {
            const { selected_amount } = item
            return {
              idSup: item.event_supplier_id || item.auction_supplier_id,
              checked:
                selected_type === 'Selected by Supplier' && selected_amount > 0,
              selectItem: false,
            }
          }
        )
        return {
          [`${id}`]: arrayItemSupplier,
        }
      })
      const initMapSelectItem = map(quotationList, (value, index) => {
        const itemMap = map(
          value.event_item_supplier || value.auction_item_supplier_response,
          (item, i) => {
            const action = () => {
              if (
                value.selected_type === selectionType.selectedbySupplier &&
                item.selected_amount > 0
              ) {
                return 'checked'
              } else if (
                value.selected_type === selectionType.selectedbyItem &&
                item.selected_amount > 0
              ) {
                return 'checked'
              } else {
                return 'un_checked'
              }
            }
            if (
              value.selected_type === selectionType.selectedbySupplier &&
              item.selected_amount > 0
            ) {
              return {
                idItem: value.id,
                ...(item.event_supplier_id && {
                  idSup: item.event_supplier_id,
                }),
                ...(item.auction_supplier_id && {
                  idSup: item.auction_supplier_id,
                }),
                action: action(),
              }
            } else if (
              value.selected_type === selectionType.selectedbyItem &&
              item.selected_amount > 0
            ) {
              return {
                idItem: value.id,
                ...(item.event_supplier_id && {
                  idSup: item.event_supplier_id,
                }),
                ...(item.auction_supplier_id && {
                  idSup: item.auction_supplier_id,
                }),
                action: action(),
              }
            }
          }
        )
        const filterArr = filter(itemMap, value => !isUndefined(value))
        const [rfqSelect] = filterArr
        return { ...rfqSelect }
      })
      if (this._isMounted) {
        this.setState(
          {
            quotationList,
            quotationCheckBox: arrayCheckBoxItemSup,
            setDataInit: res.records,
            itemAction: { selectedBySupplier: initMapSelectItem },
            tempData: resTempData,
          },
          this.forceUpdate()
        )
      }
    } else {
      console.log('error', 'getItemCompare')
      if (Number(eventType) === 1) {
        toastFail('error')
      }
    }
  }

  setTypeCheckBoxSelected(res = '') {
    let { resultCheckBoxSelected } = this.state
    const { qty, percent } = allowcateType
    const { allocated } = selectionType
    if (res) {
      let checkType = ''
      const checkBoxSelected = map(res, (itemValue, itemKey) => {
        const {
          event_item_supplier,
          auction_item_supplier_response,
          id,
          selected_type,
        } = itemValue
        const item = event_item_supplier || auction_item_supplier_response
        const mapSup = map(item, (value, index) => {
          const {
            // allocate_type,
            allocate_type,
            event_supplier_id,
            auction_supplier_id,
          } = value
          const supplierId = event_supplier_id || auction_supplier_id
          let checkedType = null
          if (allocate_type === qty) {
            checkedType = true
          } else if (allocate_type === percent) {
            checkedType = false
          }
          return {
            idSup: supplierId,
            check: checkedType,
          }
        })
        const checkboxQty = some(mapSup, ['check', true])
        const checkboxPercent = some(mapSup, ['check', false])
        if (checkboxQty) {
          checkType = qty
        }
        if (checkboxPercent) {
          checkType = percent
        }
        return {
          idItem: id,
          check: selected_type !== allocated ? true : checkboxQty,
          checkType: selected_type !== allocated ? qty : checkType,
        }
      })
      resultCheckBoxSelected = checkBoxSelected
      if (this._isMounted) {
        this.setState({ resultCheckBoxSelected })
      }
    }
  }
  setQuotaSelected(res = '') {
    let { quotaSelected } = this.state
    const { qty, percent } = allowcateType
    const { allocated } = selectionType
    if (res) {
      let checkType = qty
      const filterRes = filter(res, (value, index) => {
        if (value.selected_type === allocated) return value
      })
      quotaSelected = map(res, (itemValue, itemKey) => {
        const {
          event_item_supplier: event_item_supplier,
          auction_item_supplier_response: auction_supplier_response,
          id,
          event_id,
          auction_id,
        } = itemValue
        const supplier_response =
          event_item_supplier || auction_supplier_response
        const itemSupplierResponse = map(
          supplier_response,
          (rfqValue, rfqIndex) => {
            const {
              allocate_type,
              event_supplier_id,
              auction_supplier_id,
              selected_amount,
              supplier_id,
            } = rfqValue
            if (allocate_type === qty) {
              checkType = qty
            } else if (allocate_type === percent) {
              checkType = percent
            }
            let supplierId = event_supplier_id || auction_supplier_id
            return {
              allocate_type: checkType,
              supplier_id: supplier_id,
              ...(event_supplier_id && {
                event_supplier_id: event_supplier_id,
              }),
              ...(auction_supplier_id && {
                auction_supplier_id: auction_supplier_id,
              }),
              selected_amount,
            }
          }
        )
        return {
          id,
          ...(event_id && { rfq_id: event_id }),
          ...(auction_id && { auction_id: auction_id }),
          ...(event_id && {
            event_item_supplier: itemSupplierResponse,
          }),
          ...(auction_id && {
            auction_item_supplier_response: itemSupplierResponse,
          }),
          selected_type: allocated,
        }
      })
      if (this._isMounted) {
        // console.log('quotaSelected', quotaSelected)
        this.setState({ quotaSelected })
      }
    }
  }
  getSupplierListCompare = async eventId => {
    let res = await eventNewController().getEventSupplierById(eventId)
    if (res) {
      const supplierList = res.map(sup => {
        return { ...sup, checked: true }
      })
      if (this._isMounted) {
        this.setState(
          { supplierList },
          await this.getItemCompare(supplierList, eventId)
        )
      }
    } else {
      console.log('error getSupplierListCompare')
      toastFail('error')
    }
  }

  onClickShowAttachment = async id => {
    const res = await rfqController().getAttachmentFile(id)
    if (res) {
      if (this._isMounted) {
        this.setState({ getSupplierEventFile: res })
      }
    } else {
      console.log('error', 'onClickShowAttachment')
      toastFail('error')
    }
  }

  validateSchedule() {
    const { newScheduleDate, formData, statusRFQ } = this.state
    let { isErrMsgEndDate, isErrMsgStartDate } = this.state
    let isPass = true
    isErrMsgEndDate = ''
    isErrMsgStartDate = ''
    const funcToastEventTimeOut = message => {
      const funcMessage = () => {
        if (message) {
          return message
        } else {
          return 'Awaiting Event Status Update'
        }
      }
      const textToast = funcMessage()
      return toast(textToast, {
        onClose: () => {
          window.location.reload()
        },
        toastId: textToast,
        position: 'top-center',
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        type: 'error',
      })
    }
    if (
      typeof newScheduleDate.end_date === 'undefined' ||
      newScheduleDate.end_date === null
    ) {
      isErrMsgEndDate = 'End date must required field'
      isPass = false
    }
    if (
      typeof newScheduleDate.start_date === 'undefined' ||
      newScheduleDate.start_date === null
    ) {
      isErrMsgStartDate = 'Start date must required field'
      isPass = false
    }
    if (formData.end_date < Date.now() && statusRFQ !== 4) {
      try {
        funcToastEventTimeOut()
        isPass = false
      } catch (error) {
        console.log(error)
      }
    }
    if (
      newScheduleDate.end_date &&
      newScheduleDate.start_date &&
      newScheduleDate.end_date <= newScheduleDate.start_date
    ) {
      isErrMsgEndDate = 'End date must be after Start date'
      isPass = false
    }

    if (
      statusRFQ !== 3 &&
      statusRFQ !== 4 &&
      newScheduleDate.start_date &&
      newScheduleDate.start_date <= Date.now()
    ) {
      isErrMsgStartDate = 'Start date must be after current time'
      isPass = false
    }
    if (newScheduleDate.end_date && newScheduleDate.end_date <= Date.now()) {
      isErrMsgEndDate = 'End date must be after current time'
      isPass = false
    }
    if (this._isMounted) {
      this.setState({
        isErrMsgEndDate,
        isErrMsgStartDate,
      })
    }
    return isPass
  }

  onSaveSchedule = async () => {
    const {
      formData,
      newScheduleDate,
      statusRFQ,
      supplierList,
      event_id,
    } = this.state
    const { rfqid } = this.props.match.params || {}
    const rfqApi = rfqController()
    const isReOpen = statusRFQ == 4

    if (this.validateSchedule() && !this.state.isLoading) {
      this.setState({ isLoading: true })

      const params = {
        event_id,
        start_date: statusRFQ == 2 ? newScheduleDate.start_date : undefined,
        end_date: newScheduleDate.end_date,
      }
      // console.log({ params, statusRFQ, newScheduleDate })

      const api = isReOpen ? rfqApi.reOpenRFQ : rfqApi.reScheduleRFQ
      const res = await api(params)
      if (res === '52005: this event is not last round') {
        toastFail('This event is not last round')
        this.setState({ isLoading: false })
      } else if (res) {
        await this.getItemCompare(supplierList, this.state.event_id)
        if (isReOpen) {
          toastActive('Reopen event is success')
        } else {
          toastActive('Reschedule event is success')
        }
        this.toggleModal()
        this.getEventById(formData.id)
        this.getApprovalWorkflow(rfqid)
        this.funcGetSavingType()
        this.funcGetApprovalHistory(rfqid)
        // กัน กด เบิ้ล
        setTimeout(() => {
          this.setState({ isLoading: false })
        }, 5000)
      } else {
        setTimeout(() => {
          this.setState({ isLoading: false })
        }, 5000)
        console.log('error', 'onSaveSchedule')
        toastFail('error')
      }
    }
  }

  validateCancelRFQ() {
    const { cancelReasonText, cancelReasonValue } = this.state
    let { isErrMsgReasonText, isErrMsgReasonValue } = this.state
    let isPass = true
    if (!cancelReasonValue) {
      isErrMsgReasonValue = STRING.INVALID
      isPass = false
    } else if (cancelReasonValue.value === 5 && !cancelReasonText) {
      isErrMsgReasonText = STRING.INVALID
      isPass = false
    }
    if (this._isMounted) {
      this.setState({
        isErrMsgReasonValue,
        isErrMsgReasonText,
      })
    }
    return isPass
  }

  OnCancelEvent = async () => {
    const { formData, cancelReasonText, cancelReasonValue } = this.state
    if (this.validateCancelRFQ()) {
      const params = {
        cancel_reason:
          cancelReasonValue.value === 5
            ? cancelReasonText
            : cancelReasonValue.label,
      }
      let res = await eventNewController().cancelEvent(formData.id, params)
      if (res) {
        toastActive('Cancel event is success')
        this.toggleModal()
        this.getEventById(formData.id)
      } else {
        console.log('error', 'OnCancelEvent')
        toastFail('error')
      }
    }
  }

  downloadExternal = parmas => {
    const { eventType } = this.props.match.params
    return eventNewController()
      .downloadExternal(parmas.id)
      .then(res => {
        this.deleteLoadingDownloadFile({ id: parmas.id })
        FileDownload(res.data, parmas.name)
      })
  }

  downloadInternalApprovalNote = parmas => {
    const { id, file_name } = parmas
    return rfqController()
      .downloadApprovalFile(id)
      .then(res => {
        this.deleteLoadingDownloadFile(parmas)
        if (res.data) {
          FileDownload(res.data, file_name)
        }
      })
  }

  downloadInternal = parmas => {
    const { eventType } = this.props.match.params

    eventNewController()
      .downloadInternal(parmas.id)
      .then(res => {
        this.deleteLoadingDownloadFile({ id: parmas.id })
        // return res
        FileDownload(res.data, parmas.name)
      })
  }

  downloadSupplierEventFile = parmas => {
    return rfqController()
      .downloadSupplierEventFile(parmas.id)
      .then(res => {
        setTimeout(() => {
          FileDownload(res.data, parmas.name)
        }, 500)
      })
  }

  downloadItem = parmas => {
    const { eventType } = this.props.match.params
    return eventNewController()
      .downloadEventItemFile(parmas.id)
      .then(res => {
        this.deleteLoadingDownloadFile({ id: parmas.id })
        FileDownload(res.data, parmas.name)
      })
  }

  downloadItemSupplier = parmas => {
    return mySupplierCompanyController()
      .downloadSupplierFileItem(parmas.id)
      .then(res => FileDownload(res.data, parmas.name))
  }

  downloadCompareToExcel = info => {
    const { eventType } = this.props.match.params
    const { checkAward } = this.state
    if (Number(eventType) === 1) {
      return rfqController()
        .downloadCompareToExcel(info.id, checkAward.submitaward)
        .then(res =>
          FileDownload(
            res.data,
            (info.name ? info.name : info.event_no) + '.xlsx'
          )
        )
    }
    if (Number(eventType) === 2) {
      return auctionController()
        .downloadCompareToExcel(info.id, checkAward.submitaward)
        .then(res => {
          // console.log('download', res)
          FileDownload(
            res.data,
            (info.name ? info.name : info.event_no) + '.xlsx'
          )
        })
    }
  }

  setLoadingDownloadFile = file => {
    this.state.loadingDownloadFile.push({ id: file.id })
    this.setState({
      loadingDownloadFile: this.state.loadingDownloadFile,
    })
  }

  deleteLoadingDownloadFile = file => {
    let index = this.state.loadingDownloadFile.findIndex(x => x.id === file.id)
    this.state.loadingDownloadFile.splice(index, 1)
    this.setState({
      loadingDownloadFile: this.state.loadingDownloadFile,
    })
  }

  renderDownloadFile = file => {
    return (
      this.state.loadingDownloadFile &&
      this.state.loadingDownloadFile.map((value, index) => {
        if (value.id === file.id) {
          return (
            <Loaders
              load={true}
              key={index}
              // style={{
              //   marginLeft: '-35px',
              //   position: 'relative',
              //   right: '-75px',
              // }}
            />
          )
        }
      })
    )
  }

  matchValueSelected = (option, selectedId) => {
    if (option) {
      return option.find(
        value => value.value.toString() === selectedId.toString()
      )
    }
  }

  onChangeCheckAll = async () => {
    let { supplierList, checkAllSupplier } = this.state

    if (checkAllSupplier) {
      supplierList.map(e => {
        e.checked = false
      })
    } else {
      supplierList.map(e => {
        e.checked = true
      })
    }
    if (this._isMounted) {
      this.setState(
        { supplierList, checkAllSupplier: !checkAllSupplier },
        await this.getItemCompare(supplierList, this.state.event_id)
      )
    }
  }

  onChangeCheckboxSupplier = async index => {
    let { supplierList } = this.state
    let isAll = true
    supplierList[index].checked = !supplierList[index].checked
    supplierList.map(e => {
      if (!e.checked) {
        return (isAll = false)
      }
    })
    if (this._isMounted) {
      this.setState(
        { supplierList, checkAllSupplier: isAll },
        await this.getItemCompare(supplierList, this.state.event_id)
      )
    }
  }

  onClickSaving = index => {
    this.setState({ isLoading: true })
    const { quotationList } = this.state
    quotationList[index].checked = !quotationList[index].checked
    if (this._isMounted) {
      this.setState({
        quotationList,
        isLoading: false,
      })
    }
  }

  toggleModal = id => {
    if (this._isMounted) {
      return this.setState(prevState => ({
        ...prevState,
        modals: prevState.modals.map(modal => ({
          ...modal,
          isOpen: modal.name === id ? !modal.isOpen : false,
        })),
      }))
    }
  }

  onChangeExchangeRate = async () => {
    const { match } = this.props
    const { params } = match
    const { rfqid, eventType } = params
    const obj = {
      rate: this.state.exchangeRate,
    }
    let res = await eventNewController().updateExchangeRate(
      obj,
      this.state.formData.id
    )
    if (res == 'Update exchange rate successfully') {
      this.getEventById(this.state.formData.id)
      this.getSupplierListCompare(this.state.formData.event_id)
      this.getApprovalWorkflow(rfqid)
      this.funcGetSavingType()
      this.toggleModal()
      toastActive(res)
    } else {
      toastFail('Update exchange rate fail')
    }
  }

  nextStep() {
    if (this._isMounted) {
      this.setState({
        activeStep: this.state.activeStep + 1,
      })
    }
  }

  renderModalContactInfo(name, email, phone) {
    this.setState(
      {
        contactInformation: {
          name: name,
          email: email,
          phone: phone,
        },
      },
      this.toggleModal('modals-approval-contact')
    )
  }

  previousStep() {
    if (this.state.activeStep > 0) {
      if (this._isMounted) {
        this.setState({
          activeStep: this.state.activeStep - 1,
        })
      }
    }
  }

  step1Content() {
    const { formData, internalFile, statusRFQ, externalFile } = this.state
    const getRoleTec = () => {
      const getRoleLocal = localStorage.getItem('roleUser')
      const getRoleLocalMulti = localStorage.getItem('roleUserMulti')
      let hideRoleTec = null
      let hideRoleTecMulti = null
      if (getRoleLocal) {
        hideRoleTec = parseInt(getRoleLocal, 10)
      } else {
        const dataRoleMulti = JSON.parse(getRoleLocalMulti)
        const idRoleTec = 10
        const someArrayCheckRole = element => {
          return element.id !== idRoleTec
        }
        hideRoleTecMulti = dataRoleMulti
          ? dataRoleMulti.some(someArrayCheckRole)
          : null
      }
      const resultRole = {
        hideRoleTec,
        hideRoleTecMulti,
      }
      return resultRole
    }
    const hideTecRole = getRoleTec()
    const { dataProject } = this.state
    const projectStatus = dataProject
      ? funcCheckStatusProject(dataProject.project_status_id)
      : ''

    const downloadInternalProjectFile = async params => {
      console.log(params)
      const { id, file_name } = params
      return rfqController()
        .downloadFileSourcingProject(params.id)
        .then(res => {
          this.deleteLoadingDownloadFile({ id: id })
          FileDownload(res.data, file_name)
        })
    }
    const renderInternalFileProject = () => {
      const { internalFileProject } = this.state
      if (internalFileProject.length > 0) {
        return (
          <Section className="form-group-control">
            <AttachedFile
              // key={i}
              id={'attached-internal-file'}
              isIcon={true}
              isUpload={false}
              onDownload={e => {
                this.setLoadingDownloadFile(e)
                downloadInternalProjectFile(e)
              }}
              fileList={internalFileProject}
              loadingDownload={this.state.loadingDownloadFile}
              className="attached-internal-file"
            />
          </Section>
        )
      } else {
        return '-'
      }
    }
    return (
      <React.Fragment>
        <Section className="form-wrapper">
          <Section className="form-group-title">Project Information</Section>

          <Section className="form-row">
            <Section className="form-col col-6">
              <Section className="form-group">
                <label>Project No.</label>
                <Section className="form-group-control">
                  <Section className="form-group-inner-wrapper">
                    <Input
                      disabled={true}
                      value={
                        this.state.dataProject
                          ? this.state.dataProject.project_no
                          : ''
                      }
                    />
                  </Section>
                  <Section className="message"></Section>
                </Section>
              </Section>
            </Section>
            <Section className="form-col col-6">
              <Section className="form-group">
                <label>Project Status</label>
                <Section className="form-group-control">
                  <Section className="form-group-inner-wrapper rfq_status">
                    <Input disabled={true} value={projectStatus} />
                    {dataProject.project_status_id === 3 && (
                      <Image
                        src={ICONS['icon-help.svg']}
                        alt="help"
                        tootipValue={dataProject.cancel_reason}
                        useTootipFor={dataProject.cancel_reason}
                        useTootip={true}
                      />
                    )}
                  </Section>
                  <Section className="message"></Section>
                </Section>
              </Section>
            </Section>
          </Section>

          <Section className="form-row">
            <Section className="form-col col-6">
              <Section className="form-group">
                <label>Category</label>
                <Section className="form-group-control">
                  <Section className="form-group-inner-wrapper">
                    <SelectBox
                      id="compare_event_pro_category"
                      options={this.state.businessCategory}
                      placeholder="Select Category"
                      value={this.state.valueBsCategories}
                      isDisabled
                    />
                  </Section>
                  <Section className="message"></Section>
                </Section>
              </Section>
            </Section>

            <Section className="form-col col-6">
              <Section className="form-group">
                <label>Created Date</label>
                <Section className="form-group-control">
                  <Section className="form-group-inner-wrapper">
                    {this.renderCreatedDate(this.state.dataProject)}
                  </Section>
                  <Section className="message"></Section>
                </Section>
              </Section>
            </Section>
          </Section>

          <Section className="form-row">
            <Section className="form-col col-6">
              <Section className="form-group">
                <label>Project Name</label>

                <Section className="form-group-control">
                  <Section className="form-group-inner-wrapper">
                    <Input
                      disabled={true}
                      value={
                        this.state.dataProject
                          ? this.state.dataProject.name
                            ? this.state.dataProject.name
                            : '-'
                          : '-'
                      }
                    />
                  </Section>

                  <Section className="message"></Section>
                </Section>
              </Section>
            </Section>

            <Section className="form-col col-6">
              <Section className="form-group">
                <label>Create By</label>
                <Section className="form-group-control">
                  <Section className="form-group-inner-wrapper">
                    <Input
                      disabled={true}
                      value={
                        this.state.dataProject
                          ? this.state.dataProject.created_by
                            ? this.state.dataProject.created_by
                            : '-'
                          : '-'
                      }
                    />
                  </Section>

                  <Section className="message"></Section>
                </Section>
              </Section>
            </Section>
          </Section>

          <Section className="form-row">
            <Section className="form-col col-6">
              <Section className="form-group">
                <label>Description</label>
                <Section className="form-group-control">
                  <Section className="form-group-inner-wrapper">
                    <InputTextarea
                      disabled={true}
                      value={
                        this.state.dataProject
                          ? this.state.dataProject.description
                            ? this.state.dataProject.description
                            : '-'
                          : ''
                      }
                    />
                  </Section>
                  <Section className="message"></Section>
                </Section>
              </Section>
            </Section>

            <Section className="form-col col-6">
              <Section className="form-group">
                <label>Estimate Budget ({this.state.baseCurrency})</label>
                <Section className="form-group-control">
                  <Section className="form-group-inner-wrapper">
                    <Input
                      disabled={true}
                      value={
                        this.state.dataProject
                          ? this.state.dataProject.estimate_budget
                            ? Numeral(
                                this.state.dataProject.estimate_budget
                              ).format('0,0.00')
                            : '-'
                          : '-'
                      }
                    />
                  </Section>

                  <Section className="message"></Section>
                </Section>
              </Section>

              <Section className="form-group">
                <label>Target Saving (%)</label>

                <Section className="form-group-control">
                  <Section className="form-group-inner-wrapper">
                    <Input
                      disabled={true}
                      value={
                        this.state.dataProject
                          ? this.state.dataProject.target_saving
                            ? Numeral(
                                this.state.dataProject.target_saving
                              ).format('0,0.00')
                            : this.state.dataProject.target_saving
                          : this.state.dataProject.target_saving
                      }
                    />
                  </Section>

                  <Section className="message"></Section>
                </Section>
              </Section>
            </Section>
          </Section>

          <Section className="form-row">
            <Section className="form-col col-6">
              <Section className="form-group">
                <label>Target Date</label>

                <Section className="form-group-control">
                  <Section className="form-group-inner-wrapper">
                    <DatePickerInput
                      selected={
                        this.state.dataProject
                          ? this.state.dataProject.target_date
                            ? this.renderTargetDate(this.state.dataProject)
                            : null
                          : null
                      }
                      disabled={true}
                      minDate={new Date()}
                      showMonthDropdown
                      showYearDropdown
                      dateFormat="MMM d, yyyy"
                      dropdownMode="select"
                    />
                  </Section>

                  <Section className="message"></Section>
                </Section>
              </Section>

              <Section className="form-group">
                <label>Predecessor</label>

                <Section className="form-group-control">
                  <Section className="form-group-inner-wrapper">
                    <SelectBox
                      id="predecessor-pro-event"
                      options={this.state.optionsPredecessor}
                      placeholder="Select Predecessor"
                      value={this.state.predecessorValue}
                      isDisabled
                    />
                  </Section>

                  <Section className="message"></Section>
                </Section>
              </Section>
            </Section>

            <Section className="form-col col-6">
              <Section className="form-group">
                <label>Internal Note</label>

                <Section className="form-group-control">
                  <Section className="form-group-inner-wrapper">
                    <InputTextarea
                      disabled={true}
                      value={
                        this.state.dataProject
                          ? this.state.dataProject.internal_note
                            ? this.state.dataProject.internal_note
                            : '-'
                          : ''
                      }
                    />
                  </Section>

                  <Section className="message"></Section>
                </Section>
              </Section>
            </Section>
          </Section>

          <Section className="form-row">
            <Section className="form-col col-6">
              <Section className="form-group">
                <label>Project Reference</label>
                <Section className="form-group-control">
                  <Section className="form-group-inner-wrapper">
                    <Input
                      disabled={true}
                      value={
                        this.state.dataProject
                          ? this.state.dataProject.project_reference
                            ? this.state.dataProject.project_reference
                            : '-'
                          : ''
                      }
                    />
                  </Section>
                  <Section className="message"></Section>
                </Section>
              </Section>
            </Section>

            <Section className="form-col col-6">
              <Section className="form-group">
                <label className="tooltip-upload">
                  Internal Attachment
                  <Section className="link tooltip-attachment">
                    <Image
                      src={ICONS['icon-help.svg']}
                      alt="help"
                      tootipValue={`(*File type must be jpg, gif, png, bmp, tif, tiff, pdf, doc, docx, \n xls, xlsx, ppt, pptx, txt and Maximum File Size 50 Mb)`}
                      useTootipFor="FileType"
                      useTootip={true}
                    />
                  </Section>
                </label>
                {renderInternalFileProject()}
              </Section>
            </Section>
          </Section>

          <Section className="form-row">
            <Section className={`form-col col-6`}>
              <Section className="form-group">
                <label>Purchasing Site</label>

                <Section className="form-group-control">
                  <Section className="form-group-inner-wrapper">
                    <Button
                      className="theme-blue purchasing-site-detail"
                      onClick={() => {
                        this.toggleModal('purchasing')
                      }}
                    >
                      Detail
                    </Button>
                  </Section>

                  <Section className="message"></Section>
                </Section>
              </Section>
            </Section>
          </Section>
        </Section>

        <Section className="form-wrapper">
          <Section className="form-group-title">Event Information</Section>

          {/* row 1 */}
          <Section className="form-row">
            <Section className="form-col col-6">
              {/* event no.  */}
              <Section className="form-group">
                <label>Event No.</label>
                <Section className="form-group-control">
                  <Section className="form-group-inner-wrapper">
                    <Input disabled={true} value={formData.event_no} />
                  </Section>
                  <Section className="message"></Section>
                </Section>
              </Section>
            </Section>

            <Section className="form-col col-6">
              {/* Bidding Type  */}
              <Section className="form-group">
                <label>Bidding Type</label>
                <Section className="form-group-control">
                  <Section className="form-group-inner-wrapper">
                    <Input disabled={true} value={formData.bidding_type} />
                  </Section>
                  <Section className="message"></Section>
                </Section>
              </Section>
            </Section>
          </Section>

          {/* row 2 */}
          <Section className="form-row">
            <Section className="form-col col-6">
              {/* Event Type */}
              <Section className="form-group">
                <label>Event Type</label>

                <Section className="form-group-control">
                  <Section className="form-group-inner-wrapper">
                    <Input
                      disabled={true}
                      value={this.matchValue(
                        this.state.eventTypes,
                        formData.event_type_id
                      )}
                    />
                  </Section>
                  <Section className="message"></Section>
                </Section>
              </Section>
            </Section>

            <Section className="form-col col-6">
              {/* Event Status  */}
              <Section className="form-group">
                <label>Event Status</label>
                <Section className="form-group-control">
                  <Section className="form-group-inner-wrapper rfq_status">
                    <Input
                      disabled={true}
                      value={this.matchValue(
                        this.state.statuses,
                        formData.rfq_status_id || formData.auction_status_id
                      )}
                    />
                    {(formData.rfq_status_id === 5 ||
                      formData.auction_status_id === 5) && (
                      <Image
                        src={ICONS['icon-help.svg']}
                        alt="help"
                        tootipValue={formData.cancel_reason}
                        useTootipFor={formData.cancel_reason}
                        useTootip={true}
                      />
                    )}{' '}
                  </Section>
                  <Section className="message"></Section>
                </Section>
              </Section>
            </Section>
          </Section>

          {/* row 3 */}
          <Section className="form-row">
            <Section className="form-col col-6">
              {/* Event Name */}
              <Section className="form-group">
                <label>Event Name</label>

                <Section className="form-group-control">
                  <Section className="form-group-inner-wrapper">
                    <Input disabled={true} value={formData.name} />
                  </Section>

                  <Section className="message"></Section>
                </Section>
              </Section>
            </Section>

            <Section className="form-col col-6">
              {/* Award Status */}
              <Section className="form-group">
                <label>Award Status</label>

                <Section className="form-group-control">
                  <Section className="form-group-inner-wrapper rfq_status">
                    <Input
                      disabled={true}
                      value={this.matchValue(
                        this.state.awardStatuses,
                        formData.rfq_award_status_id ||
                          formData.auction_award_status_id
                      )}
                    />
                    {(formData.rfq_award_status_id === 5 ||
                      formData.auction_award_status_id === 5) && (
                      <Image
                        src={ICONS['icon-help.svg']}
                        alt="help"
                        tootipValue={formData.no_selection_reason}
                        useTootipFor={formData.no_selection_reason}
                        useTootip={true}
                      />
                    )}
                  </Section>
                  <Section className="message"></Section>
                </Section>
              </Section>
            </Section>
          </Section>

          {/* row 4 */}
          <Section className="form-row">
            <Section className="form-col col-6">
              {/* Description */}
              <Section className="form-group">
                <label>Description</label>

                <Section className="form-group-control">
                  <Section className="form-group-inner-wrapper">
                    <InputTextarea
                      disabled={true}
                      value={formData.description ? formData.description : '-'}
                    />
                  </Section>

                  <Section className="message"></Section>
                </Section>
              </Section>
            </Section>

            <Section className="form-col col-6">
              {/* Created Date */}
              <Section className="form-group">
                <label>Created Date</label>
                <Section className="form-group-control">
                  <Section className="form-group-inner-wrapper">
                    <Input
                      disabled={true}
                      value={dateMonDayYearTime(
                        // moment(formData.create_at, 'YYYY/MM/DD HH:mm:ss')
                        //   .utc(formData.create_at)
                        //   .toDate()
                        moment(
                          formData.create_at,
                          'YYYY/MM/DD HH:mm:ss'
                        ).toDate()
                      )}
                    />
                  </Section>
                  <Section className="message"></Section>
                </Section>
              </Section>

              {/* Create By */}
              <Section className="form-group">
                <label>Create By</label>

                <Section className="form-group-control">
                  <Section className="form-group-inner-wrapper">
                    <Input disabled={true} value={formData.create_by} />
                  </Section>

                  <Section className="message"></Section>
                </Section>
              </Section>
            </Section>
          </Section>

          {/* row 5 */}
          <Section className="form-row">
            <Section className="form-col col-6">
              {/* Currency */}
              <Section className="form-group">
                <label>Currency</label>

                <Section className="form-group-control">
                  <Section className="form-group-inner-wrapper">
                    <Input disabled={true} value={formData.currency} />
                  </Section>

                  <Section className="message"></Section>
                </Section>
              </Section>
            </Section>

            <Section className="form-col col-6">
              {/* VAT */}
              <Section className="form-group">
                <label>VAT</label>

                <Section className="form-group-control">
                  <Section className="form-group-inner-wrapper">
                    <Input disabled={true} value={formData.vat} />
                  </Section>

                  <Section className="message"></Section>
                </Section>
              </Section>
            </Section>
          </Section>

          {/* row 6  */}
          <Section className="form-row">
            <Section className="form-col col-6">
              {/* Start Date */}
              <Section className="form-group">
                <label>Start Date</label>

                <Section className="form-group-control">
                  <Section className="form-group-inner-wrapper">
                    <Input
                      disabled={true}
                      value={dateMonDayYearTime(formData.start_date)}
                    />
                  </Section>

                  <Section className="message"></Section>
                </Section>
              </Section>
            </Section>

            <Section className="form-col col-6">
              {/* End Date */}
              <Section className="form-group">
                <label>End Date</label>

                <Section className="form-group-control">
                  <Section className="form-group-inner-wrapper">
                    <Input
                      disabled={true}
                      value={dateMonDayYearTime(formData.end_date)}
                    />
                  </Section>

                  <Section className="message"></Section>
                </Section>
              </Section>
            </Section>
          </Section>

          {formData.event_type_id === 1 ? (
            <>
              {/* row 7 RFQ  */}
              <Section className="form-row">
                <Section className="form-col col-6">
                  {/* Purchasing Type */}
                  <Section className="form-group">
                    <label>Purchasing Type</label>

                    <Section className="form-group-control">
                      <Section className="form-group-inner-wrapper">
                        <Input
                          disabled={true}
                          value={formData.purchasing_type}
                        />
                      </Section>

                      <Section className="message"></Section>
                    </Section>
                  </Section>
                </Section>

                <Section className="form-col col-6">
                  {/* Seal Envelope */}
                  <Section className="form-group">
                    <label>Seal Envelope</label>
                    <Section className="form-group-control">
                      <Section className="form-group-inner-wrapper">
                        <ToggleCompareEvent
                          checkedToggle={formData.seal_type}
                        />{' '}
                        {formData.seal_status_name ? (
                          <span
                            style={{
                              marginLeft: '14px',
                              color: '#848484',
                              fontSize: '17px',
                            }}
                          >
                            {formData.seal_status_name}
                          </span>
                        ) : (
                          ''
                        )}
                      </Section>
                      <Section className="message"></Section>
                    </Section>
                  </Section>
                </Section>
              </Section>
            </>
          ) : (
            <>
              {/* row 7 Auction  */}
              <Section className="form-row">
                <Section className="form-col col-6">
                  {/* Auction Type */}
                  <Section className="form-group">
                    <label>Auction Type</label>

                    <Section className="form-group-control">
                      <Section className="form-group-inner-wrapper">
                        <Input disabled={true} value={formData.auction_type} />
                      </Section>

                      <Section className="message"></Section>
                    </Section>
                  </Section>
                </Section>

                <Section className="form-col col-6">
                  {/* Opening Price  */}
                  <Section className="form-group">
                    <label>Opening Price </label>

                    <Section className="form-group-control">
                      <Section className="form-group-inner-wrapper">
                        <NumberFormat
                          type="text"
                          value={
                            formData.opening_price
                              ? Number(formData.opening_price).toFixed(2)
                              : null
                          }
                          thousandSeparator={true}
                          customInput={Input}
                          disabled={true}
                        />
                      </Section>

                      <Section className="message"></Section>
                    </Section>
                  </Section>
                </Section>
              </Section>

              {/* row 8 Auction*/}
              <Section className="form-row">
                <Section className="form-col col-6">
                  {/* Extension Time */}
                  <Section className="form-group">
                    <label>
                      Extension Time <br />
                      (Minutes)
                    </label>

                    <Section className="form-group-control">
                      <Section className="form-group-inner-wrapper">
                        <div className="group-input-custom">
                          <Input
                            className="input-custom"
                            disabled={true}
                            value={
                              formData.is_extension_time_used ? 'Yes' : 'No'
                            }
                          />
                          <Input
                            className="input-custom"
                            disabled={true}
                            value={
                              formData.is_extension_time_used
                                ? formData.extension_minutes + ' Minutes'
                                : '-'
                            }
                          />
                        </div>
                      </Section>

                      <Section className="message"></Section>
                    </Section>
                  </Section>
                </Section>

                <Section className="form-col col-6">
                  {/* Bid Submission */}
                  <Section className="form-group">
                    <label>Bid Submission</label>

                    <Section className="form-group-control">
                      <Section className="form-group-inner-wrapper">
                        <div className="group-input-custom">
                          <Input
                            className="input-custom"
                            disabled={true}
                            value={
                              formData.bidding_type === 'Reverse'
                                ? formData.is_min_bid_used
                                  ? 'Minimum Bid Decrement'
                                  : 'Bid Decrement'
                                : formData.is_min_bid_used
                                ? 'Minimum Bid Increment'
                                : 'Bid Increment'
                            }
                          />
                          <NumberFormat
                            className="input-custom"
                            type="text"
                            value={
                              formData.bid_decrement_increment ||
                              formData.min_bid_decrement_increment
                                ? Number(
                                    formData.bid_decrement_increment ||
                                      formData.min_bid_decrement_increment
                                  ).toFixed(2)
                                : null
                            }
                            thousandSeparator={true}
                            customInput={Input}
                            disabled={true}
                          />
                        </div>
                      </Section>

                      <Section className="message"></Section>
                    </Section>
                  </Section>
                </Section>
              </Section>

              {/* row 9 Auction*/}
              <Section className="form-row">
                <Section className="form-col col-6">
                  {/* Extension Time */}
                  <Section className="form-group">
                    <label>Max Extension Time</label>

                    <Section className="form-group-control">
                      <Section className="form-group-inner-wrapper">
                        <div className="group-input-custom">
                          <Input
                            className="input-custom"
                            disabled={true}
                            value={
                              formData.is_extension_time_used
                                ? formData.extension_time_string
                                : '-'
                            }
                          />
                          <Input
                            className="input-custom"
                            disabled={true}
                            value={
                              formData.is_extension_time_used
                                ? formData.extension_time
                                  ? formData.extension_time + ' Times'
                                  : '-'
                                : '-'
                            }
                          />
                        </div>
                      </Section>

                      <Section className="message"></Section>
                    </Section>
                  </Section>
                </Section>

                <Section className="form-col col-6">
                  {/* Display Dummy */}
                  <Section className="form-group">
                    <label>
                      Display Dummy <br />
                      Supplier Name
                    </label>

                    <Section className="form-group-control">
                      <Section className="form-group-inner-wrapper">
                        <Input
                          disabled={true}
                          value={
                            formData.display_dummy_supplier_name ? 'Yes' : 'No'
                          }
                        />
                      </Section>

                      <Section className="message"></Section>
                    </Section>
                  </Section>
                </Section>
              </Section>
            </>
          )}

          {/* time left   */}
          <Section className="form-row">
            <Section className="form-col col-6">
              {/* Time Left */}
              {(formData.rfq_status_id === 3 ||
                formData.auction_status_id === 3) && (
                <Section className="form-group">
                  <label>Time Left</label>

                  <Section className="form-group-control">
                    <Section className="form-group-inner-wrapper">
                      {this.renderTimeOut(formData)}
                    </Section>

                    <Section className="message"></Section>
                  </Section>
                </Section>
              )}
            </Section>
          </Section>

          <Section className="form-row">
            <Section className="form-col col-6">
              {/* Internal Note */}
              <Section className="form-group">
                <label>Internal Note</label>

                <Section className="form-group-control">
                  <Section className="form-group-inner-wrapper">
                    <InputTextarea
                      disabled={true}
                      value={
                        formData.internal_note ? formData.internal_note : '-'
                      }
                    />
                  </Section>

                  <Section className="message"></Section>
                </Section>
              </Section>
            </Section>

            <Section className="form-col col-6">
              {/* Note To Supplier */}
              <Section className="form-group">
                <label>Note To Supplier</label>

                <Section className="form-group-control">
                  <Section className="form-group-inner-wrapper">
                    <InputTextarea
                      disabled={true}
                      value={
                        formData.note_to_supplier
                          ? formData.note_to_supplier
                          : '-'
                      }
                    />
                  </Section>

                  <Section className="message"></Section>
                </Section>
              </Section>
            </Section>
          </Section>

          <Section className="form-row">
            <Section className="form-col col-6">
              {/* Internal Attachment */}
              <Section className="form-group">
                <label className="tooltip-upload">
                  Internal Attachment
                  <Section className="link tooltip-attachment">
                    <Image
                      src={ICONS['icon-help.svg']}
                      alt="help"
                      tootipValue={`(*File type must be jpg, gif, png, bmp, tif, tiff, pdf, doc, docx, \n xls, xlsx, ppt, pptx, txt and Maximum File Size 50 Mb)`}
                      useTootipFor="FileType"
                      useTootip={true}
                    />
                  </Section>
                </label>

                {internalFile.length > 0 ? (
                  <Section className="form-group-control">
                    <AttachedFile
                      // key={i}
                      id={`attached-file-internal-file`}
                      isIcon={true}
                      isUpload={false}
                      onDownload={e => {
                        this.setLoadingDownloadFile(e)
                        this.downloadInternal(e)
                        // e.id ? this.downloadInternal(e) : null
                      }}
                      fileList={internalFile}
                      loadingDownload={this.state.loadingDownloadFile}
                    />
                  </Section>
                ) : (
                  '-'
                )}
                <Section className="message"></Section>
              </Section>
            </Section>

            <Section className="form-col col-6">
              {/* Attachment To */}
              <Section className="form-group">
                <label className="tooltip-upload">
                  Attachment To <br /> Supplier
                  <Section className="link tooltip-attachment">
                    <Image
                      src={ICONS['icon-help.svg']}
                      alt="help"
                      tootipValue={`(*File type must be jpg, gif, png, bmp, tif, tiff, pdf, doc, docx, \n xls, xlsx, ppt, pptx, txt and Maximum File Size 50 Mb)`}
                      useTootipFor="FileType"
                      useTootip={true}
                    />
                  </Section>
                </label>
                {externalFile.length > 0 ? (
                  <Section className="form-group-control">
                    <AttachedFile
                      id={'attached-file-list'}
                      isIcon={true}
                      isUpload={false}
                      onDownload={e => {
                        this.setLoadingDownloadFile(e)
                        this.downloadExternal(e)
                      }}
                      fileList={externalFile}
                      className={'attached-file-list'}
                      loadingDownload={this.state.loadingDownloadFile}
                    />
                  </Section>
                ) : (
                  '-'
                )}
              </Section>
            </Section>
          </Section>

          {formData.event_type_id === 2 && statusRFQ === 4
            ? this.renderAuctionEventLog()
            : null}

          {/* function render button Re-open event and Reschedule Event */}
          {formData.event_type_id === 1 && (
            <>{this.renderReopenAwaiting(formData, hideTecRole)}</>
          )}
        </Section>
      </React.Fragment>
    )
  }

  step2Content() {
    const { products, UOM } = this.state
    return (
      <Section className="form-wrapper step-2">
        <Section className="form-group-title">
          Compare Event - Step 2 : Event Items
        </Section>

        <Section className="form-group-header">
          Total {products.items ? products.items.length : 0} items
        </Section>

        <Section className="table-header-freeze-wrapper">
          <Table className="sourcing-item compare header-freeze">
            <Table.TBODY>
              <Table.TR>
                <Table.TH className="no">No</Table.TH>

                <Table.TH className="item-name-event">ITEM NAME</Table.TH>

                <Table.TH className="description">DESCRIPTION</Table.TH>

                <Table.TH className="quantity">Qty</Table.TH>

                <Table.TH className="uom">UOM</Table.TH>

                <Table.TH className="price">UNIT PRICE: THB</Table.TH>
              </Table.TR>
            </Table.TBODY>
          </Table>
          <Table className="sourcing-item compare split-row-color">
            <Table.TBODY>
              {!!products.items &&
                products.items.map((e, i) => {
                  const mapUOM = this.matchValueSelected(UOM, e.uom_id)
                  return (
                    <Table.TR key={i}>
                      <Table.TD className="no">{i + 1}</Table.TD>

                      <Table.TD className="item-name-event">
                        <Section>
                          {e.name}{' '}
                          {e.rfq_buyer_item_file &&
                            e.rfq_buyer_item_file.map((j, i) => {
                              return (
                                <Section className="attached-file-list" key={i}>
                                  <a
                                    target="_blank"
                                    className="file-link removable"
                                    rel="noopener noreferrer"
                                  >
                                    <span
                                      onClick={() => {
                                        j.id ? this.downloadItem(j) : null
                                      }}
                                      className="file-name"
                                    >
                                      {j.name}
                                    </span>
                                  </a>
                                </Section>
                              )
                            })}
                        </Section>
                      </Table.TD>

                      <Table.TD className="description">
                        <Section>{e.description}</Section>
                      </Table.TD>

                      <Table.TD className="quantity">
                        {Numeral(e.req_amount).format('0,0.00')}
                      </Table.TD>

                      <Table.TD className="uom">
                        {mapUOM ? mapUOM.label : null}
                      </Table.TD>

                      <Table.TD className="price">
                        <Section>
                          Budget Price:{' '}
                          {Numeral(e.budget_price).format('0,0.0000')}
                        </Section>
                        <Section>
                          Historical Price:{' '}
                          {!e.historical_price ||
                          parseFloat(e.historical_price) === 0
                            ? 'N/A'
                            : Numeral(e.historical_price).format('0,0.0000')}
                        </Section>
                        <Section>
                          Market Price:{' '}
                          {!e.market_price || parseFloat(e.market_price) === 0
                            ? 'N/A'
                            : Numeral(e.market_price).format('0,0.0000')}
                        </Section>
                      </Table.TD>
                    </Table.TR>
                  )
                })}
            </Table.TBODY>
          </Table>
        </Section>
      </Section>
    )
  }

  step3Content() {
    const { formData, externalFile } = this.state
    return (
      <Section className="form-wrapper add-supplier">
        <Section className="form-group-title">
          Compare Event - Step 3 : Event Summary
        </Section>
        <Section className="table-wrapper">
          <Table className="buyer split-row-color">
            {/* Header Row */}
            <Table.THEAD>
              <Table.TR className="header">
                <Table.TH className="no" id="no_header">
                  NO.
                </Table.TH>
                <Table.TH className="tax-id" id="tax_id_header">
                  TAX ID
                </Table.TH>

                <Table.TH className="company-name" id="company_name_header">
                  SUPPLIER NAME
                </Table.TH>

                <Table.TH className="branch-number" id="main_directory_header">
                  BRANCH
                </Table.TH>

                <Table.TH className="vendor-code" id="vendor_code">
                  SUPPLIER NO.
                </Table.TH>

                <Table.TH className="contact-name" id="contact_name">
                  CONTACT NAME
                </Table.TH>

                <Table.TH className="email" id="email_header">
                  CONTACT EMAIL
                </Table.TH>

                <Table.TH className="phone" id="phone_header">
                  PHONE
                </Table.TH>
              </Table.TR>
            </Table.THEAD>

            <Table.TBODY>{this.renderSuppliersRfqSelect()}</Table.TBODY>
          </Table>
        </Section>

        <Section className="form-row form-row-title form-group-header">
          <label>Sourcing Period</label>
        </Section>

        <Section className="form-row">
          <Section className="form-col col-6">
            <Section className={`form-group date-period`}>
              <label>Start Date</label>

              <Section className="form-group-control">
                <Section className="form-group-inner-wrapper">
                  <DatePickerInput
                    selected={formData.start_date ? formData.start_date : null}
                    // selectsStart
                    disabled={true}
                    minDate={new Date()}
                    showMonthDropdown
                    showYearDropdown
                    dateFormat="MMMM d, yyyy h:mm aa"
                    dropdownMode="select"
                  />
                </Section>

                <Section className="message"></Section>
              </Section>
            </Section>
          </Section>

          <Section className="form-col col-6">
            <Section className={`form-group date-period`}>
              <label>End Date</label>

              <Section className="form-group-control">
                <Section className="form-group-inner-wrapper">
                  <DatePickerInput
                    selected={formData.end_date ? formData.end_date : null}
                    disabled={true}
                    // selectsStart
                    minDate={formData.start_date}
                    showMonthDropdown
                    showYearDropdown
                    dateFormat="MMMM d, yyyy h:mm aa"
                    dropdownMode="select"
                  />
                </Section>

                <Section className="message"></Section>
              </Section>
            </Section>
          </Section>
        </Section>

        <Section className="form-row form-row-title">
          <Section className="form-group">
            <label>Note To Supplier</label>
          </Section>
        </Section>

        <Section className="form-group">
          <label>Note</label>
          <Section className="form-group-control">
            <Section className="form-group-inner-wrapper">
              <InputTextarea
                value={formData.note_to_supplier}
                disabled={true}
              ></InputTextarea>
            </Section>
            <Section className="message"></Section>
          </Section>
        </Section>

        <Section className="form-group">
          <label>Attachment</label>
          <Section className="form-group-control">
            {externalFile.length > 0
              ? externalFile.map((e, i) => {
                  return (
                    <Section className="attached-file-list" key={i}>
                      <a
                        target="_blank"
                        className="file-link removable"
                        rel="noopener noreferrer"
                      >
                        <span
                          onClick={() => {
                            e.id ? this.downloadExternal(e) : null
                          }}
                          className="file-name"
                        >
                          {e.name}{' '}
                        </span>
                      </a>
                    </Section>
                  )
                })
              : '-'}
          </Section>
        </Section>
      </Section>
    )
  }
  renderAveragePrice = (event, formData, is_Green) => {
    if (
      formData.seal_status_name === sealStatus.sealed ||
      formData.seal_status_name === sealStatus.awaitingunseal
    ) {
      return (
        <React.Fragment>
          {event.average_price && (
            <>
              <Section
                className={`form-col col-6`}
                style={{ color: '#4b4acb' }}
              >
                <span></span>
              </Section>
              <Section className="form-col col-6">
                <span></span>
              </Section>
            </>
          )}
        </React.Fragment>
      )
    } else {
      return (
        <React.Fragment>
          {event.average_price && (
            <>
              <Section
                className={`form-col col-6 " ${
                  parseFloat(event.average_price) === is_Green && 'market-price'
                } `}
              >
                Average Price
              </Section>
              <Section className="form-col col-6">
                {event.average_price &&
                  (parseFloat(event.average_price) === is_Green ? (
                    <Section className="market-price text-right">
                      <div
                        className="cut-word"
                        data-tip
                        data-for={`${formData.id}-${event.average_price}-average-price`}
                      >
                        {Numeral(event.average_price).format('0,0.00')}
                      </div>
                      <TooltipBuyer
                        id={`${formData.id}-${event.average_price}-average-price`}
                        toolTipText={Numeral(event.average_price).format(
                          '0,0.00'
                        )}
                      />
                    </Section>
                  ) : event.average_price.charAt(0) === '-' ? (
                    <Section className="average-price">
                      <div
                        className="cut-word"
                        data-tip
                        data-for={`${formData.id}-${event.average_price}-average-price`}
                      >
                        {Numeral(event.average_price).format('0,0.00')}
                      </div>
                      <TooltipBuyer
                        id={`${formData.id}-${event.average_price}-average-price`}
                        toolTipText={Numeral(event.average_price).format(
                          '0,0.00'
                        )}
                      />
                    </Section>
                  ) : (
                    <Section className="text-right">
                      <div
                        className="cut-word"
                        data-tip
                        data-for={`${formData.id}-${event.average_price}-average-price`}
                      >
                        {Numeral(event.average_price).format('0,0.00')}
                      </div>
                      <TooltipBuyer
                        id={`${formData.id}-${event.average_price}-average-price`}
                        toolTipText={Numeral(event.average_price).format(
                          '0,0.00'
                        )}
                      />
                    </Section>
                  ))}
              </Section>
            </>
          )}
        </React.Fragment>
      )
    }
  }
  renderBudgetPrice = (event, formData, is_Green) => {
    if (
      formData.seal_status_name === sealStatus.sealed ||
      formData.seal_status_name === sealStatus.awaitingunseal
    ) {
      return (
        <React.Fragment>
          {event.budget_price && (
            <>
              <Section
                className={`form-col col-6`}
                style={{ color: '#4b4acb' }}
              >
                <span></span>
              </Section>
              <Section className="form-col col-6">
                <span></span>
              </Section>
            </>
          )}
        </React.Fragment>
      )
    } else {
      return (
        <React.Fragment>
          {event.budget_price && (
            <>
              <Section
                className={`form-col col-6 " ${
                  parseFloat(event.budget_price) === is_Green && 'market-price'
                } `}
              >
                Budget Price
              </Section>
              <Section className="form-col col-6 ">
                {event.budget_price &&
                  (parseFloat(event.budget_price) === is_Green ? (
                    <Section className="market-price text-right">
                      <div
                        className="cut-word"
                        data-tip
                        data-for={`${formData.id}-${event.budget_price}-budget-price`}
                      >
                        {Numeral(event.budget_price).format('0,0.00')}
                      </div>
                      <TooltipBuyer
                        id={`${formData.id}-${event.budget_price}-budget-price`}
                        toolTipText={Numeral(event.budget_price).format(
                          '0,0.00'
                        )}
                      />
                    </Section>
                  ) : event.budget_price.charAt(0) === '-' ? (
                    <Section className="average-price">
                      <div
                        className="cut-word"
                        data-tip
                        data-for={`${formData.id}-${event.budget_price}-budget-price`}
                      >
                        {Numeral(event.budget_price).format('0,0.00')}
                      </div>
                      <TooltipBuyer
                        id={`${formData.id}-${event.budget_price}-budget-price`}
                        toolTipText={Numeral(event.budget_price).format(
                          '0,0.00'
                        )}
                      />
                    </Section>
                  ) : (
                    <Section className="text-right">
                      <div
                        className="cut-word"
                        data-tip
                        data-for={`${formData.id}-${event.budget_price}-budget-price`}
                      >
                        {Numeral(event.budget_price).format('0,0.00')}
                      </div>
                      <TooltipBuyer
                        id={`${formData.id}-${event.budget_price}-budget-price`}
                        toolTipText={Numeral(event.budget_price).format(
                          '0,0.00'
                        )}
                      />
                    </Section>
                  ))}
              </Section>
            </>
          )}
        </React.Fragment>
      )
    }
  }
  renderHistoricalPrice = (event, formData, is_Green) => {
    if (
      formData.seal_status_name === sealStatus.sealed ||
      formData.seal_status_name === sealStatus.awaitingunseal
    ) {
      return (
        <React.Fragment>
          {event.historical_price && (
            <>
              <Section
                className={`form-col col-6`}
                style={{ color: '#4b4acb' }}
              >
                <span></span>
              </Section>
              <Section className="form-col col-6">
                <span></span>
              </Section>
            </>
          )}
        </React.Fragment>
      )
    } else {
      return (
        <React.Fragment>
          {event.historical_price && (
            <>
              <Section
                className={`form-col col-6 " ${
                  parseFloat(event.historical_price) === is_Green &&
                  'market-price'
                } `}
              >
                Historical Price
              </Section>
              <Section className="form-col col-6">
                {event.historical_price &&
                  (parseFloat(event.historical_price) === is_Green ? (
                    <Section className="market-price text-right">
                      <div
                        className="cut-word"
                        data-tip
                        data-for={`${formData.id}-${event.historical_price}-historical-price`}
                      >
                        {Numeral(event.historical_price).format('0,0.00')}
                      </div>
                      <TooltipBuyer
                        id={`${formData.id}-${event.historical_price}-historical-price`}
                        toolTipText={Numeral(event.historical_price).format(
                          '0,0.00'
                        )}
                      />
                    </Section>
                  ) : event.historical_price.charAt(0) === '-' ? (
                    <Section className="average-price">
                      <div
                        className="cut-word"
                        data-tip
                        data-for={`${formData.id}-${event.historical_price}-historical-price`}
                      >
                        {Numeral(event.historical_price).format('0,0.00')}
                      </div>
                      <TooltipBuyer
                        id={`${formData.id}-${event.historical_price}-historical-price`}
                        toolTipText={Numeral(event.historical_price).format(
                          '0,0.00'
                        )}
                      />
                    </Section>
                  ) : (
                    <Section className="text-right">
                      <div
                        className="cut-word"
                        data-tip
                        data-for={`${formData.id}-${event.historical_price}-historical-price`}
                      >
                        {Numeral(event.historical_price).format('0,0.00')}
                      </div>
                      <TooltipBuyer
                        id={`${formData.id}-${event.historical_price}-historical-price`}
                        toolTipText={Numeral(event.historical_price).format(
                          '0,0.00'
                        )}
                      />
                    </Section>
                  ))}
              </Section>
            </>
          )}
        </React.Fragment>
      )
    }
  }
  renderMarketPrice = (event, formData, is_Green) => {
    if (
      formData.seal_status_name === sealStatus.sealed ||
      formData.seal_status_name === sealStatus.awaitingunseal
    ) {
      return (
        <React.Fragment>
          {event.market_price && (
            <>
              <Section
                className={`form-col col-6`}
                style={{ color: '#4b4acb' }}
              >
                <span></span>
              </Section>
              <Section className="form-col col-6">
                <span></span>
              </Section>
            </>
          )}
        </React.Fragment>
      )
    } else {
      return (
        <React.Fragment>
          {event.market_price && (
            <>
              <Section
                className={`form-col col-6 " ${
                  parseFloat(event.market_price) === is_Green && 'market-price'
                } `}
              >
                Market Price
              </Section>
              <Section className="form-col col-6">
                {event.market_price &&
                  (parseFloat(event.market_price) === is_Green ? (
                    <Section className="market-price text-right">
                      <div
                        className="cut-word"
                        data-tip
                        data-for={`${formData.id}-${event.market_price}-market-price`}
                      >
                        {Numeral(event.market_price).format('0,0.00')}
                      </div>
                      <TooltipBuyer
                        id={`${formData.id}-${event.market_price}-market-price`}
                        toolTipText={Numeral(event.market_price).format(
                          '0,0.00'
                        )}
                      />
                    </Section>
                  ) : event.market_price.charAt(0) === '-' ? (
                    <Section className="average-price">
                      <div
                        className="cut-word"
                        data-tip
                        data-for={`${formData.id}-${event.market_price}-market-price`}
                      >
                        {Numeral(event.market_price).format('0,0.00')}
                      </div>
                      <TooltipBuyer
                        id={`${formData.id}-${event.market_price}-market-price`}
                        toolTipText={Numeral(event.market_price).format(
                          '0,0.00'
                        )}
                      />
                    </Section>
                  ) : (
                    <Section className="text-right">
                      <div
                        className="cut-word"
                        data-tip
                        data-for={`${formData.id}-${event.market_price}-market-price`}
                      >
                        {Numeral(event.market_price).format('0,0.00')}
                      </div>
                      <TooltipBuyer
                        id={`${formData.id}-${event.market_price}-market-price`}
                        toolTipText={Numeral(event.market_price).format(
                          '0,0.00'
                        )}
                      />
                    </Section>
                  ))}
              </Section>
            </>
          )}
        </React.Fragment>
      )
    }
  }
  renderNoteSeal = (event, formData, is_Green, statusSup, keySup) => {
    const acceptedStatus = statusSup[keySup].response_status
    const { seal_status_name, rfq_status } = formData
    if (
      event.response_status === 'Rejected' &&
      formData.seal_status_name !== sealStatus.sealed &&
      formData.seal_status_name !== sealStatus.awaitingunseal
    ) {
      return (
        <React.Fragment>
          <Section className="note">
            Note:{' '}
            {event.note && event.response_status !== 'Rejected' // Reject Reason ไม่ต้องแสดงไว้ที่ราย Item
              ? event.note
              : ''}
          </Section>
        </React.Fragment>
      )
    } else {
      if (
        formData.seal_status_name === sealStatus.sealed ||
        formData.seal_status_name === sealStatus.awaitingunseal
      ) {
        if (
          event.response_status === 'Rejected' &&
          acceptedStatus !== 'Accepted'
        ) {
          return (
            <React.Fragment>
              <Section className="note">
                Note:{' '}
                {event.note && event.response_status !== 'Rejected'
                  ? event.note
                  : ''}
              </Section>
            </React.Fragment>
          )
        } else {
          return (
            <React.Fragment>
              <Section className="note">
                {/* <label style={{ color: '#4b4acb' }}>Note:</label> */}
                <span></span>
              </Section>
            </React.Fragment>
          )
        }
      } else {
        return (
          <React.Fragment>
            <Section className="note">
              Note:{' '}
              {event.note &&
              event.response_status !== 'Rejected' &&
              event.response_status !== 'Draft'
                ? event.note
                : ''}
            </Section>
          </React.Fragment>
        )
      }
    }
  }
  renderFuncButtonSelectItem(formData, event, key, keyUom) {
    let {
      itemAction,
      quotationCheckBox,
      tempData,
      setDataInit,
      resultSelect,
      allowSupplierSelected,
      allocateItems,
      setNoItemSelect,
      dataProject,
    } = this.state
    const { selectedBySupplier } = itemAction
    const {
      id,
      event_item_supplier: event_item_supplier,
      auction_item_supplier_response,
    } = event

    const idSup =
      (event_item_supplier && event_item_supplier[key].event_supplier_id) ||
      (auction_item_supplier_response &&
        auction_item_supplier_response[key].auction_supplier_id)

    const handlerOnClickSelectItem = async (id, event_item_supplier) => {
      this.setState({ isLoading: true })

      const { match } = this.props
      const { params } = match
      const { rfqid } = params
      const { event_supplier_id } = event_item_supplier
      const funcChecked = value => {
        return false
      }
      const checkBox = map(quotationCheckBox, (value, index) => {
        const dataId = setDataInit[index].id
        const arrayMapCheckBox = map(value[dataId], (chakValue, key) => {
          return {
            ...chakValue,
            checked: funcChecked(chakValue),
          }
        })
        return {
          [dataId]: arrayMapCheckBox,
        }
      })
      const dataObs = {
        selectItem: {
          idEvent: id,
          rfq_sup: event_supplier_id,
        },
      }
      await this.setState({ quotationCheckBox: checkBox })
      await this.funcWrapData(dataObs)
      setTimeout(() => {
        this.getApprovalWorkflow(rfqid)
        this.setState({ isLoading: false })
      }, 800)
    }

    const funcCheckBoxUnCheck = () => {
      const funcChecked = value => {
        return false
      }
      const checkBox = map(quotationCheckBox, (value, index) => {
        const dataId = setDataInit[index].id
        const arrayMapCheckBox = map(value[dataId], (chakValue, key) => {
          return {
            ...chakValue,
            checked: funcChecked(chakValue),
          }
        })
        return {
          [dataId]: arrayMapCheckBox,
        }
      })
      return checkBox
    }

    const handlerOnClickCheck = async e => {
      this.setState({ isLoading: true })

      if (e.detail === 1) {
        const idEvent = id
        const idSup =
          event_item_supplier[key] || auction_item_supplier_response[key]
        const checkBox = funcCheckBoxUnCheck()
        const dataObs = {
          unCheckItem: {
            idEvent,
            idSup,
          },
        }
        await this.setState({ quotationCheckBox: checkBox })
        await this.funcWrapData(dataObs)

        this.setState({ isLoading: false })
      }
    }

    const handlersClickEdit = (e, idItem) => {
      e.preventDefault()
      const findData = find(setDataInit, (value, index) => {
        if (value.id === idItem) return value
      })
      allocateItems = findData
      this.setTypeCheckBoxSelected([allocateItems])
      this.setState({ allocateItems })
      this.toggleModal('allow-selection')
    }

    if (selectedBySupplier.length > 0) {
      const { eventType } = this.props.match.params
      const findIdButtonCheck = find(selectedBySupplier, (value, index) => {
        const idSup =
          (event_item_supplier && event_item_supplier[key].event_supplier_id) ||
          (auction_item_supplier_response &&
            auction_item_supplier_response[key].auction_supplier_id)
        if (value.idItem === id && value.idSup === idSup) {
          return value
        }
      })
      const findIdSelect = find(setNoItemSelect, (value, index) => {
        const { id: idNoitem } = value
        if (idNoitem === id) return value
      })
      const itemSupplier = findIdSelect
        ? findIdSelect.event_item_supplier ||
          findIdSelect.auction_item_supplier_response
        : []
      const findIdSupSelect = find(
        itemSupplier,
        value =>
          (value.event_supplier_id || value.auction_supplier_id) === idSup
      )
      if (Number(eventType) === 1) {
        // Auction ไม่มีพวก Select Item / Allocate / No Select

        if (!isEmpty(findIdButtonCheck) && !findIdSupSelect) {
          const hideItemReject = event_item_supplier
            ? event_item_supplier[key].unit_price
            : ''
          const hideItemResponse = event_item_supplier
            ? event_item_supplier[key].response_status
            : ''
          if (
            findIdButtonCheck.action === 'checked' &&
            hideItemReject !== '' &&
            hideItemResponse !== 'Rejected' &&
            hideItemReject !== 'RFQ Reject'
          ) {
            return (
              <Button
                key={key}
                className="theme-green is-bottom"
                disabled={
                  this.state.eventListHaveApprove ||
                  this.state.isHavingListEventOpen
                }
                onClick={handlerOnClickCheck}
              >
                Select Item
              </Button>
            )
          } else {
            if (
              hideItemReject !== '' &&
              hideItemResponse !== 'Rejected' &&
              hideItemReject !== 'RFQ Reject'
            ) {
              return (
                <Button
                  key={key}
                  className="theme-blue is-bottom"
                  disabled={
                    this.state.eventListHaveApprove ||
                    this.state.isHavingListEventOpen
                  }
                  onClick={e => {
                    if (e.detail === 1) {
                      return handlerOnClickSelectItem(
                        id,
                        event_item_supplier[key]
                      )
                    }
                  }}
                >
                  Select Item
                </Button>
              )
            }
          }
        } else {
          const findIdItem = find(allowSupplierSelected, (value, index) => {
            if (value.id === id) return value
          })
          if (findIdItem) {
            const { qty, percent } = allowcateType
            const findIdSup = find(
              findIdItem.event_item_supplier,
              (value, index) => {
                const {
                  event_supplier_id,
                  allocate_type,
                  selected_amount,
                } = value
                // console.log(
                //   event_supplier_id ===
                //     event_item_supplier[key].event_supplier_id
                // )
                if (
                  event_supplier_id ===
                  event_item_supplier[key].event_supplier_id
                ) {
                  if (allocate_type === qty && selected_amount > 0) {
                    return value
                  } else if (allocate_type === percent && selected_amount > 0) {
                    return value
                  }
                }
              }
            )
            if (findIdSup) {
              const {
                allocate_type,
                selected_amount,
                event_supplier_id,
              } = findIdSup
              const getUom = this.state.quotationList[keyUom].uom
              if (
                (event_item_supplier[key].event_supplier_id ===
                  event_supplier_id &&
                  allocate_type === qty &&
                  selected_amount > 0) ||
                (allocate_type === percent && selected_amount > 0)
              ) {
                if (allocate_type === qty && selected_amount > 0) {
                  const amountItem = this.funcFormatNumber(selected_amount)
                  return (
                    <Button
                      key={key}
                      className="theme-green is-bottom"
                      onClick={e => handlersClickEdit(e, id)}
                      disabled={
                        this.state.eventListHaveApprove ||
                        this.state.isHavingListEventOpen
                      }
                    >
                      Allocation {amountItem} {getUom}
                    </Button>
                  )
                } else if (allocate_type === percent && selected_amount > 0) {
                  return (
                    <Button
                      key={key}
                      className="theme-green is-bottom"
                      onClick={e => handlersClickEdit(e, id)}
                      disabled={
                        this.state.eventListHaveApprove ||
                        this.state.isHavingListEventOpen
                      }
                    >
                      Allocation {selected_amount} %
                    </Button>
                  )
                }
              }
            } else {
              const hideItemReject = event_item_supplier
                ? event_item_supplier[key].unit_price
                : ''
              const hideItemResponse = event_item_supplier
                ? event_item_supplier[key].response_status
                : ''
              if (
                hideItemReject !== '' &&
                hideItemResponse !== 'Rejected' &&
                hideItemReject !== 'RFQ Reject'
              ) {
                return (
                  <Button
                    key={key}
                    style={{ cursor: 'default' }}
                    className="theme-gray is-bottom"
                    disabled={true}
                  >
                    Select Item
                  </Button>
                )
              }
            }
          } else {
            const findIdSelect = find(setNoItemSelect, (value, index) => {
              const { id: idNoitem } = value
              if (idNoitem === id) return value
            })
            const rfqItemSupplier = findIdSelect
              ? findIdSelect.event_item_supplier
              : []
            const findIdSup = find(
              rfqItemSupplier,
              value => value.event_supplier_id === idSup
            )
            if (findIdSup) {
              const hideItemReject = event_item_supplier
                ? event_item_supplier[key].unit_price
                : ''
              const hideItemResponse = event_item_supplier
                ? event_item_supplier[key].response_status
                : ''
              if (
                hideItemReject !== '' &&
                hideItemResponse !== 'Rejected' &&
                hideItemReject !== 'RFQ Reject'
              ) {
                return (
                  <Button
                    key={key}
                    style={{ cursor: 'default' }}
                    className="theme-gray is-bottom"
                    disabled={true}
                  >
                    Select Item
                  </Button>
                )
              }
            } else {
              const hideItemReject = event_item_supplier
                ? event_item_supplier[key].unit_price
                : ''
              const hideItemResponse = event_item_supplier
                ? event_item_supplier[key].response_status
                : ''
              if (
                hideItemReject !== '' &&
                hideItemResponse !== 'Rejected' &&
                hideItemReject !== 'RFQ Reject'
              ) {
                return (
                  <Button
                    key={key}
                    className="theme-blue is-bottom"
                    disabled={
                      this.state.eventListHaveApprove ||
                      this.state.isHavingListEventOpen
                    }
                    onClick={e => {
                      if (e.detail === 1) {
                        return handlerOnClickSelectItem(
                          id,
                          event_item_supplier[key]
                        )
                      }
                    }}
                  >
                    Select Item
                  </Button>
                )
              }
            }
          }
        }
      }
    }
  }
  // func renderFuncButtonSelectItemAwa
  renderFuncButtonSelectItemAwa = (formData, event, key, keyUom) => {
    const textAccepted = 'Accepted'
    let {
      itemAction,
      quotationCheckBox,
      tempData,
      setDataInit,
      resultSelect,
      allowSupplierSelected,
      allocateItems,
      setNoItemSelect,
    } = this.state
    const { selectedBySupplier } = itemAction
    const { id, event_item_supplier, auction_item_supplier_response } = event
    const idSup =
      (event_item_supplier && event_item_supplier[key].event_supplier_id) ||
      (auction_item_supplier_response &&
        auction_item_supplier_response[key].auction_supplier_id)
    if (selectedBySupplier.length > 0) {
      const findIdButtonCheck = find(selectedBySupplier, (value, index) => {
        if (value.idItem === id && value.idSup === idSup) {
          return value
        }
      })
      const findIdSelect = find(setNoItemSelect, (value, index) => {
        const { id: idNoitem } = value
        if (idNoitem === id) return value
      })
      const rfqItemSupplier = findIdSelect
        ? findIdSelect.event_item_supplier ||
          findIdSelect.auction_item_supplier_response
        : []
      const findIdSupSelect = find(
        rfqItemSupplier,
        value => value.event_supplier_id === idSup
      )
      if (!isEmpty(findIdButtonCheck) && !findIdSupSelect) {
        // Select Item
        const hideItemReject = event_item_supplier
          ? event_item_supplier[key].unit_price
          : auction_item_supplier_response
          ? auction_item_supplier_response[key].unit_price
          : ''
        const hideItemResponse = event_item_supplier
          ? event_item_supplier[key].response_status
          : auction_item_supplier_response
          ? auction_item_supplier_response[key].response_status
          : ''

        let showByRole = false
        if (this.state.checkRole === rolesObj.tec) {
          showByRole = false
        } else {
          // isAPO = Role=> approver or purchaser or observer
          let isAPO = false
          let isTec = false
          if (this.state.checkMultiRole) {
            for (var i = 0; i < this.state.checkMultiRole.length; i++) {
              if (this.state.checkMultiRole[i].id === rolesObj.tec) {
                isTec = true
              }
              if (this.state.checkMultiRole[i].id === rolesObj.approver) {
                isAPO = true
              }
              if (this.state.checkMultiRole[i].id === rolesObj.purchaser) {
                isAPO = true
              }
              if (this.state.checkMultiRole[i].id === rolesObj.observer) {
                isAPO = true
              }
            }
          }
          if (isTec) {
            if (isAPO) {
              showByRole = true
            } else {
              showByRole = false
            }
          } else {
            showByRole = true
          }
        }

        if (
          findIdButtonCheck.action === 'checked' &&
          hideItemReject !== '' &&
          hideItemResponse !== 'Rejected' &&
          hideItemReject !== 'RFQ Reject' &&
          showByRole
        ) {
          return (
            <Text key={key} className="has-icon color-green">
              <Image
                src={ICONS['icon-check.svg']}
                alt="Image"
                className="icon-checked"
                style={{ marginRight: '10px' }}
              />
              Select Item
            </Text>
          )
        }
      } else {
        const findIdItem = find(allowSupplierSelected, (value, index) => {
          if (value.id === id) return value
        })
        if (findIdItem) {
          // Allocation Item
          const { qty, percent } = allowcateType
          const findIdSup = find(
            findIdItem.event_item_supplier,
            (value, index) => {
              const {
                event_supplier_id,
                allocate_type,
                selected_amount,
              } = value
              if (
                event_supplier_id === event_item_supplier[key].event_supplier_id
              ) {
                if (allocate_type === qty && selected_amount > 0) {
                  return value
                } else if (allocate_type === percent && selected_amount > 0) {
                  return value
                }
              }
            }
          )
          if (findIdSup) {
            const {
              allocate_type,
              selected_amount,
              event_supplier_id,
            } = findIdSup
            const getUom = this.state.quotationList[keyUom].uom
            if (
              (event_item_supplier[key].event_supplier_id ===
                event_supplier_id &&
                allocate_type === qty &&
                selected_amount > 0) ||
              (allocate_type === percent && selected_amount > 0)
            ) {
              if (allocate_type === qty && selected_amount > 0) {
                const amountItem = this.funcFormatNumber(selected_amount)
                return (
                  <Text key={key} className="has-icon color-green">
                    <Image
                      src={ICONS['icon-check.svg']}
                      alt="Image"
                      className="icon-checked"
                      style={{ marginRight: '10px' }}
                    />
                    Allocation {amountItem} {getUom}
                  </Text>
                )
              } else if (allocate_type === percent && selected_amount > 0) {
                return (
                  <Text key={key} className="has-icon color-green">
                    <Image
                      src={ICONS['icon-check.svg']}
                      alt="Image"
                      className="icon-checked"
                      style={{ marginRight: '10px' }}
                    />
                    Allocation {selected_amount} %
                  </Text>
                )
              }
            }
          }
        } else {
          // No Item Selections
          const findIdSelect = find(setNoItemSelect, (value, index) => {
            const { id: idNoitem } = value
            if (idNoitem === id) return value
          })
          const rfqItemSupplier = findIdSelect
            ? findIdSelect.event_item_supplier
            : []
          const findIdSup = find(
            rfqItemSupplier,
            value => value.event_supplier_id === idSup
          )
          if (findIdSup) {
            const hideItemReject = event_item_supplier
              ? event_item_supplier[key].unit_price
              : ''
            const hideItemResponse = event_item_supplier
              ? event_item_supplier[key].response_status
              : ''
            if (
              hideItemReject !== '' &&
              hideItemResponse !== 'Rejected' &&
              hideItemReject !== 'RFQ Reject'
            ) {
              return (
                <Text
                  key={key}
                  style={{
                    color: 'red',
                    fontWeight: '600',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginTop: 'auto',
                  }}
                >
                  No Item Selection
                </Text>
              )
            }
          }
        }
      }
    }
  }
  renderRFQItemSupplierResponse(event, formData, keyUom) {
    // show selections not role TEC
    const notRoleTec = this.funcCheckSelectionsRole()
    const { awardStatuses, rolesCheck, dataProject } = this.state
    const sealedCheck = formData.seal_status_name !== sealStatus.sealed
    const awaUnSealedCheck =
      formData.seal_status_name !== sealStatus.awaitingunseal
    const matchValueAwa = this.matchValue(
      awardStatuses,
      formData.rfq_award_status_id || formData.auction_award_status_id
    )
    const checkAwaSel = 'Awaiting Selection'
    const awaiting_approve = this.matchValue(
      awardStatuses,
      formData.rfq_award_status_id || formData.auction_award_status_id
    )
    const itemSupplierResponse =
      event.event_item_supplier || event.auction_item_supplier_response
    if (itemSupplierResponse) {
      return itemSupplierResponse.map((j, ji) => {
        const AllPrice = {
          average_price: j.average_price && parseFloat(j.average_price),
          budget_price: j.budget_price && parseFloat(j.budget_price),
          historical_price:
            j.historical_price && parseFloat(j.historical_price),
          market_price: j.market_price && parseFloat(j.market_price),
        }
        let arr = Object.values(AllPrice)
        const is_Green = Math.max(...arr)
        return (
          <td key={ji} className="supplier-name save-row">
            {formData.event_type_id === 2 && j.total_price === '0.00' ? (
              <></>
            ) : (
              <>
                <Section className="form-row">
                  {this.renderAveragePrice(j, formData, is_Green)}
                </Section>
                <Section className="form-row">
                  {this.renderBudgetPrice(j, formData, is_Green)}
                </Section>
                <Section className="form-row">
                  {this.renderHistoricalPrice(j, formData, is_Green)}
                </Section>
                <Section className="form-row">
                  {this.renderMarketPrice(j, formData, is_Green)}
                </Section>
              </>
            )}
            {this.renderNoteSeal(
              j,
              formData,
              is_Green,
              this.state.selectSuppliersRfq,
              ji
            )}
            {formData.seal_status_name === sealStatus.sealed ? (
              ''
            ) : (
              <>
                {j.event_supplier_item_file &&
                  j.event_supplier_item_file.map((file, indexFile) => {
                    return formData.seal_status_name != 'Awaiting Unseal' ? (
                      <Section className="attached-file-list" key={indexFile}>
                        <a
                          target="_blank"
                          className="file-link removable"
                          rel="noopener noreferrer"
                        >
                          <span
                            className="file-name"
                            onClick={() => {
                              this.downloadItemSupplier(file)
                            }}
                          >
                            {file.name}
                          </span>
                        </a>
                      </Section>
                    ) : (
                      ''
                    )
                  })}
              </>
            )}
            {sealedCheck &&
              awaUnSealedCheck &&
              matchValueAwa === checkAwaSel &&
              rolesCheck.roles !== 'approver' &&
              notRoleTec &&
              dataProject.project_status_id === 2 &&
              this.renderFuncButtonSelectItem(formData, event, ji, keyUom)}
            {(awaiting_approve === 'Awaiting Approve' ||
              awaiting_approve === 'Awarded' ||
              awaiting_approve === 'Rejected') &&
              dataProject.project_status_id === 2 &&
              this.renderFuncButtonSelectItemAwa(formData, event, ji, keyUom)}
          </td>
        )
      })
    }
  }

  renderTotal(quotationList, formData) {
    let totalList = []
    let isHaveReject = []
    let isNoRes = []
    let supplier = this.state.supplierList
    quotationList.map((e, i) => {
      let item = e.event_item_supplier || e.auction_item_supplier_response
      if (item) {
        item.map((j, ji) => {
          supplier.map(sup => {
            if (j.event_supplier_id === sup.id && i === 0) {
              if (
                sup.total_price !== 'N/A' &&
                ((formData.event_type_id === 1 && sup.total_price >= 0) ||
                  (formData.event_type_id === 2 && sup.total_price > 0)) &&
                // sup.response_status !== 'No response'
                sup.response_status === 'Accepted'
              ) {
                // if (totalList[ji]) {
                //   totalList[ji] = totalList[ji] + parseFloat(sup.total_price)
                // } else {
                //   totalList[ji] = parseFloat(sup.total_price)
                // }
                totalList.push({
                  total_price: parseFloat(sup.total_price),
                  isHaveRejectItem: sup.is_has_item_reject,
                  isNoResponse: sup.response_status,
                })
              }
            }
          })
          if (
            j.total_price &&
            j.total_price === 'N/A' &&
            // j.response_status !== 'Draft' &&
            // j.response_status !== 'Rejected'
            j.response_status === 'Accepted'
          ) {
            if (totalList[ji]) {
              isHaveReject[ji] = true
              // totalList[ji] = totalList[ji] + 0
              // ถ้า response_status เป็น Term and Condition แสดงว่าก็ No response เลยใส่เป็นว่าง / Accepted ก็ไม่ต้องมี !
              isNoRes[ji] =
                j.response_status.includes('Term') ||
                j.response_status.includes('Draft')
                  ? ''
                  : j.response_status
            } else {
              isHaveReject[ji] = true
              // totalList[ji] = 0
              isNoRes[ji] =
                j.response_status.includes('Term') ||
                j.response_status.includes('Draft')
                  ? ''
                  : j.response_status
            }
          }
        })

        // item.map((j, ji) => {
        //   if (
        //     j.event_supplier_total_price &&
        //     j.event_supplier_total_price !== 'N/A'
        //   ) {
        //     if (totalList[ji]) {
        //       totalList[ji] =
        //         totalList[ji] + parseFloat(j.event_supplier_total_price)
        //     } else {
        //       totalList[ji] = parseFloat(j.event_supplier_total_price)
        //     }
        //   } else {
        //     if (totalList[ji]) {
        //       isHaveReject[ji] = true
        //       totalList[ji] = totalList[ji] + 0
        //       // ถ้า response_status เป็น Term and Condition แสดงว่าก็ No response เลยใส่เป็นว่าง / Accepted ก็ไม่ต้องมี !
        //       isNoRes[ji] = j.response_status.includes('Term')
        //         ? ''
        //         : j.response_status
        //     } else {
        //       isHaveReject[ji] = true
        //       totalList[ji] = 0
        //       isNoRes[ji] = j.response_status.includes('Term')
        //         ? ''
        //         : j.response_status
        //     }
        //   }
        // })
      }
    })
    if (totalList.length > 0) {
      return (
        <React.Fragment>
          {totalList.map((e, i) => {
            return (
              <td key={i} className="supplier-name">
                <Section className="form-row">
                  <Section className="form-col col-9 bold textRightTotal">
                    {formData.seal_status_name === sealStatus.sealed ? (
                      <span></span>
                    ) : (
                      <>
                        {!isNaN(e.total_price)
                          ? Numeral(e.total_price).format('0,0.00')
                          : '-'}
                        <span style={{ color: 'red' }}>
                          {/* && parseInt(e) !== 0 */}
                          {/* {!isNoRes[i] ? '' : isHaveReject[i] && '!'} */}
                          {!e.isNoResponse ? '' : e.isHaveRejectItem && '!'}
                        </span>
                      </>
                    )}
                  </Section>
                </Section>
              </td>
            )
          })}
          {/* <td className="supplier-name"></td>
          <td className="supplier-name"></td> */}
        </React.Fragment>
      )
    }
    // else if (totalList.length === 2) {
    //   return (
    //     <React.Fragment>
    //       {totalList.map((e, i) => {
    //         return (
    //           <td key={i} className="supplier-name">
    //             <Section className="form-row">
    //               <Section className="form-col col-9 bold textRightTotal">
    //                 {formData.seal_status_name === sealStatus.sealed ? (
    //                   <span></span>
    //                 ) : (
    //                   <>
    //                     {!isNaN(e) ? Numeral(e).format('0,0.00') : '-'}
    //                     <span style={{ color: 'red' }}>
    //                       {!isNoRes[i] ? '' : isHaveReject[i] && '!'}
    //                     </span>
    //                   </>
    //                 )}
    //               </Section>
    //             </Section>
    //           </td>
    //         )
    //       })}
    //       <td className="supplier-name"></td>
    //     </React.Fragment>
    //   )
    // } else if (totalList.length > 2) {
    //   return (
    //     <React.Fragment>
    //       {totalList.map((e, i) => {
    //         return (
    //           <td key={i} className="supplier-name">
    //             <Section className="form-row">
    //               <Section className="form-col col-9 bold textRightTotal">
    //                 {formData.seal_status_name === sealStatus.sealed ? (
    //                   <span></span>
    //                 ) : (
    //                   <>
    //                     {!isNaN(e) ? Numeral(e).format('0,0.00') : '-'}
    //                     <span style={{ color: 'red' }}>
    //                       {!isNoRes[i] ? '' : isHaveReject[i] && '!'}
    //                     </span>
    //                   </>
    //                 )}
    //               </Section>
    //             </Section>
    //           </td>
    //         )
    //       })}
    //     </React.Fragment>
    //   )
    // }
  }

  renderSuppliersRfqSelect = () => {
    const { selectSuppliersRfq } = this.state
    return selectSuppliersRfq.map((sup, index) => {
      return (
        <Table.TR key={index + sup.TaxID}>
          <Table.TD className="no">{index + 1}</Table.TD>
          <Table.TD className="tax-id">{sup.TaxID}</Table.TD>

          <Table.TD className="company-name">{sup.CompanyName}</Table.TD>

          <Table.TD className="branch-number">
            {sup.Branch ? sup.Branch : 'Not Specify'}
          </Table.TD>

          <Table.TD className="vendor-code">{sup.VendorCode}</Table.TD>

          <Table.TD className="contact-name">{sup.ContactName}</Table.TD>

          <Table.TD className="email">{sup.ContactEmail}</Table.TD>

          <Table.TD className="phone">{sup.ContactPhone}</Table.TD>
        </Table.TR>
      )
    })
  }

  copyRfqByID = async () => {
    const { match } = this.props
    const { params } = match
    const { id: idProject, rfqid } = params
    // const linkCopy = `/sourcing-detail-form-buyer-cocr/${idProject}/${rfqid}`
    const linkCopy = `/sourcing-detail-form-buyer-cocr/${idProject}/${this.state.formData.event_id}`
    this.props.history.push(linkCopy)
  }

  renderButtonExport = (
    statusRfq,
    isCancel,
    sealStatus,
    rolesTec,
    rolesMulti,
    fromDataEx
  ) => {
    const renderExportBtn = () => {
      return (
        <Button
          className="page-button"
          onClick={() => this.downloadCompareToExcel(fromDataEx)}
        >
          <Image src={ICONS['icon-export-white.svg']} alt="export icon" />
          Export
        </Button>
      )
    }
    if (
      sealStatus !== '' &&
      statusRfq === 4 &&
      sealStatus !== 'Sealed' &&
      sealStatus !== 'Awaiting Unseal'
    ) {
      return <React.Fragment>{renderExportBtn()}</React.Fragment>
    } else if (
      sealStatus !== '' &&
      statusRfq === 5 &&
      sealStatus !== 'Sealed' &&
      sealStatus !== 'Awaiting Unseal'
    ) {
      return <React.Fragment>{renderExportBtn()}</React.Fragment>
    } else if (sealStatus == '' && statusRfq === 4) {
      return <React.Fragment>{renderExportBtn()}</React.Fragment>
    } else if (sealStatus == '' && statusRfq === 5) {
      return <React.Fragment>{renderExportBtn()}</React.Fragment>
    } else if (sealStatus == '' && isCancel === true) {
      return <React.Fragment>{renderExportBtn()}</React.Fragment>
    }
  }
  renderIconUnitPrice = (value, formData, status, keyIndex) => {
    const acceptedStatus = value.response_status
    const rfqReject = value.unit_price
    const textReject = 'RFQ Reject'
    const textRejectAuction = 'Auction Reject'
    const textAccepted = 'Accepted'
    if (
      // value.unit_price === textReject || textRejectAuction
      value.unit_price.includes('Reject') &&
      formData.seal_status_name !== sealStatus.sealed &&
      formData.seal_status_name !== sealStatus.awaitingunseal
    ) {
      return (
        <Section
          className={`form-col col-6 " ${
            value.unit_price.includes('Reject') &&
            value.response_status !== 'Draft' &&
            'average-price'
          } `}
        >
          {value.unit_price ? (
            value.unit_price.includes('Reject') ? (
              // value.unit_price
              'N/A'
            ) : (
              <>
                <div
                  className="cut-word"
                  data-tip
                  data-for={`${formData.id}-${value.unit_price}-unit-price`}
                >
                  {Numeral(value.unit_price).format('0,0.0000')}
                </div>
                <TooltipBuyer
                  id={`${formData.id}-${value.unit_price}-unit-price`}
                  toolTipText={Numeral(value.unit_price).format('0,0.0000')}
                />
              </>
            )
          ) : (
            'N/A'
          )}
        </Section>
      )
    } else {
      if (
        formData.seal_status_name === sealStatus.sealed ||
        formData.seal_status_name === sealStatus.awaitingunseal
      ) {
        if (
          value.unit_price.includes('Reject') &&
          acceptedStatus !== textAccepted
        ) {
          return (
            <Section
              className={`form-col col-6 " ${
                value.unit_price.includes('Reject') && 'average-price'
              } `}
            >
              {value.unit_price ? (
                value.unit_price.includes('Reject') ? (
                  // value.unit_price
                  'N/A'
                ) : (
                  <>
                    <div
                      className="cut-word"
                      data-tip
                      data-for={`${formData.id}-${value.unit_price}-unit-price`}
                    >
                      {Numeral(value.unit_price).format('0,0.0000')}
                    </div>
                    <TooltipBuyer
                      id={`${formData.id}-${value.unit_price}-unit-price`}
                      toolTipText={Numeral(value.unit_price).format('0,0.0000')}
                    />
                  </>
                )
              ) : (
                'N/A'
              )}
            </Section>
          )
        } else {
          return (
            <Section className={`form-col col-6`}>
              <span></span>
            </Section>
          )
        }
      } else {
        return (
          <React.Fragment>
            <Section
              className={`form-col col-6 " ${
                value.unit_price.includes('Reject') && 'average-price'
              } `}
            >
              {value.unit_price ? (
                value.unit_price.includes('Reject') ? (
                  // value.unit_price
                  'N/A'
                ) : (
                  <>
                    <div
                      className="cut-word"
                      data-tip
                      data-for={`${formData.id}-${value.unit_price}-unit-price`}
                    >
                      {Numeral(value.unit_price).format('0,0.0000')}
                    </div>
                    <TooltipBuyer
                      id={`${formData.id}-${value.unit_price}-unit-price`}
                      toolTipText={Numeral(value.unit_price).format('0,0.0000')}
                    />
                  </>
                )
              ) : (
                'N/A'
              )}
            </Section>
          </React.Fragment>
        )
      }
    }
  }
  renderIconTotalPrice = (value, formData, status, keyIndex) => {
    const acceptedStatus = value.response_status
    const rfqReject = value.unit_price
    const textReject = 'RFQ Reject'
    const textRejectAuction = 'Auction Reject'
    const textAccepted = 'Accepted'
    if (
      // value.unit_price === textReject || textRejectAuction
      value.unit_price.includes('Reject') &&
      value.response_status !== 'Draft' &&
      formData.seal_status_name !== sealStatus.sealed &&
      formData.seal_status_name !== sealStatus.awaitingunseal
    ) {
      return (
        <Section
          className={`form-col col-6 bold ${
            value.total_price === 'N/A' && 'average-price'
          } `}
        >
          {value.total_price
            ? value.total_price == 'N/A'
              ? value.total_price
              : Numeral(value.total_price).format('0,0.00')
            : 'N/A'}
        </Section>
      )
    } else {
      if (
        formData.seal_status_name === sealStatus.sealed ||
        formData.seal_status_name === sealStatus.awaitingunseal
      ) {
        if (
          value.unit_price.includes('Reject') &&
          acceptedStatus !== textAccepted
        ) {
          return (
            <Section
              className={`form-col col-6 bold ${
                value.total_price === 'N/A' && 'average-price'
              } `}
            >
              {value.total_price ? (
                value.total_price == 'N/A' ? (
                  value.total_price
                ) : (
                  <>
                    <div
                      className="cut-word"
                      data-tip
                      data-for={`${formData.id}-${value.total_price}-total-price`}
                    >
                      {Numeral(value.total_price).format('0,0.00')}
                    </div>
                    <TooltipBuyer
                      id={`${formData.id}-${value.total_price}-total-price`}
                      toolTipText={Numeral(value.total_price).format('0,0.00')}
                    />
                  </>
                )
              ) : (
                'N/A'
              )}
            </Section>
          )
        } else {
          return (
            <Section className={`form-col col-6 bold`}>
              <span></span>
            </Section>
          )
        }
      } else {
        return (
          <React.Fragment>
            <Section
              className={`form-col col-6 bold ${
                value.total_price === 'N/A' && 'average-price'
              } `}
            >
              {value.total_price && value.total_price !== 'N/A' ? (
                formData.event_type_id === 2 && value.total_price === '0.00' ? (
                  'N/A'
                ) : (
                  <>
                    <div
                      className="cut-word"
                      data-tip
                      data-for={`${formData.id}-${value.total_price}-total-price`}
                    >
                      {Numeral(value.total_price).format('0,0.00')}
                    </div>
                    <TooltipBuyer
                      id={`${formData.id}-${value.total_price}-total-price`}
                      toolTipText={Numeral(value.total_price).format('0,0.00')}
                    />
                  </>
                )
              ) : (
                'N/A'
              )}
            </Section>
          </React.Fragment>
        )
      }
    }
  }
  renderRequestUnsealButton = () => {
    const handleOnClick = e => {
      this.fetchTecContacts('', 1, true)
      return this.toggleModal('request-unseal')
    }
    const renderButtonReqUnseal = () => {
      /* filter aw <= 1 */
      const { dataInitTableTec } = this.state
      const result = dataInitTableTec.filter(
        value =>
          (value.request_status === 'Awaiting submit' ||
            value.request_status === '') &&
          value.request_at === ''
      )
      const handleOnClick = e => {
        return this.toggleModal('confirm-request-unseal')
      }
      return (
        <React.Fragment>
          {result.length >= 1 ? (
            <Button
              onClick={handleOnClick}
              className="theme-blue"
              style={{ width: '180px' }}
            >
              Request to Unseal
            </Button>
          ) : (
            ''
          )}
        </React.Fragment>
      )
    }
    return (
      <React.Fragment>
        <Section className="form-actions" style={{ marginBottom: '1em' }}>
          <Section className="button-group">
            <Button onClick={handleOnClick} className="theme-blue">
              Add TEC
            </Button>
            {renderButtonReqUnseal()}
          </Section>
        </Section>
      </React.Fragment>
    )
  }
  goToSourcing = () => {
    setTimeout(() => {
      this.props.history.push(ROUTE_PATH.SOURCING_BUYER.LINK)
      this._clicksOneReqSubmit = 0
    }, 800)
  }
  funcOpenModalConfirm = value => {
    const { dataInitTableTec } = this.state
    if (value === 'save data') {
      if (this._isMounted) {
        this.setState({ modalSave: 'save data' })
      }
      this.toggleModal()
    } else if (value === false) {
      if (this._isMounted) {
        this.setState({ modalSave: false })
      }
      this.toggleModal()
    } else if (value === 'request-unseal') {
      this.toggleModal()
    } else if (value === 'submit') {
      const { match } = this.props
      const { id, rfqid } = match.params
      this._clicksOneReqSubmit += 1
      const result = dataInitTableTec.filter(
        value =>
          (value.request_status === 'Awaiting submit' ||
            value.request_status === '') &&
          value.request_at === ''
      )
      if (result) {
        const funcPostApi = async () => {
          const dataResult = {
            rfq_id: rfqid ? rfqid : '',
            tec_request: [],
          }
          result.map((value, index) => {
            const data = {
              id: value.rfq_buyer_seal_id ? value.rfq_buyer_seal_id : '',
              buyer_id: value.id,
              is_request: true,
            }
            dataResult.tec_request.push(data)
          })
          if (this._clicksOneReqSubmit === 1) {
            const res = await rfqController().createRequestUnseal(dataResult)
            if (res) {
              this.toggleModal()
              const { data } = res
              switch (data.code) {
                case 41102: {
                  this.notifyError(`Some user isn't TEC`)
                  this._clicksOneReqSubmit = 0
                  return store.dispatch(sendApiRequestUnseal(''))
                }
                case 41103: {
                  this.notifyError(`Some user isn't active`)
                  this._clicksOneReqSubmit = 0
                  return store.dispatch(sendApiRequestUnseal(''))
                }
                case 41104: {
                  this.notifyError(`Some user was deleted`)
                  this._clicksOneReqSubmit = 0
                  return store.dispatch(sendApiRequestUnseal(''))
                }
                default: {
                  this.goToSourcing()
                  return store.dispatch(sendApiRequestUnseal(data.message))
                }
              }
            } else {
              this._clicksOneReqSubmit = 0
              this.toggleModal()
            }
          }
        }
        funcPostApi()
      }
    }
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    const { match } = this.props
    const { id, rfqid } = match.params
    if (prevState.modals !== this.state.modals) {
      // openModalConfirm
      const { modals } = this.state
      const result = modals.filter(
        modal => modal.name === 'confirm-request-unseal'
      )
      if (result) {
        if (this._isMounted) {
          this.setState({ modalsOpenConfirm: result[0].isOpen })
        }
      }
    }
  }
  componentWillUnmount() {
    this._isMounted = false
    document
      .getElementById('sourcing_request_unseal')
      .removeEventListener('scroll', this._handleScroll)
  }

  _handleScroll() {
    const offsetTrigger = 1
    const docElm = document.getElementById('sourcing_request_unseal')
    const scrollBottom =
      docElm.scrollHeight - (docElm.scrollTop + docElm.clientHeight)
    if (scrollBottom > offsetTrigger) {
      this.isScrollBottom = false
    } else if (scrollBottom < offsetTrigger && !this.isScrollBottom) {
      this.isScrollBottom = true
      this._onScrollBottom()
    }
  }

  _onScrollBottom() {
    const { paginationTecContacts } = this.state
    if (paginationTecContacts.page !== paginationTecContacts.next_page) {
      this.fetchTecContacts(
        paginationTecContacts.search,
        paginationTecContacts.next_page,
        false
      )
    }
  }

  renderTimeOut = time => {
    if (time.end_date) {
      return (
        <Countdown
          date={time.end_date}
          renderer={({ days, hours, minutes, seconds }) => {
            return (
              <span>
                {days} Days : {hours} Hours : {minutes} Minutes : {''}
                {seconds} Seconds
              </span>
            )
          }}
        />
      )
    }
  }
  handlerCancelEventTimeOUt = e => {
    const funcToastEventTimeOut = message => {
      const funcMessage = () => {
        if (message) {
          return message
        } else {
          return 'Awaiting Event Status Update'
        }
      }
      const textToast = funcMessage()
      return toast(textToast, {
        onClose: () => {
          window.location.reload()
        },
        toastId: textToast,
        position: 'top-center',
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        type: 'error',
      })
    }
    if (e.detail === 1) {
      return funcToastEventTimeOut()
    }
  }
  renderCancelEvent = (formData, statusRFQ) => {
    const { eventType } = this.props.match.params

    const renderButtonCancelEvent = () => {
      const { checkRole, checkMultiRole, dataProject } = this.state
      const { created_by_id } = dataProject
      const buyerId = localStorage.getItem('buyerId')
      const createby = created_by_id ? created_by_id.toString() : ''
      const isCreate = buyerId === createby ? true : false
      const purchaserMultiRole = find(checkMultiRole, data => {
        return data.id === rolesObj.purchaser
      })
      const renderButtonCancelEvent = () => {
        return (
          <Button
            className="theme-red"
            onClick={() => {
              this.toggleModal('cancelevent')
            }}
          >
            Cancel Event
          </Button>
        )
      }
      if (
        (checkRole === rolesObj.admin ||
          checkRole === rolesObj.systemadmin ||
          checkRole === rolesObj.purchaser) &&
        isCreate
      ) {
        return renderButtonCancelEvent()
      } else {
        if (purchaserMultiRole && isCreate) {
          return renderButtonCancelEvent()
        }
      }
    }
    if (
      Number(eventType) === 1 &&
      ((statusRFQ === 2 && !formData.is_cancel) ||
        (statusRFQ === 3 && !formData.is_cancel))
    ) {
      return renderButtonCancelEvent()
    }
    // Auction Cancel ได้แค่ Awaiting Open
    if (Number(eventType) === 2 && statusRFQ === 2 && !formData.is_cancel) {
      return renderButtonCancelEvent()
    }
  }
  renderModalCancelEvent = end_date => {
    const {
      supplierList,
      quotationDetail,
      checkAllSupplier,
      quotationList,
      modals,
      activeStep,
      statusRFQ,
      isErrOther,
      newScheduleDate,
      cancelReasonValue,
      formData,
      cancelReasonText,
      cancelReason,
      isErrMsgEndDate,
      isErrMsgReasonValue,
      isErrMsgReasonText,
    } = this.state
    const getRoleLocal = localStorage.getItem('roleUser')
    const getRoleLocalMulti = localStorage.getItem('roleUserMulti')
    let hideRoleTec = null
    let hideRoleTecMulti = null
    if (getRoleLocal) {
      hideRoleTec = parseInt(getRoleLocal, 10)
    } else {
      const dataRoleMulti = JSON.parse(getRoleLocalMulti)
      const idRoleTec = 10
      const someArrayCheckRole = element => {
        return element.id !== idRoleTec
      }
      hideRoleTecMulti = dataRoleMulti
        ? dataRoleMulti.some(someArrayCheckRole)
        : null
    }
    this.step1Content()
    this.step2Content()
    this.step3Content()
    const funcToastEventTimeOut = message => {
      const funcMessage = () => {
        if (message) {
          return message
        } else {
          return 'Awaiting Event Status Update'
        }
      }
      const textToast = funcMessage()
      return toast(textToast, {
        onClose: () => {
          window.location.reload()
        },
        toastId: textToast,
        position: 'top-center',
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        type: 'error',
      })
    }
    const funcRenderer = ({ days, hours, minutes, seconds, completed }) => {
      return (
        <Modal
          className="theme-blue modal-cancel-event"
          isOpen={
            modals
              .filter(modal => {
                return modal.name === 'cancelevent'
              })
              .map(obj => obj.isOpen)[0]
          }
          modalWidth="768px"
        >
          <Modal.Header>Cancel Event</Modal.Header>

          <Modal.Body>
            <Section className="form-group">
              <label>Event No:</label>
              <Section className="form-group-control">
                <Section className="form-group-inner-wrapper text">
                  {formData.event_no}
                </Section>
              </Section>
            </Section>

            <Section className="form-group">
              <label>Event Name:</label>
              <Section className="form-group-control">
                <Section className="form-group-inner-wrapper text">
                  {formData.name}
                </Section>
              </Section>
            </Section>

            <Section
              className={`form-group ${isErrMsgReasonValue && 'is-error'}`}
            >
              <label>Reason:</label>
              <Section className="form-group-control">
                <Section className="form-group-inner-wrapper">
                  <SelectBox
                    className="select-reason"
                    value={cancelReasonValue}
                    options={cancelReason}
                    isSearchable={false}
                    placeholder="Select"
                    onChange={e => {
                      if (this._isMounted) {
                        this.setState({
                          cancelReasonValue: e,
                          isErrMsgReasonValue: '',
                        })
                      }
                      this.setState({
                        isErrOther: false,
                      })
                    }}
                  />
                </Section>

                <Section className="message">
                  {isErrMsgReasonValue && 'Please specify reason'}
                </Section>
              </Section>
            </Section>
            <Section className={`form-group ${isErrOther && 'is-error'}`}>
              <label></label>
              <Section className="form-group-control">
                {cancelReasonValue ? (
                  cancelReasonValue.label ===
                  'Other, please specify - อื่นๆ กรุณาระบุ' ? (
                    <Section className="form-group-inner-wrapper">
                      <InputTextarea
                        onChange={e => {
                          const cancelReasonTextvalue = e.target.value
                          this.setState({
                            cancelReasonText: cancelReasonTextvalue,
                          })
                        }}
                      ></InputTextarea>
                    </Section>
                  ) : null
                ) : null}
                <Section className="message">
                  {isErrOther && STRING.INVALID}
                </Section>
              </Section>
            </Section>
          </Modal.Body>

          <Modal.Footer>
            <Button
              id=""
              className="theme-gray close"
              onClick={() => {
                if (this._isMounted) {
                  this.setState(
                    {
                      isErrMsgReasonValue: '',
                      isErrMsgReasonText: '',
                      cancelReasonText: '',
                      isErrOther: false,
                      cancelReasonValue: null,
                    },
                    this.toggleModal()
                  )
                }
              }}
            >
              Cancel
            </Button>

            <Button
              id=""
              className="theme-green save"
              onClick={e => {
                if (e.detail === 1) {
                  if (completed) {
                    return funcToastEventTimeOut()
                  } else {
                    if (cancelReasonValue === null) {
                      this.setState({
                        isErrMsgReasonValue: true,
                      })
                    } else {
                      if (cancelReasonValue.value === 5) {
                        if (cancelReasonText === '') {
                          this.setState({
                            isErrOther: true,
                          })
                        } else {
                          this.setState({
                            isErrOther: false,
                          })
                          return this.OnCancelEvent()
                        }
                      } else {
                        return this.OnCancelEvent()
                      }
                    }
                  }
                }
              }}
            >
              Confirm
            </Button>
          </Modal.Footer>
        </Modal>
      )
    }
    if (
      (statusRFQ === 2 && !formData.is_cancel) ||
      (statusRFQ === 3 && !formData.is_cancel)
    ) {
      if (end_date) {
        try {
          return <Countdown date={end_date} renderer={funcRenderer} />
        } catch (error) {
          console.log(error)
        }
      }
    }
  }
  funcOpenModalInformation(result) {
    let { setDataInit, errorSelect, resultSelect } = this.state
    const {
      filterQuotaSelected,
      filterCheckBox,
      totalNumberSelect,
      totalNumberQty,
      totalNumberPercent,
    } = result
    const { qty, percent } = allowcateType
    const itemMax = 'MAX'
    const { rfqid } = this.props.match.params
    const sendsApi = async (itemMax = '') => {
      // const resFilter = [filterQuotaSelected]
      // const filterData = map(resFilter, (value, index) => {
      //   const { event_item_supplier } = value
      //   console.log('supplier_id', event_item_supplier)
      //   const filterRfq = filter(event_item_supplier, (value, index) => {
      //     const { selected_amount } = value
      //     // value.rfq_supplier_id = value.event_supplier_id
      //     if (selected_amount > 0) return value
      //   })
      //   console.log
      //   return {
      //     // ...value,
      //     id: value.id,
      //     selected_type: value.selected_type,
      //     // rfq_id: this.state.idRFQ,
      //     allocate_type: filterCheckBox.checkType,
      //     // event_item_supplier: filterRfq,
      //     suppliers: filterRfq,
      //     // rfq_item_supplier_response: filterRfq,
      //   }
      // })
      let filterRfq = []
      const filterData = map(
        filterQuotaSelected.event_item_supplier,
        (value, index) => {
          const { selected_amount } = value
          if (selected_amount > 0) {
            filterRfq.push(value)
          }
          // })
        }
      )
      const allocateData = {
        // ...value,
        id: filterQuotaSelected.id,
        selected_type: filterQuotaSelected.selected_type,
        rfq_id: this.state.idRFQ,
        allocate_type: filterCheckBox.checkType,
        // event_item_supplier: filterRfq,
        suppliers: filterRfq,
        // rfq_item_supplier_response: filterRfq,
      }
      try {
        console.log('selection Supplier 6 : Allocate Items')
        // const res = await rfqController().selectionSupplier(filterData)
        const res = await eventNewController().selectionSupplier(
          this.state.event_id,
          allocateData
        )
        if (res) {
          if (res.data && res.data.status === 'error') {
            toastFail('Allocate Items Error')
          } else {
            // this.getItemCompare(
            //   this.state.supplierList,
            //   this.state.event_id,
            //   this.state.activePage
            // )
            this.funcGetSupplierSelected(res)
            this.setTypeCheckBoxSelected(res)
            this.funcGetNoItemsSelect(res)
            this.funcGetSavingType()
            errorSelect = []
            resultSelect = []
            setDataInit = res
            this.getItemCompare(
              this.state.supplierList,
              this.state.event_id,
              this.state.activePage
            )
            if (this._isMounted) {
              this.setState({
                setDataInit,
                errorSelect,
                resultSelect,
                totalNumberSelect: 0,
              })
              setTimeout(() => {
                this.getApprovalWorkflow(rfqid)
              }, 800)
            }
          }
          if (itemMax) {
            return this.toggleModal()
          }
          // this.toggleModal()
        }
      } catch (error) {
        console.log(error)
      }
    }
    if (filterQuotaSelected) {
      if (filterCheckBox.checkType === qty) {
        if (totalNumberSelect < totalNumberQty) {
          this.toggleModal('items-information')
          return sendsApi()
        } else {
          return sendsApi(itemMax)
        }
      } else if (filterCheckBox.checkType === percent) {
        if (totalNumberSelect < totalNumberPercent) {
          this.toggleModal('items-information')
          return sendsApi()
        } else {
          return sendsApi(itemMax)
        }
      }
    }
  }
  modalItemsNotFully() {
    const { modals } = this.state
    const handlersClose = () => {
      this.toggleModal()
    }
    return (
      <Modal
        className="theme-blue modal-information"
        isOpen={
          modals
            .filter(modal => {
              return modal.name === 'items-information'
            })
            .map(obj => obj.isOpen)[0]
        }
        modalWidth="575px"
      >
        <Modal.Header>Infomation</Modal.Header>
        <Modal.Body>
          <p className="default text-center">Items are not fully allocated.</p>
        </Modal.Body>
        <Modal.Footer>
          <Button
            id="close_modal_history_id"
            className="theme-border-gray"
            onClick={handlersClose}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    )
  }
  renderModalAllowSelect() {
    let {
      modals,
      allocateItems,
      resultCheckBoxSelected,
      setDataInit,
      quotaSelected,
      errorSelect,
      resultSelect,
      totalNumberSelect,
    } = this.state
    const { eventType } = this.props.match.params
    const handlerClickCancel = e => {
      e.preventDefault()
      errorSelect = []
      resultSelect = []
      totalNumberSelect = 0
      this.setQuotaSelected(setDataInit)
      this.setTypeCheckBoxSelected(setDataInit)
      this.setState({ errorSelect, resultSelect, totalNumberSelect })
      return this.toggleModal()
    }
    if (!isEmpty(allocateItems)) {
      const {
        name,
        description,
        rfq_buyer_item_file,
        event_item_file,
        auction_buyer_item_file,
        req_amount,
        event_item_supplier,
        auction_item_supplier_response,
        id,
        uom,
      } = allocateItems
      const { qty, percent } = allowcateType
      const numberFloat = this.funcFormatNumber(req_amount)
      const totalNumberQty = Number(req_amount)
      const totalNumberPercent = 100
      let filterCheckBox = find(resultCheckBoxSelected, (value, index) => {
        if (id === value.idItem && value.checkType === qty) {
          return value
        } else if (id === value.idItem && value.checkType === percent) {
          return value
        } else {
          return value
        }
      })
      let filterQuotaSelected = find(quotaSelected, (value, index) => {
        if (id === value.id) {
          return value
        }
      })
      let mapSupCheckBox
      if (Number(eventType) === 1) {
        mapSupCheckBox = map(
          filterQuotaSelected.event_item_supplier,
          (rfqSupValue, rfqIndex) => {
            return {
              ...rfqSupValue,
              allocate_type: filterCheckBox.checkType,
            }
          }
        )
        filterQuotaSelected.event_item_supplier = mapSupCheckBox
      }
      if (Number(eventType) === 2) {
        mapSupCheckBox = map(
          filterQuotaSelected.auction_item_supplier_response,
          (rfqSupValue, rfqIndex) => {
            return {
              ...rfqSupValue,
              allocate_type: filterCheckBox.checkType,
            }
          }
        )
        filterQuotaSelected.auction_item_supplier_response = mapSupCheckBox
      }

      let arraySupPush = []
      const funcRenderInput = (supplier_id, key) => {
        const { checkType } = filterCheckBox
        const {
          event_item_supplier,
          auction_item_supplier_response,
        } = filterQuotaSelected

        const item_supplier_response =
          event_item_supplier || auction_item_supplier_response

        const findSupData = find(item_supplier_response, (value, index) => {
          if (value.event_supplier_id === supplier_id) return value
          if (value.auction_supplier_id === supplier_id) return value
        })

        const errorInput = find(errorSelect, (value, index) => {
          if (
            Number(eventType) === 1 &&
            supplier_id === value.event_supplier_id
          )
            return value
          if (
            Number(eventType) === 2 &&
            supplier_id === value.auction_supplier_id
          )
            return value
        })
        const morethan =
          errorInput && ['morethan'].every(prop => prop in errorInput)
        const hasNotmorethan =
          errorInput && ['notmorethan'].every(prop => prop in errorInput)
        const onChangeNumberFormat = e => {
          const numberTotal = e.target.value.replace(',', '')
          if (e.target.value !== '.') {
            findSupData.selected_amount = Number(numberTotal)
          } else if (e.target.value === '.') {
            findSupData.selected_amount = 0
            this.forceUpdate()
          } else {
            findSupData.selected_amount = Number(numberTotal)
          }
          findSupData.allocate_type = filterCheckBox.checkType
          arraySupPush.push(findSupData)
        }
        return (
          <NumberFormat
            // placeholder={findSupData.allocate_type === qty ? 'QTY' : '%'}
            allowedDecimalSeparators={['.']}
            value={
              findSupData
                ? findSupData.allocate_type === qty ||
                  findSupData.allocate_type === percent
                  ? findSupData.selected_amount
                  : 0
                : 0
            }
            decimalScale={2}
            allowNegative={false}
            customInput={Input}
            isAllowed={values => {
              const { value, floatValue } = values
              if (
                typeof floatValue === 'undefined' ||
                typeof value === 'undefined'
              ) {
                return true
              }
              if (value.charAt(0) === '0') {
                if (value.charAt(1) && value.charAt(1) != '.') {
                  return false
                }
              }
              return true
            }}
            id={`${
              errorInput
                ? (errorInput.event_supplier_id === supplier_id ||
                    errorInput.auction_supplier_id === supplier_id) &&
                  errorInput.index === key &&
                  morethan &&
                  errorInput.morethan
                  ? checkType === qty && totalNumberSelect > totalNumberQty
                    ? 'selected-qty-err'
                    : checkType === percent &&
                      totalNumberSelect > totalNumberPercent
                    ? 'selected-qty-err'
                    : 'selected-qty'
                  : 'selected-qty'
                : 'selected-qty'
            }`}
            isHorizontal
            onChange={onChangeNumberFormat}
            className="foo"
            thousandSeparator={true}
            fixedDecimalScale={true}
          />
        )
      }
      if (arraySupPush.length !== 0) {
        if (Number(eventType) === 1) {
          filterQuotaSelected.event_item_supplier = arraySupPush
        }
        if (Number(eventType) === 2) {
          filterQuotaSelected.auction_item_supplier_response = arraySupPush
        }
      }
      const funcRenderContentSelected = () => {
        let countNo = 0
        let filterItemSup
        if (Number(eventType) === 1) {
          filterItemSup = filter(event_item_supplier, value => {
            if (
              value.unit_price !== '' &&
              value.unit_price !== 'RFQ Reject' &&
              value.response_status !== 'Rejected'
            ) {
              return value
            }
          })
        }
        if (Number(eventType) === 2) {
          filterItemSup = filter(auction_item_supplier_response, value => {
            if (
              value.unit_price !== '' &&
              value.unit_price !== 'Auction Reject' &&
              value.response_status !== 'Rejected'
            ) {
              return value
            }
          })
        }
        return map(filterItemSup, (value, key) => {
          const {
            supplier_company_name,
            unit_price,
            event_supplier_id,
            auction_supplier_id,
            response_status,
          } = value
          const valueUitPrice = this.funcFormatNumber(unit_price, 4)
          countNo += 1
          const rejected = 'Rejected'
          const accepted = 'Accepted'
          return (
            <Table.TR key={key}>
              <Table.TD className="create-date" style={{ flex: '0 0 5%' }}>
                {countNo}
              </Table.TD>
              <Table.TD className="detail" style={{ flex: '0 0 40%' }}>
                <Text
                  tootipValue={supplier_company_name}
                  useTootipFor="sourcing-name"
                  useTootip={true}
                >
                  {supplier_company_name}
                </Text>
              </Table.TD>
              <Table.TD style={{ flex: '0 0 27.5%', textAlign: 'right' }}>
                {valueUitPrice}
              </Table.TD>
              <Table.TD
                className="selected-qty-td"
                style={{ flex: '0 0 27.5%', textAlign: 'center' }}
              >
                {response_status !== rejected ||
                unit_price !== '' ||
                unit_price !== 'Reject' ? (
                  funcRenderInput(event_supplier_id || auction_supplier_id, key)
                ) : (
                  <Input isDisable />
                )}
              </Table.TD>
            </Table.TR>
          )
        })
      }
      const renderFuncSupSelected = () => {
        return (
          <Section className="table-header-freeze-wrapper">
            <Table className="history-log-data header-freeze">
              <Table.TBODY>
                <Table.TR>
                  <Table.TH style={{ flex: '0 0 5%' }} className="create-date">
                    NO.
                  </Table.TH>
                  <Table.TH style={{ flex: '0 0 40%' }} className="detail">
                    SUPPLIER
                  </Table.TH>
                  <Table.TH
                    style={{ flex: '0 0 27.5%', justifyContent: 'right' }}
                    className="action"
                  >
                    UNIT PRICE {`(${this.state.formData.currency})`}
                  </Table.TH>
                  <Table.TH
                    style={{ flex: '0 0 27.5%', justifyContent: 'center' }}
                    className="action"
                  >
                    QUOTA
                  </Table.TH>
                </Table.TR>
              </Table.TBODY>
            </Table>
            <div className="style-table">
              <Table className="history-log-data split-row-color">
                <Table.TBODY>{funcRenderContentSelected()}</Table.TBODY>
              </Table>
            </div>
          </Section>
        )
      }
      const funcSelectedAmount = () => {
        const mapDataAmount = map(
          filterQuotaSelected.event_item_supplier,
          (value, index) => {
            return {
              ...value,
              selected_amount: 0,
            }
          }
        )
        return mapDataAmount
      }
      const renderFuncCheckBox = () => {
        const handlerCheckboxQty = e => {
          filterQuotaSelected.event_item_supplier = funcSelectedAmount()
          filterCheckBox.check = true
          filterCheckBox.checkType = qty
          if (this._isMounted) {
            resultCheckBoxSelected = [
              filterCheckBox,
              ...this.state.resultCheckBoxSelected,
            ]
            this.setState({
              resultCheckBoxSelected,
            })
          }
        }
        const handlerCheckboxPercent = e => {
          filterQuotaSelected.event_item_supplier = funcSelectedAmount()
          filterCheckBox.check = false
          filterCheckBox.checkType = percent
          if (this._isMounted) {
            resultCheckBoxSelected = [
              filterCheckBox,
              ...this.state.resultCheckBoxSelected,
            ]
            this.setState({
              resultCheckBoxSelected,
            })
          }
        }
        return (
          <React.Fragment>
            <Section className="form-group" style={{ alignItems: 'center' }}>
              <Checkbox
                id="checkboxQty"
                value="checkboxQty"
                type="radio"
                style={{ maxWidth: '25px' }}
                name="checkboxQty"
                checked={filterCheckBox.check}
                onChange={handlerCheckboxQty}
              />
              <span
                style={{
                  justifyContent: 'flex-start',
                  marginRight: '10px',
                  marginTop: '4px',
                }}
              >
                Quantity
              </span>
              <Checkbox
                id="checkboxPercent"
                value="checkboxPercent"
                type="radio"
                style={{ maxWidth: '25px' }}
                name="checkboxPercent"
                checked={!filterCheckBox.check}
                onChange={handlerCheckboxPercent}
              />
              <span
                style={{
                  justifyContent: 'flex-start',
                  marginRight: '10px',
                  marginTop: '4px',
                }}
              >
                Percentage (%)
              </span>
            </Section>
          </React.Fragment>
        )
      }
      const handlerSaveSelected = e => {
        if (e.detail === 1) {
          let countTotalNumber = 0
          const mapValue = map(
            filterQuotaSelected.event_item_supplier,
            (value, index) => {
              const { selected_amount } = value
              const selectedAmount =
                selected_amount === '' ? 0 : selected_amount
              const { checkType } = filterCheckBox
              countTotalNumber += selectedAmount
            }
          )
          errorSelect = []
          resultSelect = []
          const mapValueCheck = map(
            filterQuotaSelected.event_item_supplier,
            (value, index) => {
              const { selected_amount, event_supplier_id, supplier_id } = value
              const selectedAmount =
                selected_amount === '' ? 0 : selected_amount
              const { checkType } = filterCheckBox
              if (checkType === qty) {
                if (countTotalNumber > totalNumberQty) {
                  if (selected_amount > totalNumberQty) {
                    const obj = {
                      event_supplier_id,
                      supplier_id,
                      morethan: true,
                      index,
                    }
                    errorSelect.push(obj)
                  }
                  if (selected_amount > 0) {
                    const obj = {
                      event_supplier_id,
                      supplier_id,
                      morethan: true,
                      index,
                    }
                    errorSelect.push(obj)
                  }
                } else if (countTotalNumber <= totalNumberQty) {
                  const obj = {
                    event_supplier_id,
                    done: true,
                    supplier_id,
                    // rfq_supplier_id: event_supplier_id,
                  }
                  resultSelect.push(obj)
                }
              } else if (checkType === percent) {
                if (countTotalNumber > totalNumberPercent) {
                  if (selected_amount > totalNumberQty) {
                    const obj = {
                      event_supplier_id,
                      supplier_id,
                      morethan: true,
                      index,
                    }
                    errorSelect.push(obj)
                  }
                  if (selected_amount > 0) {
                    const obj = {
                      event_supplier_id,
                      supplier_id,
                      morethan: true,
                      index,
                    }
                    errorSelect.push(obj)
                  }
                } else if (countTotalNumber <= totalNumberPercent) {
                  const obj = {
                    event_supplier_id,
                    done: true,
                    supplier_id,
                    // rfq_supplier_id: event_supplier_id,
                  }
                  resultSelect.push(obj)
                }
              }
            }
          )
          totalNumberSelect = countTotalNumber
          if (errorSelect.length !== 0) {
            resultSelect = []
            if (this._isMounted) {
              this.setState({ errorSelect, resultSelect, totalNumberSelect })
            }
          } else if (resultSelect.length !== 0) {
            if (totalNumberSelect === 0) {
              return toastFail('Please fill out the items')
            } else {
              errorSelect = []
              const result = {
                filterQuotaSelected,
                filterCheckBox,
                totalNumberSelect,
                totalNumberQty,
                totalNumberPercent,
              }
              this.funcOpenModalInformation(result)
              this.setState({ resultSelect, errorSelect, totalNumberSelect })
            }
          }
        }
      }
      const renderAttachmentFile = () => {
        // const files = rfq_buyer_item_file
        const files = event_item_file
        if (files.length !== 0) {
          return map(files, (value, index) => {
            return (
              <a
                target="_blank"
                className="file-link removable file-link-edit"
                rel="noopener noreferrer"
                key={index}
              >
                <span
                  className="file-name"
                  onClick={() => this.downloadItem(value)}
                >
                  {value.name}
                </span>
              </a>
            )
          })
        } else {
          return '-'
        }
      }
      return (
        <Modal
          id="allowselection"
          className="reschedule theme-blue"
          isOpen={
            modals
              .filter(modal => {
                return modal.name === 'allow-selection'
              })
              .map(obj => obj.isOpen)[0]
          }
        >
          <Modal.Header>Select Supplier</Modal.Header>
          <Modal.Body>
            <Section className="row">
              <Section className="col-2">
                <Section className="form-group">
                  <label style={{ justifyContent: 'flex-start' }}>Item :</label>
                </Section>
              </Section>
              <Section className="col-6">
                <Section className="form-group text">
                  {/* <label style={{ justifyContent: 'flex-start' }}>{name}</label> */}
                  <text style={{ justifyContent: 'flex-start' }}>{name}</text>
                </Section>
              </Section>
            </Section>
            <Section className="row">
              <Section className="col-2">
                <Section className="form-group">
                  <label style={{ justifyContent: 'flex-start' }}>
                    Description :
                  </label>
                </Section>
              </Section>
              <Section className="col-6">
                <Section className="form-group">
                  <text style={{ justifyContent: 'flex-start' }}>
                    {description}
                  </text>
                </Section>
              </Section>
            </Section>
            <Section className="row">
              <Section className="col-2">
                <Section className="form-group">
                  <label style={{ justifyContent: 'flex-start' }}>
                    Attachment :
                  </label>
                </Section>
              </Section>
              <Section className="col-6">
                <Section
                  className="form-group"
                  style={{ alignItems: 'center' }}
                >
                  <Section className="attached-file-list">
                    {renderAttachmentFile()}
                  </Section>
                </Section>
              </Section>
            </Section>
            <Section className="row">
              <Section className="col-2">
                <Section className="form-group">
                  <label style={{ justifyContent: 'flex-start' }}>
                    Quantity :
                  </label>
                </Section>
              </Section>
              <Section className="col-6">
                <Section className="form-group">
                  <label style={{ justifyContent: 'flex-start' }}>
                    {`${numberFloat} ${uom ? uom : ''}`}
                  </label>
                </Section>
              </Section>
            </Section>
            <Section className="row">
              <Section className="col-2">
                <Section className="form-group">
                  <label
                    style={{ justifyContent: 'flex-start', flexBasis: '145px' }}
                  >
                    Allocation Type :
                  </label>
                </Section>
              </Section>
              <Section className="col-6">{renderFuncCheckBox()}</Section>
            </Section>
            <Section className="form-row">
              <Section className="form-group" style={{ marginTop: '1em' }}>
                <Section className="form-group-title">
                  Multiple Supplier Selected
                </Section>
              </Section>
            </Section>
            {renderFuncSupSelected()}
          </Modal.Body>
          <Modal.Footer>
            <div className="footer-validation-select">
              {filterCheckBox.checkType === qty &&
              totalNumberSelect > totalNumberQty ? (
                <p>Items are over-allocated. Please check</p>
              ) : (
                ''
              )}
              {filterCheckBox.checkType === percent &&
              totalNumberSelect > totalNumberPercent ? (
                <p>Items are over-allocated. Please check</p>
              ) : (
                ''
              )}
            </div>
            <Button
              className="theme-border-gray close"
              onClick={handlerClickCancel}
            >
              Cancel
            </Button>
            <Button className="theme-green save" onClick={handlerSaveSelected}>
              Select
            </Button>
          </Modal.Footer>
        </Modal>
      )
    }
  }
  renderModalClearAll() {
    let { modals } = this.state
    const handlersCancel = e => {
      return this.toggleModal()
    }
    const handlersConfirm = e => {
      const { eventType, rfqid } = this.props.match.params
      if (e.detail === 1) {
        let { setDataInit, quotationCheckBox, itemAction } = this.state
        const funcSendApi = async () => {
          try {
            this.setState({ isConfirming: true })
            let res
            // เก่า ผ่านค่อยลบ
            // if (Number(eventType) === 1) {
            //   res = await rfqController().clearAllSelectionSelect(rfqid)
            // }
            // if (Number(eventType) === 2) {
            //   res = await auctionController().clearAllSelectionSelect(rfqid)
            // }
            res = await eventNewController().clearAllSelection(
              this.state.event_id
              // rfqid
            )
            if (res) {
              if (res.data && res.data.status === 'error') {
                this.toggleModal()
                toastFail('Clear All Error')
              } else {
                const selectedItems = this.clearSelectedItem(res)
                itemAction.selectedBySupplier = selectedItems
                const arrayCheckBoxItemSup = this.clearSelectBox(res)
                // setDataInit = res
                quotationCheckBox = arrayCheckBoxItemSup
                this.funcGetSavingType()
                // this.funcGetSupplierSelected(res)
                // this.setQuotaSelected(res)
                // this.setTypeCheckBoxSelected(res)
                // this.funcGetNoItemsSelect(res)
                this.getItemCompare(
                  this.state.supplierList,
                  this.state.event_id,
                  this.state.activePage
                )
                this.setState({
                  setDataInit,
                  quotationCheckBox,
                  itemAction,
                })
                this.toggleModal()
              }
              // this.toggleModal()
              setTimeout(() => {
                this.setState({ isConfirming: false })
              }, 500)
            }
          } catch (error) {
            console.log(error)
            setTimeout(() => {
              this.setState({ isConfirming: false })
            }, 800)
          }
        }
        funcSendApi()
      }
    }
    return (
      <Modal
        className="theme-blue"
        isOpen={
          modals
            .filter(modal => {
              return modal.name === 'modals-clear-all'
            })
            .map(obj => obj.isOpen)[0]
        }
        modalWidth="575px"
      >
        <Modal.Header>Confirm</Modal.Header>
        <Modal.Body>
          <p className="default text-center">
            Are you sure to clear all selection?
          </p>
        </Modal.Body>
        <Modal.Footer className="theme-gray">
          <Button className="theme-border-gray" onClick={handlersCancel}>
            Cancel
          </Button>
          <Button
            className="theme-green"
            onClick={handlersConfirm}
            disabled={this.state.isConfirming}
          >
            Confirm
          </Button>
        </Modal.Footer>
      </Modal>
    )
  }
  renderModalSubmitAward() {
    let { modals, savingType, setDataInit, checkAward } = this.state
    let rfq_auction_id = ''
    if (setDataInit && setDataInit.length !== 0) {
      // rfq_auction_id = setDataInit[0].rfq_id || setDataInit[0].auction_id
      rfq_auction_id = setDataInit.rfq_id || setDataInit.auction_id
    }
    const { res } = savingType
    const funcSetFormat = number => {
      let numberFormat = ''
      const na = 'N/A'
      if (number === na) {
        numberFormat = na
      } else {
        numberFormat = Numeral(number).format('0,0.00')
      }
      return numberFormat
    }
    let {
      average_reserve_price,
      average_extended_price,
      average_total_saving_price,
      budget_reserve_price,
      budget_total_saving_price,
      budget_extended_price,
      historical_reserve_price,
      historical_extended_price,
      historical_total_saving_price,
      market_reserve_price,
      market_extended_price,
      market_total_saving_price,
    } = res
    average_reserve_price = funcSetFormat(average_reserve_price)
    average_extended_price = funcSetFormat(average_extended_price)
    average_total_saving_price = funcSetFormat(average_total_saving_price)
    budget_reserve_price = funcSetFormat(budget_reserve_price)
    budget_extended_price = funcSetFormat(budget_extended_price)
    budget_total_saving_price = funcSetFormat(budget_total_saving_price)
    historical_reserve_price = funcSetFormat(historical_reserve_price)
    historical_extended_price = funcSetFormat(historical_extended_price)
    historical_total_saving_price = funcSetFormat(historical_total_saving_price)
    market_reserve_price = funcSetFormat(market_reserve_price)
    market_extended_price = funcSetFormat(market_extended_price)
    market_total_saving_price = funcSetFormat(market_total_saving_price)
    const handlersCancel = () => {
      let { checkAward } = this.state
      checkAward = this.state.checkAward
      this.toggleModal()
      if (this._isMounted) {
        this.setState({ checkAward })
      }
    }
    const handlersConfirm = e => {
      let {
        checkAward,
        submitAward,
        approvalFiels,
        formData,
        approvalNote,
      } = this.state
      const { event_no, name, id } = formData
      const { submitaward } = checkAward
      const saving_type = submitaward
      // files id
      if (e.detail === 1 && !this.state.isLoading) {
        this.setState({ isLoading: true, isConfirming: true })
        const confirmAward = async () => {
          try {
            const elm = document.getElementById('approval-note')
            const resText = elm ? elm.value : ''
            const obj = {
              note_for_approver: resText,
              file_request: approvalFiels,
            }
            // const obj = {
            //   note_for_approver: resText,
            //   file_request: approvalFiels,
            //   rfq_id: rfq_id,
            //   saving_type,
            // } // เก่า
            this.toggleModal()
            const res = await rfqController().submitAward(
              obj,
              // rfq_auction_id,
              this.state.idRFQ,
              saving_type
            )
            if (res === '52010: sourcing project was award') {
              toast.error('Sourcing project was award')
              this.setState({ isLoading: false })
            } else if (res === '52011: project has event awaiting approval') {
              toast.error('Project has event awaiting approval')
              this.setState({ isLoading: false })
            } else if (res) {
              submitAward = true
              approvalFiels = []
              approvalNote = ''
              toast.success('Submit Award Success')
              this.funcGetSavingType()
              this.getEventById(id)
              this.funcGetApprovalHistory(id)
              setTimeout(() => {
                this.getApprovalWorkflow(id)
              }, 800)
              if (this._isMounted) {
                this.setState({ submitAward, approvalFiels, approvalNote })
              }
              this.setState({
                isLoading: false,
                showButtonSubmit: false,
                showButtonCancel: true,
                showButtonNoSelect: false,
              })
            }
          } catch (error) {
            this.setState({ isLoading: false })
            console.log(error)
          }
          setTimeout(() => {
            this.setState({ isConfirming: false })
          }, 800)
        }
        confirmAward()
      }
    }
    return (
      <Modal
        // className="purchasing-site buyer theme-blue modals-submit-award"
        className="theme-blue popup"
        isOpen={
          modals
            .filter(modal => {
              return modal.name === 'modals-submit-award'
            })
            .map(obj => obj.isOpen)[0]
        }
      >
        <Modal.Header>Submit Award</Modal.Header>
        <Modal.Body>
          <p className="default text-center">Are you sure to Submit Award?</p>
        </Modal.Body>
        <Modal.Footer>
          <Button className="theme-gray close" onClick={handlersCancel}>
            Cancel
          </Button>
          <Button
            className="theme-green"
            onClick={handlersConfirm}
            disabled={this.state.isConfirming}
          >
            Confirm
          </Button>
        </Modal.Footer>
      </Modal>
    )
  }

  renderModalNoSelectionReason = () => {
    let {
      modals,
      noSelectionReason,
      noSelectionReasonValue,
      isErrOther,
      noSelectionReasonText,
      formData,
      isErrMsgNoSelectionReasonText,
      isErrMsgNoSelectionReasonValue,
    } = this.state

    const validateNoSelection = () => {
      let isPass = true
      if (!noSelectionReasonValue) {
        isErrMsgNoSelectionReasonValue = STRING.INVALID
        isPass = false
      } else if (noSelectionReasonValue.value === 8 && !noSelectionReasonText) {
        isErrMsgNoSelectionReasonText = STRING.INVALID
        isPass = false
      }
      if (this._isMounted) {
        this.setState({
          isErrMsgNoSelectionReasonValue,
          isErrMsgNoSelectionReasonText,
        })
      }
      return isPass
    }

    const handlersConfirm = async () => {
      const { match } = this.props
      const { params } = match
      const { rfqid, eventType } = params
      const { id } = formData
      let { noSelectionReasonValue, noSelectionReasonText } = this.state

      if (validateNoSelection() && !this.state.isLoading) {
        this.setState({ isLoading: true, isConfirming: true })
        const obj = {
          reason:
            noSelectionReasonValue.value === 8 //Other
              ? noSelectionReasonText
              : noSelectionReasonValue.label,
        }
        try {
          this.toggleModal()
          let res
          // obj.event_id = rfqid
          res = await eventNewController().selectNoSelectionReason(rfqid, obj)
          if (res) {
            toast('No Selection Success', {
              toastId: 'No Selection',
              position: 'top-center',
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: true,
              progress: undefined,
              type: 'success',
            })
            this.funcGetSavingType()
            this.getEventById(id)
            this.funcGetApprovalHistory(id)
            setTimeout(() => {
              this.getApprovalWorkflow(id)
            }, 800)
            this.setState({ isLoading: false, isConfirming: false })
          }
        } catch (error) {
          this.setState({ isLoading: false, isConfirming: false })
        }
      }
    }
    return (
      <Modal
        className="theme-blue modal-no-selection-reason"
        isOpen={
          modals
            .filter(modal => {
              return modal.name === 'modal-no-selection-reason'
            })
            .map(obj => obj.isOpen)[0]
        }
        modalWidth="768px"
      >
        <Modal.Header>No Selection</Modal.Header>

        <Modal.Body>
          <Section className="form-group">
            <label>Description:</label>
            <Section className="form-group-control">
              <Section className="form-group-inner-wrapper text">
                {formData.event_no}
              </Section>
            </Section>
          </Section>

          <Section className="form-group">
            <label>Event Name:</label>
            <Section className="form-group-control">
              <Section className="form-group-inner-wrapper text">
                {formData.name}
              </Section>
            </Section>
          </Section>

          <Section
            className={`form-group ${
              isErrMsgNoSelectionReasonValue && 'is-error'
            }`}
          >
            <label>Reason:</label>
            <Section className="form-group-control">
              <Section className="form-group-inner-wrapper">
                <SelectBox
                  className="select-reason"
                  value={noSelectionReasonValue}
                  options={noSelectionReason}
                  isSearchable={false}
                  //menuIsOpen={true}
                  placeholder="Select"
                  onChange={e => {
                    if (this._isMounted) {
                      this.setState({
                        noSelectionReasonValue: e,
                        isErrMsgNoSelectionReasonValue: '',
                      })
                    }
                    this.setState({
                      isErrOther: false,
                    })
                  }}
                />
              </Section>
              <Section className="message">
                {' '}
                {isErrMsgNoSelectionReasonValue &&
                  isErrMsgNoSelectionReasonValue}
              </Section>
            </Section>
          </Section>
          <Section className={`form-group ${isErrOther && 'is-error'}`}>
            <label></label>
            <Section className="form-group-control">
              {noSelectionReasonValue ? (
                noSelectionReasonValue.label ===
                'Other, please specify - อื่นๆ กรุณาระบุ(text)' ? (
                  <Section className="form-group-inner-wrapper">
                    <InputTextarea
                      onChange={e => {
                        const noSelectionReasonTextvalue = e.target.value
                        this.setState({
                          noSelectionReasonText: noSelectionReasonTextvalue,
                          isErrOther: false,
                        })
                      }}
                    ></InputTextarea>
                  </Section>
                ) : null
              ) : null}
              <Section className="message">
                {isErrOther && STRING.INVALID}
              </Section>
            </Section>
          </Section>
        </Modal.Body>

        <Modal.Footer>
          <Button
            id=""
            className="theme-gray"
            onClick={() => {
              // isErrMsgNoSelectionReasonValue = ''
              if (this._isMounted) {
                this.setState(
                  {
                    noSelectionReasonText: '',
                    noSelectionReasonValue: null,
                    isErrMsgNoSelectionReasonText: '',
                    isErrMsgNoSelectionReasonValue: '',
                    isErrOther: false,
                  },
                  this.toggleModal()
                )
              }
            }}
          >
            Cancel
          </Button>

          <Button
            id=""
            className="theme-green"
            onClick={e => {
              if (
                noSelectionReasonValue !== null &&
                noSelectionReasonValue.value === 8
              ) {
                if (noSelectionReasonText === '') {
                  this.setState({
                    isErrOther: true,
                  })
                } else {
                  this.setState({
                    isErrOther: false,
                  })
                  return handlersConfirm()
                }
              } else {
                return handlersConfirm()
              }
            }}
            disabled={this.state.isConfirming}
          >
            Confirm
          </Button>
        </Modal.Footer>
      </Modal>
    )
  }

  renderModalReSubmitAward() {
    let { modals } = this.state
    const renderBodyContent = () => {
      return (
        <p className="default text-center">Are you sure to re-submit award?</p>
      )
    }
    const handlersCancel = () => {
      this.toggleModal()
    }
    const handlersConfirm = e => {
      let { reSubmitAward } = this.state
      const { match } = this.props
      const { params } = match
      const { rfqid } = params
      if (e.detail === 1) {
        const confirmReSubmitAward = async () => {
          try {
            if (rfqid) {
              const res = await rfqController().reSubmitAward(rfqid)
              if (res === '52010: sourcing project was award') {
                toast.error('Sourcing project was award')
                this.toggleModal()
              } else if (res === '51514: the project was cancelled') {
                toast.error('The project was cancelled')
                this.toggleModal()
              } else if (res) {
                toast.success('Re-Submit Award Success')
                this.funcGetSavingType()
                this.toggleModal()
                if (this._isMounted) {
                  reSubmitAward = true
                  setTimeout(
                    function () {
                      this.setState({ reSubmitAward })
                    }.bind(this),
                    1000
                  )
                }
              }
            }
          } catch (error) {
            console.log(error)
          }
        }
        confirmReSubmitAward()
      }
    }
    return (
      <Modal
        className="theme-blue modals-re-submit-award"
        isOpen={
          modals
            .filter(modal => {
              return modal.name === 'modals-re-submit-award'
            })
            .map(obj => obj.isOpen)[0]
        }
        modalWidth="575px"
      >
        <Modal.Header>Re-Submit Award</Modal.Header>
        <Modal.Body>{renderBodyContent()}</Modal.Body>
        <Modal.Footer>
          <Button className="theme-gray" onClick={handlersCancel}>
            Cancel
          </Button>
          <Button className="theme-green" onClick={handlersConfirm}>
            Confirm
          </Button>
        </Modal.Footer>
      </Modal>
    )
  }
  renderModalCheckAward() {
    let { modals } = this.state
    const renderBodyContent = () => {
      return <p className="default text-center">Approval Flow Updated</p>
    }
    const handlersConfirm = e => {
      const { formData } = this.state
      const { id } = formData
      this.toggleModal()
      this.funcGetSavingType()
      this.getEventById(id)
      this.funcGetApprovalHistory(id)
      this.getApprovalWorkflow(id)
    }
    return (
      <Modal
        className="theme-blue modals-re-submit-award"
        isOpen={
          modals
            .filter(modal => {
              return modal.name === 'modals-check-award'
            })
            .map(obj => obj.isOpen)[0]
        }
        modalWidth="575px"
      >
        <Modal.Header>Information</Modal.Header>
        <Modal.Body>{renderBodyContent()}</Modal.Body>
        <Modal.Footer>
          <Button className="theme-green" onClick={handlersConfirm}>
            Ok
          </Button>
        </Modal.Footer>
      </Modal>
    )
  }
  renderModalOfApproveButton() {
    let { modals } = this.state
    const renderBodyContent = () => {
      return (
        <p className="default text-center">
          Are you sure to approve this award proposal?
        </p>
      )
    }
    const handlersCancel = () => {
      this.toggleModal()
    }
    const handlersConfirm = e => {
      let { approvalFiels, approvalNote } = this.state
      const { match } = this.props
      const { params } = match
      const { rfqid } = params
      if (e.detail === 1 && !this.state.isLoading) {
        const confirmApproveAward = async () => {
          try {
            this.setState({ isLoading: true, eventIsApproving: true })
            const elm = document.getElementById('approval-note')
            const resText = elm.value
            const obj = {
              note_for_approver: resText,
              file_request: approvalFiels,
            }
            const res = await rfqController().postApproveWorkflow(obj, rfqid)
            if (res) {
              this.toggleModal()
              this.setState({ isLoading: false, eventIsApproving: false })
              if (res === '51503: approval workflow user cannot approve') {
                return toast.error('Approval workflow user cannot approve')
              } else if (res === '51510: approval work flow not found') {
                return toast.error('Approval work flow not found')
              } else if (res === '51511: approved by other approver') {
                this.getEventById(rfqid)
                this.funcGetApprovalHistory(rfqid)
                setTimeout(() => {
                  this.getApprovalWorkflow(rfqid)
                }, 800)
                this.funcGetSourcingProject()
                approvalFiels = []
                approvalNote = ''
                this.setState({ approvalFiels, approvalNote })
                return toast.error('Approved by other approver')
              } else if (res === '51513: rejected by other approver') {
                this.getEventById(rfqid)
                this.funcGetApprovalHistory(rfqid)
                setTimeout(() => {
                  this.getApprovalWorkflow(rfqid)
                }, 800)
                this.funcGetSourcingProject()
                approvalFiels = []
                approvalNote = ''
                this.setState({ approvalFiels, approvalNote })
                return toast.error('Rejected by other approver')
              } else {
                this.getEventById(rfqid)
                this.funcGetApprovalHistory(rfqid)
                setTimeout(() => {
                  this.getApprovalWorkflow(rfqid)
                }, 800)
                this.funcGetSourcingProject()
                approvalFiels = []
                approvalNote = ''
                this.setState({
                  approvalFiels,
                  approvalNote,
                  // showButtonApprove: false,
                })
                return toast.success('Award Proposal has been approved')
              }
            }
          } catch (error) {
            console.log(error)
            this.toggleModal()
            this.setState({ isLoading: false, eventIsApproving: false })
          }
        }
        confirmApproveAward()
      }
    }
    return (
      <Modal
        className="theme-blue modals-re-submit-award"
        isOpen={
          modals
            .filter(modal => {
              return modal.name === 'modals-approve-award'
            })
            .map(obj => obj.isOpen)[0]
        }
        modalWidth="575px"
      >
        <Modal.Header>Approve Award Proposal</Modal.Header>
        <Modal.Body>{renderBodyContent()}</Modal.Body>
        <Modal.Footer>
          <Button className="theme-gray" onClick={handlersCancel}>
            Cancel
          </Button>
          <Button
            className="theme-green"
            onClick={handlersConfirm}
            disabled={this.state.eventIsApproving}
          >
            Confirm
          </Button>
        </Modal.Footer>
      </Modal>
    )
  }
  renderButtonAllowSelect(data, formData, savingType, keySup) {
    // show selections not role TEC
    const notRoleTec = this.funcCheckSelectionsRole()
    let { eventType } = this.props.match.params
    let {
      itemAction,
      setDataInit,
      allocateItems,
      awardStatuses,
      dataProject,
    } = this.state
    const sealedCheck = formData.seal_status_name !== sealStatus.sealed
    const awaUnSealedCheck =
      formData.seal_status_name !== sealStatus.awaitingunseal
    const matchValueAwa = this.matchValue(
      awardStatuses,
      formData.rfq_award_status_id || formData.auction_award_status_id
    )
    const checkAwaSel = 'Awaiting Selection'
    const { qty, percent } = allowcateType
    const { selectedBySupplier } = itemAction
    const { allocated, noSelection } = selectionType
    const { id, rfq_id, auction_id } = data
    const findDataDisble = find(selectedBySupplier, (value, index) => {
      if (value.idItem === id) return value
    })
    const awaiting_approve = this.matchValue(
      awardStatuses,
      formData.rfq_award_status_id || formData.auction_award_status_id
    )
    const showSelections = this.funcCheckSelectionsRole()
    const handlerOnClickAllocateItems = (e, idItem) => {
      e.preventDefault()
      const findData = find(setDataInit, (value, index) => {
        if (value.id === idItem) return value
      })
      allocateItems = findData
      this.setState({ allocateItems })
      this.toggleModal('allow-selection')
    }
    const handlerUnAllocate = (e, id) => {
      if (e.detail === 1) {
        const filterAllo = filter(setDataInit, (allV, allK) => {
          const { selected_type } = allV
          if (allV.id === id && selected_type === allocated) return allV
        })
        if (filterAllo.length !== 0) {
          let dataUnallocate
          // const mapData = map(filterAllo, (value, key) => {
          //   const { id, rfq_id, event_id, auction_id } = value
          //   if (Number(eventType) === 1) {
          //     return {
          //       id,
          //       event_id,
          //       rfq_id: this.state.idRFQ,
          //       // event_item_supplier: [],
          //       // rfq_item_supplier_response: [],
          //       selected_type: '',
          //       suppliers: [],
          //     }
          //   }
          //   if (Number(eventType) === 2) {
          //     return {
          //       id,
          //       auction_id,
          //       auction_item_supplier_response: [],
          //       selected_type: '',
          //       suppliers: [],
          //     }
          //   }
          // })
          filterAllo.map((value, key) => {
            const { id, rfq_id, event_id, auction_id } = value
            if (Number(eventType) === 1) {
              dataUnallocate = {
                id,
                // event_id,
                // rfq_id: this.state.idRFQ,
                // event_item_supplier: [],
                // rfq_item_supplier_response: [],
                selected_type: '',
                allocate_type: '',
                suppliers: [],
              }
            }
            if (Number(eventType) === 2) {
              dataUnallocate = {
                id,
                auction_id,
                auction_item_supplier_response: [],
                selected_type: '',
                suppliers: [],
              }
            }
          })
          const funcSendsApi = async () => {
            try {
              this.setState({ isLoading: true })
              console.log('selection Supplier 7 : Unallocate Items')
              // const res = await rfqController().selectionSupplier(mapData)
              const res = await eventNewController().selectionSupplier(
                this.state.event_id,
                dataUnallocate
              )
              if (res) {
                await this.getItemCompare(
                  this.state.supplierList,
                  this.state.event_id,
                  this.state.activePage
                )
                // this.funcGetSupplierSelected(res)
                // this.setQuotaSelected(res)
                // this.setTypeCheckBoxSelected(res)
                await this.funcGetSavingType()
                // setDataInit = res
                // this.setState({ setDataInit })
              }
              this.setState({ isLoading: false })
            } catch (error) {
              console.log(error)
            }
          }
          funcSendsApi()
        }
      }
    }
    const handlersNoItem = (e, idItem, rfq_auction_id, unCheck = false) => {
      const { noSelection } = selectionType
      if (e.detail === 1) {
        try {
          this.setState({ isLoading: true })

          let dataNoItem
          if (Number(eventType) === 1) {
            // dataNoItem = [
            //   {
            //     id: idItem,
            //     // rfq_id: rfq_auction_id,
            //     rfq_id: this.state.idRFQ,
            //     event_id: rfq_auction_id,
            //     event_item_supplier: [],
            //     rfq_item_supplier_response: [],
            //     suppliers: [],
            //     selected_type: unCheck ? '' : noSelection,
            //   },
            // ]
            dataNoItem = {
              id: idItem,
              // rfq_id: rfq_auction_id,
              // rfq_id: this.state.idRFQ,
              // event_id: rfq_auction_id,
              // event_item_supplier: [],
              // rfq_item_supplier_response: [],
              allocate_type: '',
              suppliers: [],
              selected_type: unCheck ? '' : noSelection,
            }
          }
          if (Number(eventType) === 2) {
            dataNoItem = [
              {
                id: idItem,
                auction_id: rfq_auction_id,
                auction_item_supplier_response: [],
                selected_type: unCheck ? '' : noSelection,
              },
            ]
          }
          const funcSendsApi = async () => {
            console.log('selection Supplier 8 : No item Selection')
            // console.log('dataNoItem', dataNoItem)
            // const res = await rfqController().selectionSupplier(dataNoItem)
            const res = await eventNewController().selectionSupplier(
              this.state.event_id,
              dataNoItem
            )
            if (res) {
              if (res.data && res.data.status === 'error') {
                toastFail('No Select Item Error')
              } else {
                await this.getItemCompare(
                  this.state.supplierList,
                  this.state.event_id,
                  this.state.activePage
                )
                // this.funcGetNoItemsSelect(res)
                // this.funcGetSupplierSelected(res)
                // this.setQuotaSelected(res)
                // this.setTypeCheckBoxSelected(res)
                await this.funcGetSavingType()
                // this.setState({ setDataInit: res })
                this.setState({ isLoading: false })
              }
            }
          }
          if (unCheck === false) {
            funcSendsApi()
          } else {
            funcSendsApi()
          }
          setTimeout(() => {
            this.getApprovalWorkflow(this.state.formData.id)
          }, 800)
        } catch (error) {
          console.log(error)
        }
      }
    }
    const funcRenderNoItemSelectButton = findDataAlloCate => {
      const { setNoItemSelect } = this.state
      const styleButtonNoItem = {
        border: '1px solid red',
        color: 'red',
        backgroundColor: 'white',
        maxWidth: '60%',
      }
      const findIdSelect = find(setNoItemSelect, (value, index) => {
        const { id: idNoitem } = value
        if (idNoitem === id) return value
      })
      const unCheck = true
      const rfq_auction_id = auction_id || rfq_id
      return (
        <Button
          onClick={e => {
            if (!findDataAlloCate) {
              handlersNoItem(
                e,
                id,
                rfq_auction_id,
                findIdSelect ? unCheck : false
              )
            }
          }}
          className={
            this.state.eventListHaveApprove
              ? 'theme-gray'
              : findDataAlloCate
              ? 'theme-gray'
              : 'theme-red'
          }
          style={
            this.state.eventListHaveApprove
              ? {}
              : findIdSelect && styleButtonNoItem
          }
          disabled={
            this.state.eventListHaveApprove || this.state.isHavingListEventOpen
              ? this.state.eventListHaveApprove ||
                this.state.isHavingListEventOpen
              : findDataAlloCate
          }
        >
          No Item Selection
        </Button>
      )
    }
    // funcNoItemSelectButtonAwa || Awaiting Approve || Purchaser
    const funcNoItemSelectButtonAwa = findDataAlloCate => {
      const { setNoItemSelect } = this.state
      if (findDataAlloCate) {
        return ''
      } else {
        const findIdSelect = find(setNoItemSelect, (value, index) => {
          const { id: idNoitem } = value
          if (idNoitem === id) return value
        })
        if (findIdSelect) {
          return ''
        } else {
          return <Button className="theme-red">No Item Selection test</Button>
        }
      }
    }
    const funcRenderButton = () => {
      if (findDataDisble && findDataDisble.action === 'checked') {
        return (
          <Section
            style={{ marginTop: '100px' }}
            className="item-list"
            key={id}
          >
            <Button className="theme-gray" disabled={true}>
              No Item Selection
            </Button>
            <Button className="theme-gray" disabled={true}>
              Allocate Items
            </Button>
          </Section>
        )
      } else {
        const findDataAlloCate = find(setDataInit, (value, index) => {
          const { selected_type } = value
          if (value.id === id && selected_type === allocated) return value
        })
        const findDataNoItem = find(
          this.state.setNoItemSelect,
          (value, index) => {
            const { selected_type } = value
            if (value.id === id) return value
          }
        )
        const { event_item_supplier } = data
        const itemReject = filter(event_item_supplier, (value, index) => {
          const { unit_price } = value
          if (unit_price !== '' && unit_price !== 'RFQ Reject') {
            return value
          }
        })
        const itemResponse = filter(event_item_supplier, (value, index) => {
          const { response_status } = value
          if (response_status !== 'Rejected') {
            return value
          }
        })
        return (
          <Section
            style={{ marginTop: '100px' }}
            className="item-list"
            key={id}
          >
            {notRoleTec && funcRenderNoItemSelectButton(findDataAlloCate)}

            {
              <Button
                className={
                  findDataAlloCate
                    ? 'theme-green'
                    : itemReject.length !== 0 && itemResponse.length !== 0
                    ? 'theme-blue'
                    : findDataNoItem
                    ? 'theme-gray'
                    : ''
                }
                disabled={
                  this.state.eventListHaveApprove ||
                  this.state.isHavingListEventOpen
                    ? this.state.eventListHaveApprove ||
                      this.state.isHavingListEventOpen
                    : findDataNoItem
                }
                onClick={e => {
                  if (findDataAlloCate) {
                    handlerUnAllocate(e, id)
                  } else if (
                    itemReject.length !== 0 &&
                    itemResponse.length !== 0
                  ) {
                    handlerOnClickAllocateItems(e, id)
                  }
                }}
              >
                Allocate Items
              </Button>
            }
          </Section>
        )
      }
    }
    // funcRenderButtonAwa || Awaiting Approve || Purchaser
    const funcRenderButtonAwa = () => {
      if (findDataDisble && findDataDisble.action === 'checked') {
        return (
          <Section
            style={{ marginTop: '100px' }}
            className="item-list"
            key={id}
          />
        )
      } else {
        const findDataAlloCate = find(setDataInit, (value, index) => {
          const { selected_type } = value
          if (value.id === id && selected_type === allocated) return value
        })
        const findDataNoItem = find(
          this.state.setNoItemSelect,
          (value, index) => {
            const { selected_type } = value
            if (value.id === id) return value
          }
        )
        const { event_item_supplier } = data
        const itemReject = filter(event_item_supplier, (value, index) => {
          const { unit_price } = value
          if (unit_price !== '' && unit_price !== 'RFQ Reject') {
            return value
          }
        })
        const itemResponse = filter(event_item_supplier, (value, index) => {
          const { response_status } = value
          if (response_status !== 'Rejected') {
            return value
          }
        })
        return (
          <Section
            style={{ marginTop: '100px' }}
            className="item-list"
            key={id}
          >
            {notRoleTec && funcNoItemSelectButtonAwa(findDataAlloCate)}
            {findDataAlloCate || findDataNoItem ? (
              <></>
            ) : (
              itemReject.length !== 0 &&
              itemResponse.length !== 0 && (
                <Button
                  className="theme-blue"
                  disabled={
                    this.state.eventListHaveApprove ||
                    this.state.isHavingListEventOpen
                  }
                >
                  Allocate Items
                </Button>
              )
            )}
          </Section>
        )
      }
    }
    if (
      sealedCheck &&
      awaUnSealedCheck &&
      matchValueAwa === checkAwaSel &&
      dataProject.project_status_id === 2
    ) {
      if (notRoleTec) {
        return funcRenderButton()
      } else {
        return <Section style={{ marginTop: '100px' }}></Section>
      }
    } else if (
      awaiting_approve === 'Awaiting Approve' &&
      showSelections &&
      dataProject.project_status_id === 2
    ) {
      return funcRenderButtonAwa()
    } else {
      return <Section style={{ marginTop: '100px' }}></Section>
    }
  }
  renderSourcingCompareEvent = () => {
    const {
      supplierList,
      contactInformation,
      quotationDetail,
      checkAllSupplier,
      quotationList,
      modals,
      activeStep,
      formData,
      statusRFQ,
      newScheduleDate,
      cancelReasonValue,
      cancelReasonText,
      cancelReason,
      isErrMsgEndDate,
      isErrMsgReasonValue,
      isErrMsgReasonText,
    } = this.state
    const { end_date } = formData
    const getRoleLocal = localStorage.getItem('roleUser')
    const getRoleLocalMulti = localStorage.getItem('roleUserMulti')
    let hideRoleTec = null
    let hideRoleTecMulti = null
    if (getRoleLocal) {
      hideRoleTec = parseInt(getRoleLocal, 10)
    } else {
      const dataRoleMulti = JSON.parse(getRoleLocalMulti)
      const idRoleTec = 10
      const someArrayCheckRole = element => {
        return element.id !== idRoleTec
      }
      hideRoleTecMulti = dataRoleMulti
        ? dataRoleMulti.some(someArrayCheckRole)
        : null
    }
    const steps = [
      {
        component: this.step1Content(),
      },
      {
        component: this.step2Content(),
      },
      {
        component: this.step3Content(),
      },
    ]
    const renderPageTitle = () => {
      const showExport = this.funcCheckExportRole()
      return (
        <Section className="page-topbar">
          <Section className="page-header">
            <Section className="page-icon">
              <Image
                id="page_icon_buyer_management"
                src={ICONS['icon-sourcing-white.svg']}
                alt="page icon"
              />
            </Section>
            <Section className="title-and-breadcrumb">
              <Section id="page_title_buyer_management" className="title">
                Sourcing
              </Section>
              <Breadcrumbs props={this.props} />
            </Section>
          </Section>
          {/* render Button Export */}
          {showExport &&
            this.renderButtonExport(
              statusRFQ,
              formData.is_cancel,
              formData.seal_status_name,
              hideRoleTec,
              hideRoleTecMulti,
              formData
            )}
        </Section>
      )
    }
    const renderPageContent = () => {
      const { eventType } = this.props.match.params
      const funcRenderStatusRFQ = () => {
        const renderStatusRFQ = () => {
          const funcSupplierList = () => {
            const onChangeCheckBox = (e, i) => {
              return this.onChangeCheckboxSupplier(i)
            }
            const funcRenderResponseDate = (e, i) => {
              if (e.response_date) {
                const setTimeResponseDate = e.response_date
                  ? moment(e.response_date, 'YYYY/MM/DD HH:mm:ss').toDate()
                  : // .utc(e.response_date)
                    // .toDate()
                    null
                return dateMonDayYearTime(setTimeResponseDate)
              } else {
                return '-'
              }
            }
            if (supplierList) {
              return supplierList.map((e, i) => {
                return (
                  <Table.TR key={e.id}>
                    <Table.TD className="check-box">
                      <Checkbox
                        name="business_type"
                        id={i}
                        checked={e.checked}
                        onChange={() => onChangeCheckBox(e, i)}
                      ></Checkbox>
                    </Table.TD>
                    <Table.TD className="no">{i + 1}</Table.TD>
                    <Table.TD className="tax-id">{e.tax_id}</Table.TD>
                    <Table.TD className="supplier-name">
                      <Text
                        tootipValue={e.company_name}
                        useTootipFor="company_name"
                        useTootip={true}
                      >
                        {e.company_name}
                      </Text>
                    </Table.TD>
                    <Table.TD className="contact-name">
                      <Text
                        tootipValue={e.name}
                        useTootipFor="name"
                        useTootip={true}
                      >
                        {e.name}
                      </Text>
                    </Table.TD>
                    <Table.TD className="phone">{e.phone}</Table.TD>
                    <Table.TD className="email">
                      <Text
                        tootipValue={e.email}
                        useTootipFor="email"
                        useTootip={true}
                      >
                        {e.email}
                      </Text>
                    </Table.TD>
                    <Table.TD className="response-date">
                      {funcRenderResponseDate(e, i)}
                    </Table.TD>
                    <Table.TD className="term-status">{e.term_status}</Table.TD>
                    <Table.TD className="status">
                      <Section
                        className={`response-status ${
                          e.response_status.includes('Rejected') && 'rejected'
                        }`}
                      >
                        {e.response_status}
                        {e.response_status.includes('Rejected') && (
                          <Section className="link tooltip-attachment">
                            <Image
                              src={ICONS['icon-help.svg']}
                              alt="help"
                              tootipValue={e.reject_reason}
                              useTootip={true}
                            />
                          </Section>
                        )}
                      </Section>
                    </Table.TD>
                    {this.state.formData.event_type_id === 1 && (
                      <>
                        <Table.TD className="status">
                          {this.renderNoteToBuyerSeal(e, formData)}
                        </Table.TD>
                        <Table.TD className="status">
                          {this.renderStatusSeal(e, formData)}
                        </Table.TD>
                      </>
                    )}
                    {this.state.formData.event_type_id === 2 &&
                      statusRFQ === 4 && (
                        <Table.TD className="status">
                          {this.renderBidHistory(e, formData)}
                        </Table.TD>
                      )}
                  </Table.TR>
                )
              })
            }
          }
          const funcRenderCompareListTable = () => {
            const funcRenderToolTip = (
              checkLengthText,
              maxLength,
              i,
              value
            ) => {
              return (
                <React.Fragment>
                  <Image
                    className="padlock-icon-company"
                    src={ICONS['icon-padlock.svg']}
                    alt="padlock icon"
                  />
                  <span
                    data-tip
                    data-for={`${i}-quotationList1`}
                    className="truncate_string_span"
                  >
                    {value.supplier_company_name}
                  </span>
                  <TooltipBuyer
                    id={`${i}-quotationList1`}
                    toolTipText={value.supplier_company_name}
                  />
                </React.Fragment>
              )
            }
            const renderQuotationList = () => {
              const callQuotationList = (e, i) => {
                const itemSupplierResponse =
                  e.event_item_supplier || e.auction_item_supplier_response
                const idHeaderSup = e.id
                const funcRenderRfqItemSup = () => {
                  if (i === 0) {
                    return map(itemSupplierResponse, (value, key) => {
                      const maxLength = 32
                      const checkLengthText = value.supplier_company_name

                      return (
                        <th
                          key={`${key}-${i}`}
                          className={`supplier-name-lock ${
                            checkLengthText.length >= maxLength
                              ? 'displayAlign'
                              : ''
                          }`}
                        >
                          {/*button to check each supplier*/}
                          {this.renderElmSupNameTitle(
                            formData,
                            value,
                            idHeaderSup
                          )}
                          {/*name of header quotation*/}
                          {funcRenderToolTip(
                            checkLengthText,
                            maxLength,
                            key,
                            value
                          )}
                        </th>
                      )
                    })
                  }
                }
                return funcRenderRfqItemSup()
              }
              return map(quotationList, callQuotationList)
            }
            const funcRenderResultQuotationList = () => {
              return <React.Fragment>{renderQuotationList()}</React.Fragment>
            }
            return (
              <React.Fragment>{funcRenderResultQuotationList()}</React.Fragment>
            )
          }
          const renderQuotationList = () => {
            const { savingType } = this.state
            if (quotationList.length > 0) {
              return quotationList.map((e, ei) => {
                const funcRenderSupplierItem = () => {
                  const funcerenderItemSupplierResponse = () => {
                    const item =
                      e.event_item_supplier || e.auction_item_supplier_response
                    return map(item, (j, ji) => {
                      return (
                        <td key={ji} className="supplier-name">
                          <Section className="form-row">
                            {formData.seal_status_name === sealStatus.sealed ||
                            formData.seal_status_name ===
                              sealStatus.awaitingunseal ? (
                              <Section className="form-col col-6">
                                Unit Price
                              </Section>
                            ) : (
                              <Section className="form-col col-6">
                                Unit Price
                              </Section>
                            )}
                            {this.renderIconUnitPrice(
                              j,
                              formData,
                              this.state.selectSuppliersRfq,
                              ji
                            )}
                          </Section>
                          <Section className="form-row">
                            {formData.seal_status_name === sealStatus.sealed ||
                            formData.seal_status_name ===
                              sealStatus.awaitingunseal ? (
                              <Section className="form-col col-6">
                                <strong>Total Price</strong>
                              </Section>
                            ) : (
                              <Section className="form-col col-6">
                                <strong>Total Price</strong>
                              </Section>
                            )}
                            {this.renderIconTotalPrice(
                              j,
                              formData,
                              this.state.selectSuppliersRfq,
                              ji
                            )}
                          </Section>
                        </td>
                      )
                    })
                  }
                  return (
                    <tr className="supplier-item supplier-item-row">
                      <td className="no">{this.state.offset + ei + 1}</td>
                      <td className="item">
                        <Section className="item-list">{e.name}</Section>
                        <Section className="item-list">
                          Quantity: {Numeral(e.req_amount).format('0,0.00')}{' '}
                          {e.uom}
                        </Section>
                        <Button
                          className="theme-blue front-button"
                          onClick={() => {
                            if (this._isMounted) {
                              this.setState(
                                {
                                  quotationDetail: e,
                                },
                                this.toggleModal('supplier-description')
                              )
                            }
                          }}
                        >
                          Description
                        </Button>
                        {this.renderBudgetPriceSealed(e, formData)}
                        {this.renderHistoricalPriceSealed(e, formData)}
                        {this.renderMarketPriceSealed(e, formData)}
                      </td>
                      {funcerenderItemSupplierResponse()}
                    </tr>
                  )
                }
                const funcRenderSupplierItemSave = () => {
                  const rfqItemSupplierResponse = () => {
                    const item =
                      e.event_item_supplier || e.auction_item_supplier_response
                    return map(item, (j, ji) => {
                      return (
                        <td
                          key={ji}
                          className="supplier-name header-calculate"
                          onClick={() => {
                            this.onClickSaving(ei)
                          }}
                        />
                      )
                    })
                  }
                  return (
                    <tr className="supplier-item-save">
                      <td className="no"></td>
                      <td className={`item`}>
                        {this.renderCheckAllSupplier(checkAllSupplier, e, ei)}
                      </td>
                      {rfqItemSupplierResponse()}
                    </tr>
                  )
                }
                const funcRenderSupplierItemCheck = () => {
                  const { rolesCheck } = this.state
                  const { roles } = rolesCheck
                  const renderChecked = () => {
                    if (e.checked) {
                      return this.renderRFQItemSupplierResponse(e, formData, ei)
                    } else {
                      const rfqItem = e.event_item_supplier
                      const auctionItem = e.auction_item_supplier_response
                      return map(rfqItem || auctionItem, (j, ji) => {
                        return (
                          <td className="supplier-name save-row" key={ji}>
                            &nbsp;
                          </td>
                        )
                      })
                    }
                  }
                  return (
                    <tr className="supplier-item supplier-item-check">
                      <td className="no"></td>
                      <td className="item">
                        {/*Event Type = RFQ will show Allocate Button and Selected Button*/}
                        {roles !== 'approver' &&
                          Number(eventType) === 1 &&
                          this.renderButtonAllowSelect(
                            e,
                            formData,
                            savingType,
                            ei
                          )}
                      </td>
                      {renderChecked()}
                    </tr>
                  )
                }
                return (
                  <React.Fragment key={e.id}>
                    {/*Detail of each items list*/}
                    {funcRenderSupplierItem()}
                    {/*Detail of saving calculation and select of each item*/}
                    {funcRenderSupplierItemSave()}
                    {/*Selection Button*/}
                    {funcRenderSupplierItemCheck()}
                  </React.Fragment>
                )
              })
            }
          }
          const handlersClearAll = e => {
            return this.toggleModal('modals-clear-all')
          }
          const renderFuncClearAll = () => {
            const {
              formData,
              awardStatuses,
              rolesCheck,
              dataProject,
            } = this.state
            const { roles } = rolesCheck
            const checkAwaSel = 'Awaiting Selection'
            const matchValueAwa = this.matchValue(
              awardStatuses,
              formData.rfq_award_status_id || formData.auction_award_status_id
            )
            if (
              matchValueAwa === checkAwaSel &&
              dataProject.project_status_id == 2
            ) {
              return (
                <Button
                  className="theme-border-blue"
                  onClick={handlersClearAll}
                  disabled={
                    this.state.eventListHaveApprove ||
                    this.state.isHavingListEventOpen
                  }
                >
                  Clear All
                </Button>
              )
            }
          }
          const renderTotal = () => {
            if (formData.seal_status_name != 'Awaiting Unseal') {
              return this.renderTotal(quotationList, formData)
            } else {
              return ''
            }
          }
          // if (statusRFQ !== 2) {
          const showSavingClear = this.funcShowSavingClearAll()
          const showClearAll = this.funcCheckSelectionsRole()
          let { savingType, setDataInit, checkAward } = this.state
          let rfq_id = ''
          if (setDataInit && setDataInit.length !== 0) {
            // rfq_id = setDataInit[0].rfq_id || setDataInit[0].auction_id
            rfq_id = setDataInit.rfq_id || setDataInit.auction_id
          }
          const { res } = savingType
          const funcSetFormat = number => {
            let numberFormat = ''
            const na = 'N/A'
            if (number === na) {
              numberFormat = na
            } else {
              numberFormat = Numeral(number).format('0,0.00')
            }
            return numberFormat
          }
          let {
            average_reserve_price,
            average_extended_price,
            average_total_saving_price,
            budget_reserve_price,
            budget_total_saving_price,
            budget_extended_price,
            historical_reserve_price,
            historical_extended_price,
            historical_total_saving_price,
            market_reserve_price,
            market_extended_price,
            market_total_saving_price,
            saving_type,
            award_price,
            award_price_fcy,
            exchange_rate,
            editable,
          } = res
          average_reserve_price = funcSetFormat(average_reserve_price)
          average_extended_price = funcSetFormat(average_extended_price)
          average_total_saving_price = funcSetFormat(average_total_saving_price)
          budget_reserve_price = funcSetFormat(budget_reserve_price)
          budget_extended_price = funcSetFormat(budget_extended_price)
          budget_total_saving_price = funcSetFormat(budget_total_saving_price)
          historical_reserve_price = funcSetFormat(historical_reserve_price)
          historical_extended_price = funcSetFormat(historical_extended_price)
          historical_total_saving_price = funcSetFormat(
            historical_total_saving_price
          )
          market_reserve_price = funcSetFormat(market_reserve_price)
          market_extended_price = funcSetFormat(market_extended_price)
          market_total_saving_price = funcSetFormat(market_total_saving_price)
          exchange_rate = Numeral(exchange_rate).format('0,0.0000')
          award_price = funcSetFormat(award_price)
          award_price_fcy = funcSetFormat(award_price_fcy)

          let checkBtnEdit = false
          const userId = localStorage.getItem('buyerId')

          let isSeale = false
          if (!formData.seal_type) {
            isSeale = true
          } else if (
            formData.seal_type &&
            formData.seal_status_name.includes('Unsealed')
          ) {
            isSeale = true
          }

          const checkBtnEditable = () => {
            const award_status_id =
              formData.rfq_award_status_id || formData.auction_award_status_id
            const status_id =
              formData.rfq_status_id || formData.auction_status_id
            if (
              editable && // Editable = Yes
              isSeale && // ไม่มี seale หรือ seale แต่ต้อง Unsealed แล้ว
              status_id == 4 && // Event Status = Closed
              award_status_id == 3 && // Award Status = Awaiting Selection
              this.state.dataProject.project_status_id == 2 && // Project Status = WIP
              this.state.dataProject.created_by_id == userId // เท่ากับเจ้าของ Event
            ) {
              checkBtnEdit = true
            }
            return checkBtnEdit
          }

          const renderExchangeRate = () => {
            return (
              <>
                {/* Start Exchange Rate */}
                <Section mt="5rem"></Section>
                {formData.currency != this.state.baseCurrency && (
                  <Section className="row">
                    <Section className="col-3">
                      <Section className="form-group">
                        <label className="label">
                          Exchange Rate ({formData.currency})
                        </label>
                      </Section>
                    </Section>
                    <Section className="col-3">
                      <Section className="form-group">
                        <Section className="form-group-control">
                          <Section className="form-group-inner-wrapper">
                            <Input disabled={true} value={exchange_rate} />
                          </Section>
                          <Section className="message"></Section>
                        </Section>
                      </Section>
                    </Section>
                    {checkBtnEditable() && (
                      <Section className="col-1" ml="1rem">
                        <Button
                          className="theme-blue"
                          onClick={() => {
                            // this.setState({ exchangeRate: exchange_rate })
                            this.toggleModal('modal-edit-exchange-rate')
                          }}
                          disabled={
                            this.state.eventListHaveApprove ||
                            this.state.isHavingListEventOpen
                          }
                        >
                          Edit
                        </Button>
                      </Section>
                    )}
                  </Section>
                )}
                <Section className="row">
                  <Section className="col-3">
                    <Section className="form-group">
                      <label className="label">
                        Total Amount for Award ({formData.currency})
                      </label>
                    </Section>
                  </Section>
                  <Section className="col-3">
                    <Section className="form-group">
                      <Section className="form-group-control">
                        <Section className="form-group-inner-wrapper">
                          <Input disabled={true} value={award_price_fcy} />
                        </Section>
                        <Section className="message"></Section>
                      </Section>
                    </Section>
                  </Section>
                  {formData.currency != this.state.baseCurrency &&
                    checkBtnEditable() && (
                      <Section className="col-1" ml="1rem"></Section>
                    )}
                </Section>
                {formData.currency != this.state.baseCurrency && (
                  <Section className="row">
                    <Section className="col-3">
                      <Section className="form-group">
                        <label className="label">
                          Total Amount for Award ({this.state.baseCurrency})
                        </label>
                      </Section>
                    </Section>
                    <Section className="col-3">
                      <Section className="form-group">
                        <Section className="form-group-control">
                          <Section className="form-group-inner-wrapper">
                            <Input disabled={true} value={award_price} />
                          </Section>
                          <Section className="message"></Section>
                        </Section>
                      </Section>
                    </Section>
                    {checkBtnEditable() && (
                      <Section className="col-1" ml="1rem"></Section>
                    )}
                  </Section>
                )}
              </>
            )
          }

          const renderSavingTypeTable = () => {
            const funcColorSetA = (savingType = '') => {
              if (savingType === saving_type) {
                return '#16A651'
              } else {
                return '#4b4acb'
              }
            }
            const funcColorSetB = (savingType = '') => {
              if (savingType === saving_type) {
                return '#16A651'
              } else {
                return '#4b4acb'
              }
            }
            const funcColorSetH = (savingType = '') => {
              if (savingType === saving_type) {
                return '#16A651'
              } else {
                return '#4b4acb'
              }
            }
            const funcColorSetM = (savingType = '') => {
              if (savingType === saving_type) {
                return '#16A651'
              } else {
                return '#4b4acb'
              }
            }
            return (
              <Section
                className="table-header-freeze-wrapper"
                style={{ justifyContent: 'center', paddingTop: '30px' }}
              >
                <Table className="header-freeze table-saving">
                  <Table.TBODY>
                    <Table.TR>
                      <Table.TH className="saving-type">SAVING TYPE</Table.TH>
                      <Table.TH className="reserve-price">
                        RESERVE PRICE ({this.state.baseCurrency})
                      </Table.TH>
                      <Table.TH className="extended-price">
                        EXTENDED PRICE ({this.state.baseCurrency})
                      </Table.TH>
                      <Table.TH className="total-saving">
                        TOTAL SAVING ({this.state.baseCurrency})
                      </Table.TH>
                    </Table.TR>
                  </Table.TBODY>
                </Table>
                <Table className="split-row-color saving-type table-saving">
                  <Table.TBODY>
                    <Table.TR>
                      <Table.TD
                        className="saving-type"
                        style={{
                          color: funcColorSetA('Average price'),
                        }}
                      >
                        <Section
                          className="form-group"
                          style={{
                            alignItems: 'center',
                          }}
                        >
                          <Checkbox
                            id="Average price"
                            value="Average price"
                            type="radio"
                            style={{
                              maxWidth: '25px',
                            }}
                            className="checkbox-award"
                            name="Average price"
                            disabled={true}
                            checked={saving_type === 'Average price'}
                            onChange={' '}
                          />
                          <Text
                            tootipValue="Average Price"
                            useTootipFor="Average Price"
                            useTootip={true}
                          >
                            Average Price
                          </Text>
                        </Section>
                      </Table.TD>
                      <Table.TD
                        className="reserve-price"
                        style={{
                          color: funcColorSetA('Average price'),
                          textAlign: 'right',
                        }}
                      >
                        {average_reserve_price}
                      </Table.TD>
                      <Table.TD
                        className="extended-price"
                        style={{
                          textAlign: 'right',
                          color: funcColorSetA('Average price'),
                        }}
                      >
                        {average_extended_price}
                      </Table.TD>
                      <Table.TD
                        className="total-saving"
                        style={{
                          textAlign: 'right',
                          color: funcColorSetA('Average price'),
                        }}
                      >
                        {average_total_saving_price}
                      </Table.TD>
                    </Table.TR>
                    <Table.TR>
                      <Table.TD
                        className="saving-type"
                        style={{
                          color: funcColorSetB('Budget price'),
                        }}
                      >
                        <Section
                          className="form-group"
                          style={{
                            alignItems: 'center',
                          }}
                        >
                          <Checkbox
                            id="Budget price"
                            value="Budget price"
                            type="radio"
                            style={{
                              maxWidth: '25px',
                            }}
                            className="checkbox-award"
                            name="Budget price"
                            disabled={true}
                            checked={saving_type === 'Budget price'}
                            onChange={' '}
                          />
                          <Text
                            tootipValue="Budget Price"
                            useTootipFor="Budget Price"
                            useTootip={true}
                          >
                            Budget Price
                          </Text>
                        </Section>
                      </Table.TD>
                      <Table.TD
                        className="reserve-price"
                        style={{
                          textAlign: 'right',
                          color: funcColorSetB('Budget price'),
                        }}
                      >
                        {budget_reserve_price}
                      </Table.TD>
                      <Table.TD
                        className="extended-price"
                        style={{
                          textAlign: 'right',
                          color: funcColorSetB('Budget price'),
                        }}
                      >
                        {budget_extended_price}
                      </Table.TD>
                      <Table.TD
                        className="total-saving"
                        style={{
                          textAlign: 'right',
                          color: funcColorSetB('Budget price'),
                        }}
                      >
                        {budget_total_saving_price}
                      </Table.TD>
                    </Table.TR>
                    <Table.TR>
                      <Table.TD
                        className="saving-type"
                        style={{
                          color: funcColorSetH('Historical price'),
                        }}
                      >
                        <Section
                          className="form-group"
                          style={{
                            alignItems: 'center',
                          }}
                        >
                          <Checkbox
                            id="Historical price"
                            value="Historical price"
                            type="radio"
                            style={{
                              maxWidth: '25px',
                            }}
                            className="checkbox-award"
                            name="Historical price"
                            disabled={true}
                            checked={saving_type === 'Historical price'}
                            onChange={' '}
                          />
                          <Text
                            tootipValue="Historical Price"
                            useTootipFor="Historical Price"
                            useTootip={true}
                          >
                            Historical Price
                          </Text>
                        </Section>
                      </Table.TD>
                      <Table.TD
                        className="reserve-price"
                        style={{
                          textAlign: 'right',
                          color: funcColorSetH('Historical price'),
                        }}
                      >
                        {historical_reserve_price}
                      </Table.TD>
                      <Table.TD
                        className="extended-price"
                        style={{
                          textAlign: 'right',
                          color: funcColorSetH('Historical price'),
                        }}
                      >
                        {historical_extended_price}
                      </Table.TD>
                      <Table.TD
                        className="total-saving"
                        style={{
                          textAlign: 'right',
                          color: funcColorSetH('Historical price'),
                        }}
                      >
                        {historical_total_saving_price}
                      </Table.TD>
                    </Table.TR>
                    <Table.TR>
                      <Table.TD
                        className="saving-type"
                        style={{
                          color: funcColorSetM('Market price'),
                        }}
                      >
                        <Section
                          className="form-group"
                          style={{
                            alignItems: 'center',
                          }}
                        >
                          <Checkbox
                            id="Market price"
                            value="Market price"
                            type="radio"
                            style={{
                              maxWidth: '25px',
                            }}
                            className="checkbox-award"
                            name="Market price"
                            disabled={true}
                            checked={saving_type === 'Market price'}
                            onChange={' '}
                          />
                          <Text
                            tootipValue="Market Price"
                            useTootipFor="Market Price"
                            useTootip={true}
                          >
                            Market Price
                          </Text>
                        </Section>
                      </Table.TD>
                      <Table.TD
                        className="reserve-price"
                        style={{
                          textAlign: 'right',
                          color: funcColorSetM('Market price'),
                        }}
                      >
                        {market_reserve_price}
                      </Table.TD>
                      <Table.TD
                        className="extended-price"
                        style={{
                          textAlign: 'right',
                          color: funcColorSetM('Market price'),
                        }}
                      >
                        {market_extended_price}
                      </Table.TD>
                      <Table.TD
                        className="total-saving"
                        style={{
                          textAlign: 'right',
                          color: funcColorSetM('Market price'),
                        }}
                      >
                        {market_total_saving_price}
                      </Table.TD>
                    </Table.TR>
                  </Table.TBODY>
                </Table>
              </Section>
            )
          }
          const renderSubmitAward = () => {
            const handlerCheckboxAward = e => {
              // const { res } = savingType
              const { id, value } = e.target
              switch (value) {
                case 'Average price':
                  checkAward.submitaward = 'Average price'
                  checkAward.selected = value
                  if (this._isMounted) {
                    this.setState({ checkAward })
                  }
                  break
                case 'Budget price':
                  checkAward.submitaward = 'Budget price'
                  checkAward.selected = value
                  if (this._isMounted) {
                    this.setState({ checkAward })
                  }
                  break
                case 'Historical price':
                  checkAward.submitaward = 'Historical price'
                  checkAward.selected = value
                  if (this._isMounted) {
                    this.setState({ checkAward })
                  }
                  break
                case 'Market price':
                  checkAward.submitaward = 'Market price'
                  checkAward.selected = value
                  if (this._isMounted) {
                    this.setState({ checkAward })
                  }
                  break
                default:
                  checkAward.submitaward = 'Budget price'
                  checkAward.selected = value
                  if (this._isMounted) {
                    this.setState({ checkAward })
                  }
                  break
              }
            }
            return (
              <div className="exchange-rate">
                {award_price !== 0 && renderExchangeRate()}
                {!this.state.savingType.error &&
                  Number(this.state.savingType.res.award_price_fcy) !== 0 && (
                    <Section
                      style={{ justifyContent: 'center', paddingTop: '30px' }}
                      className="table-header-freeze-wrapper"
                    >
                      <Table className="header-freeze table-saving">
                        <Table.TBODY>
                          <Table.TR>
                            <Table.TH className="saving-type">
                              SAVING TYPE
                            </Table.TH>
                            <Table.TH className="reserve-price">
                              RESERVE PRICE ({this.state.baseCurrency})
                            </Table.TH>
                            <Table.TH className="extended-price">
                              EXTENDED PRICE ({this.state.baseCurrency})
                            </Table.TH>
                            <Table.TH className="total-saving">
                              TOTAL SAVING ({this.state.baseCurrency})
                            </Table.TH>
                          </Table.TR>
                        </Table.TBODY>
                      </Table>
                      <Table className="split-row-color saving-type table-saving">
                        <Table.TBODY>
                          <Table.TR>
                            <Table.TD className="saving-type average-price">
                              <Section
                                className="form-group"
                                style={{
                                  alignItems: 'center',
                                  color:
                                    checkAward.selected === 'Average price'
                                      ? '#16A651'
                                      : '#4b4acb',
                                }}
                              >
                                <Checkbox
                                  id="Average price"
                                  value="Average price"
                                  type="radio"
                                  style={{
                                    maxWidth: '25px',
                                  }}
                                  className="checkbox-award"
                                  name="Average price"
                                  disabled={
                                    this.state.eventListHaveApprove ||
                                    this.state.isHavingListEventOpen
                                      ? this.state.eventListHaveApprove ||
                                        this.state.isHavingListEventOpen
                                      : average_total_saving_price === 'N/A'
                                  }
                                  checked={
                                    checkAward.selected === 'Average price'
                                  }
                                  onChange={handlerCheckboxAward}
                                />
                                <Text
                                  tootipValue="Average price"
                                  useTootipFor="Average price"
                                  useTootip={true}
                                >
                                  Average Price
                                </Text>
                              </Section>
                            </Table.TD>
                            <Table.TD
                              className="reserve-price"
                              style={{
                                textAlign: 'right',
                                color:
                                  checkAward.selected === 'Average price'
                                    ? '#16A651'
                                    : '#4b4acb',
                              }}
                            >
                              {average_reserve_price}
                            </Table.TD>
                            <Table.TD
                              className="extended-price"
                              style={{
                                textAlign: 'right',
                                color:
                                  checkAward.selected === 'Average price'
                                    ? '#16A651'
                                    : '#4b4acb',
                              }}
                            >
                              {average_extended_price}
                            </Table.TD>
                            <Table.TD
                              className="total-saving"
                              style={{
                                textAlign: 'right',
                                color:
                                  checkAward.selected === 'Average price'
                                    ? '#16A651'
                                    : '#4b4acb',
                              }}
                            >
                              {average_total_saving_price}
                            </Table.TD>
                          </Table.TR>
                          <Table.TR>
                            <Table.TD className="saving-type">
                              <Section
                                className="form-group"
                                style={{
                                  alignItems: 'center',
                                  color:
                                    checkAward.selected === 'Budget price'
                                      ? '#16A651'
                                      : '#4b4acb',
                                }}
                              >
                                <Checkbox
                                  id="Budget price"
                                  value="Budget price"
                                  type="radio"
                                  style={{
                                    maxWidth: '25px',
                                  }}
                                  className="checkbox-award"
                                  name="Budget price"
                                  disabled={
                                    this.state.eventListHaveApprove ||
                                    this.state.isHavingListEventOpen
                                      ? this.state.eventListHaveApprove ||
                                        this.state.isHavingListEventOpen
                                      : budget_total_saving_price === 'N/A'
                                  }
                                  checked={
                                    checkAward.selected === 'Budget price'
                                  }
                                  onChange={handlerCheckboxAward}
                                />
                                <Text
                                  tootipValue="Budget Price"
                                  useTootipFor="Budget Price"
                                  useTootip={true}
                                >
                                  Budget Price
                                </Text>
                              </Section>
                            </Table.TD>
                            <Table.TD
                              className="reserve-price"
                              style={{
                                textAlign: 'right',
                                color:
                                  checkAward.selected === 'Budget price'
                                    ? '#16A651'
                                    : '#4b4acb',
                              }}
                            >
                              {budget_reserve_price}
                            </Table.TD>
                            <Table.TD
                              className="extended-price"
                              style={{
                                textAlign: 'right',
                                color:
                                  checkAward.selected === 'Budget price'
                                    ? '#16A651'
                                    : '#4b4acb',
                              }}
                            >
                              {budget_extended_price}
                            </Table.TD>
                            <Table.TD
                              className="total-saving"
                              style={{
                                textAlign: 'right',
                                color:
                                  checkAward.selected === 'Budget price'
                                    ? '#16A651'
                                    : '#4b4acb',
                              }}
                            >
                              {budget_total_saving_price}
                            </Table.TD>
                          </Table.TR>
                          <Table.TR>
                            <Table.TD className="saving-type">
                              <Section
                                className="form-group"
                                style={{
                                  alignItems: 'center',
                                  color:
                                    checkAward.selected === 'Historical price'
                                      ? '#16A651'
                                      : '#4b4acb',
                                }}
                              >
                                <Checkbox
                                  id="Historical price"
                                  value="Historical price"
                                  type="radio"
                                  style={{
                                    maxWidth: '25px',
                                  }}
                                  className="checkbox-award"
                                  name="Historical price"
                                  disabled={
                                    this.state.eventListHaveApprove ||
                                    this.state.isHavingListEventOpen
                                      ? this.state.eventListHaveApprove ||
                                        this.state.isHavingListEventOpen
                                      : historical_total_saving_price === 'N/A'
                                  }
                                  checked={
                                    checkAward.selected === 'Historical price'
                                  }
                                  onChange={handlerCheckboxAward}
                                />
                                <Text
                                  tootipValue="Historical Price"
                                  useTootipFor="Historical Price"
                                  useTootip={true}
                                >
                                  Historical Price
                                </Text>
                              </Section>
                            </Table.TD>
                            <Table.TD
                              className="reserve-price"
                              style={{
                                textAlign: 'right',
                                color:
                                  checkAward.selected === 'Historical price'
                                    ? '#16A651'
                                    : '#4b4acb',
                              }}
                            >
                              {historical_reserve_price}
                            </Table.TD>
                            <Table.TD
                              className="extended-price"
                              style={{
                                textAlign: 'right',
                                color:
                                  checkAward.selected === 'Historical price'
                                    ? '#16A651'
                                    : '#4b4acb',
                              }}
                            >
                              {historical_extended_price}
                            </Table.TD>
                            <Table.TD
                              className="total-saving"
                              style={{
                                flex: '0 0 27%',
                                textAlign: 'right',
                                color:
                                  checkAward.selected === 'Historical price'
                                    ? '#16A651'
                                    : '#4b4acb',
                              }}
                            >
                              {historical_total_saving_price}
                            </Table.TD>
                          </Table.TR>
                          <Table.TR>
                            <Table.TD
                              className="saving-type"
                              style={{
                                flex: '0 0 19%',
                              }}
                            >
                              <Section
                                className="form-group"
                                style={{
                                  alignItems: 'center',
                                  color:
                                    checkAward.selected === 'Market price'
                                      ? '#16A651'
                                      : '#4b4acb',
                                }}
                              >
                                <Checkbox
                                  id="Market price"
                                  value="Market price"
                                  type="radio"
                                  style={{
                                    maxWidth: '25px',
                                  }}
                                  className="checkbox-award"
                                  name="Market price"
                                  disabled={
                                    this.state.eventListHaveApprove ||
                                    this.state.isHavingListEventOpen
                                      ? this.state.eventListHaveApprove ||
                                        this.state.isHavingListEventOpen
                                      : market_total_saving_price === 'N/A'
                                  }
                                  checked={
                                    checkAward.selected === 'Market price'
                                  }
                                  onChange={handlerCheckboxAward}
                                />
                                <Text
                                  tootipValue="Market Price"
                                  useTootipFor="Market Price"
                                  useTootip={true}
                                >
                                  Market Price
                                </Text>
                              </Section>
                            </Table.TD>
                            <Table.TD
                              className="reserve-price"
                              style={{
                                flex: '0 0 27%',
                                textAlign: 'right',
                                color:
                                  checkAward.selected === 'Market price'
                                    ? '#16A651'
                                    : '#4b4acb',
                              }}
                            >
                              {market_reserve_price}
                            </Table.TD>
                            <Table.TD
                              className="extended-price"
                              style={{
                                flex: '0 0 27%',
                                textAlign: 'right',
                                color:
                                  checkAward.selected === 'Market price'
                                    ? '#16A651'
                                    : '#4b4acb',
                              }}
                            >
                              {market_extended_price}
                            </Table.TD>
                            <Table.TD
                              className="total-saving"
                              style={{
                                flex: '0 0 27%',
                                textAlign: 'right',
                                color:
                                  checkAward.selected === 'Market price'
                                    ? '#16A651'
                                    : '#4b4acb',
                              }}
                            >
                              {market_total_saving_price}
                            </Table.TD>
                          </Table.TR>
                        </Table.TBODY>
                      </Table>
                    </Section>
                  )}
              </div>
            )
          }

          const renderSavingType = () => {
            return (
              <div className="exchange-rate">
                {renderExchangeRate()}
                {!this.state.savingType.error &&
                  Number(this.state.savingType.res.award_price_fcy) !== 0 &&
                  renderSavingTypeTable()}
              </div>
            )
          }

          const changePage = async activePage => {
            if (this._isMounted) {
              this.setState({ activePage: activePage })
              this.getItemCompare(
                this.state.supplierList,
                this.state.event_id,
                activePage
              )
            }
          }

          const renderPaginationList = () => {
            return (
              this.state.total_record > 10 && (
                <Section className="content-footer">
                  <Section className="showing-item">
                    Showing {(this.state.activePage - 1) * 10 + 1} to{' '}
                    {this.state.activePage >
                    Math.floor(this.state.total_record / 10)
                      ? (this.state.activePage - 1) * 10 +
                        (this.state.total_record % 10)
                      : this.state.activePage * 10}{' '}
                    of {this.state.total_record} items
                  </Section>

                  <Section className="paginate-wrapper">
                    <Paginate
                      activePage={this.state.activePage}
                      itemsCountPerPage={this.state.limit}
                      totalItemsCount={this.state.total_record}
                      onChange={e => {
                        if (this._isMounted) {
                          return changePage(e)
                          // this.setState({
                          //   searchPage:
                          //     parseInt(e.target.value) >
                          //     Math.floor(quotationList.length / 10) + 1
                          //       ? Math.floor(quotationList.length / 10) + 1
                          //       : parseInt(e.target.value),
                          // })
                        }
                      }}
                    />

                    <Section className="moveto-wrapper">
                      <NumberFormat
                        value={this.state.searchPage}
                        label="Page"
                        isHorizontal
                        className="paginate-moveto"
                        defaultValue="1"
                        maxLength="4"
                        customInput={Input}
                        decimalSeparator={false}
                        allowNegative={false}
                        allowLeadingZeros={false}
                        onChange={e => {
                          if (this._isMounted) {
                            return this.setState({
                              searchPage:
                                parseInt(e.target.value) >
                                Math.floor(this.state.total_record / 10) + 1
                                  ? Math.floor(this.state.total_record / 10) + 1
                                  : parseInt(e.target.value),
                            })
                          }
                        }}
                        isAllowed={values => {
                          return isAllowedChangePage(values, this.props.maximum)
                        }}
                      />
                      <Button
                        onClick={() => {
                          if (this.state.searchPage) {
                            return changePage(this.state.searchPage)
                          }
                        }}
                      >
                        go
                      </Button>
                    </Section>
                  </Section>
                </Section>
              )
            )
          }

          const checkSubmitAward = () => {
            const showSubmitAw = this.funcCheckSubmitAwardRole()
            let awardStatus = this.matchValue(
              this.state.awardStatuses,
              formData.rfq_award_status_id || formData.auction_award_status_id
            )
            const awardStatusEqualAwaSel =
              !savingType.error &&
              this.matchValue(
                this.state.awardStatuses,
                formData.rfq_award_status_id || formData.auction_award_status_id
              ) === 'Awaiting Selection' &&
              !this.state.submitAward
            const approValMoreThanZero =
              this.state.approValWorkflow &&
              this.state.approValWorkflow.levels.length !== 0
            if (
              awardStatusEqualAwaSel &&
              approValMoreThanZero &&
              showSubmitAw
            ) {
              return renderSubmitAward()
            }

            let showByRole = false
            let hide_savingtype = false
            if (this.state.checkRole === rolesObj.tec) {
              showByRole = false
              hide_savingtype = true
            } else if (awardStatus === 'No Selection') {
              hide_savingtype = true
            } else {
              hide_savingtype = false
              let isAOrP = false
              let isTec = false
              if (this.state.checkMultiRole) {
                for (var i = 0; i < this.state.checkMultiRole.length; i++) {
                  if (this.state.checkMultiRole[i].id === rolesObj.tec) {
                    isTec = true
                  }
                  if (
                    this.state.checkMultiRole[i].id === rolesObj.approver ||
                    this.state.checkMultiRole[i].id === rolesObj.purchaser
                  ) {
                    if (this.state.checkMultiRole[i].id === rolesObj.approver) {
                      isAOrP = this.funcShowbuttonAppRe()
                    } else {
                      isAOrP = true
                    }
                  }
                }
              }
              if (isTec) {
                showByRole = isAOrP
              } else {
                showByRole = true
              }
            }
            const awardStatusNotEqualNoSelection =
              showSavingClear &&
              !this.state.savingType.error &&
              showByRole &&
              awardStatus !== 'No Selection'
            const notHideSavingType =
              !this.state.savingType.error && !hide_savingtype

            if (awardStatusNotEqualNoSelection || notHideSavingType) {
              return renderSavingType()
            } else {
              return ''
            }
          }
          return (
            <React.Fragment>
              <Section
                className="form-wrapper"
                style={{
                  padding: '0px 30px 0px 30px',
                }}
              >
                <Section className="compare-event-table-wrapper">
                  <Table className="compare-event split-row-color">
                    <Table.TBODY>
                      <Table.TR>
                        <Table.TH className="check-box">
                          <Checkbox
                            name="business_type"
                            id="checkAll"
                            value=""
                            checked={checkAllSupplier}
                            onChange={e => {
                              this.onChangeCheckAll()
                            }}
                          ></Checkbox>
                        </Table.TH>
                        <Table.TH className="no">NO.</Table.TH>
                        <Table.TH className="tax-id">TAX ID</Table.TH>
                        <Table.TH className="supplier-name">
                          SUPPLIER NAME
                        </Table.TH>
                        <Table.TH className="contact-name">
                          CONTACT NAME
                        </Table.TH>
                        <Table.TH className="phone">PHONE</Table.TH>
                        <Table.TH className="email">EMAIL</Table.TH>
                        <Table.TH className="response-date">
                          RESPONSE DATE
                        </Table.TH>
                        <Table.TH className="term-status">TERM STATUS</Table.TH>
                        <Table.TH className="status">RESPONSE STATUS</Table.TH>
                        {this.state.formData.event_type_id === 1 && (
                          <>
                            <Table.TH className="status">
                              NOTE TO BUYER
                            </Table.TH>
                            <Table.TH className="status">ATTACHMENT</Table.TH>
                          </>
                        )}

                        {this.state.formData.event_type_id === 2 &&
                          statusRFQ === 4 && (
                            <Table.TH className="status">BID HISTORY</Table.TH>
                          )}
                      </Table.TR>
                      {funcSupplierList()}
                    </Table.TBODY>
                  </Table>
                </Section>
                <Section className="compare-list-wrapper">
                  <Tabber>
                    <Tabber.TabList>
                      <Tabber.Tab className="react-tabs__tab theme-transparent">
                        Quotation
                      </Tabber.Tab>
                      <Section
                        className="form-actions"
                        style={{
                          marginTop: 'unset',
                          marginBottom: '1em',
                          zIndex: '10',
                          marginRight: '-30px',
                        }}
                      >
                        <Section className="button-group">
                          {/* ปิดปุ่ม Saving Type */}
                          {showSavingClear &&
                            showClearAll &&
                            renderFuncClearAll()}
                        </Section>
                      </Section>
                    </Tabber.TabList>
                    <Tabber.TabPanel>
                      {/* pagination items top */}
                      {/* {renderPaginationList()} */}
                      {/*<Section className="compare-list-table">*/}
                      {/*  <table className="table compare-list header-freeze">*/}
                      {/*    <tr>*/}
                      {/*      <th className="no">NO.</th>*/}
                      {/*      <th className="item">ITEM</th>*/}
                      {/*      {funcRenderCompareListTable()}*/}
                      {/*    </tr>*/}
                      {/*    {renderQuotationList()}*/}
                      {/*  </table>*/}
                      {/*  <table className="table compare-list total header-freeze">*/}
                      {/*    <tr className="supplier-item ">*/}
                      {/*      <td className="no"></td>*/}
                      {/*      <td className="item">*/}
                      {/*        <Section className="item-list">*/}
                      {/*          <strong>*/}
                      {/*            Total {this.state.total_record} items*/}
                      {/*          </strong>*/}
                      {/*        </Section>*/}
                      {/*      </td>*/}
                      {/*      {renderTotal()}*/}
                      {/*    </tr>*/}
                      {/*  </table>*/}
                      {/*</Section>*/}
                      {/* pagination items bottom */}
                      {/* {renderPaginationList()} */}

                      <CompareListTable
                        // quotationList={mockQuotationList}
                        quotationList={quotationList}
                        onOpenDescription={detail => {
                          this.setState({ quotationDetail: detail })
                          this.toggleModal('supplier-description')
                        }}
                      />
                    </Tabber.TabPanel>
                  </Tabber>
                </Section>

                {checkSubmitAward()}
              </Section>
            </React.Fragment>
          )
        }
        const renderButtonAction = () => {
          const showSubmitAw = this.funcCheckSubmitAwardRole()
          const { unsealed } = sealStatus
          const { seal_status_name, seal_type } = formData
          const renderButtonSubmitAward = () => {
            const { savingType, dataProject } = this.state
            const handlersClick = async () => {
              const { match } = this.props
              const { params } = match
              const { id: idProject, rfqid } = params
              // const res = await rfqController().checkFlowUpdate(rfqid)
              // if (res && res.is_update) {
              //   this.toggleModal('modals-check-award')
              // } else {
              //   this.toggleModal('modals-submit-award')
              // }
            }
            if (
              !savingType.error &&
              this.matchValue(
                this.state.awardStatuses,
                formData.rfq_award_status_id || formData.auction_award_status_id
              ) === 'Awaiting Selection' &&
              !this.state.submitAward
            ) {
              if (
                this.state.approValWorkflow &&
                this.state.approValWorkflow.levels.length !== 0 &&
                Number(this.state.savingType.res.award_price_fcy) !== 0
              ) {
                if (
                  showSubmitAw &&
                  this.state.showButtonSubmit &&
                  dataProject.project_status_id === 2
                ) {
                  return (
                    <Button
                      className="theme-green"
                      onClick={handlersClick}
                      disabled={
                        this.state.eventListHaveApprove ||
                        this.state.isHavingListEventOpen
                      }
                    >
                      Submit Award
                    </Button>
                  )
                }
              }
            }
          }
          const renderButtonReSubmitAward = () => {
            const { dataProject, eventHaveAwaApp } = this.state
            const showButtonReSubmit = this.funcCheckButtonReSubmitAward()
            const handlersClick = () => {
              this.toggleModal('modals-re-submit-award')
            }
            const userId = localStorage.getItem('buyerId')
            if (
              this.matchValue(
                this.state.awardStatuses,
                formData.rfq_award_status_id || formData.auction_award_status_id
              ) === 'Rejected' &&
              // dataProject.project_status_id !== 3 &&
              // dataProject.project_status_id !== 4 &&
              dataProject.project_status_id == 2 &&
              dataProject.created_by_id == userId
            ) {
              if (showButtonReSubmit && !eventHaveAwaApp) {
                return (
                  <Button
                    className="theme-green re-submit-button"
                    onClick={handlersClick}
                  >
                    Re-Submit Award
                  </Button>
                )
              }
            }
          }
          const styleButtonEventsNone = (
            roles,
            matchValuePer,
            statusRolesApp
          ) => {
            const checkActions = this.funcShowbuttonAppRe()
            const styleButton = {
              width: '100%',
              height: '100%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }
            if (checkActions) {
              return {
                ...styleButton,
                cursor: 'pointer',
              }
            } else {
              return {
                ...styleButton,
                pointerEvents: 'none',
              }
            }
          }
          const renderButtonSubmitApprove = () => {
            let { approValWorkflow } = this.state

            const userIdFw = localStorage.getItem('buyerId')
            const userId = parseInt(userIdFw, 10)

            let approvable = false
            if (approValWorkflow && approValWorkflow.levels) {
              approvable = approValWorkflow.levels[
                approValWorkflow.current_level
              ].approvers.some(
                approve => approve.id === userId && approve.status === 1
              )
            }

            const handlersClick = () => {
              this.toggleModal('modals-approve-award')
            }
            const checkActions = this.funcShowbuttonAppRe() && approvable
            // && this.state.showButtonApprove
            if (checkActions) {
              return (
                <Button className="theme-green" onClick={handlersClick}>
                  Approve
                </Button>
              )
            }
          }
          const renderButtonSubmitReject = () => {
            const {
              approvalNote,
              statusRolesApp,
              awardStatuses,
              formData,
              rolesCheck,
              approvalFiels,
              approValWorkflow,
            } = this.state
            const matchValuePer = this.matchValue(
              awardStatuses,
              formData.rfq_award_status_id || formData.auction_award_status_id
            )
            const userIdFw = localStorage.getItem('buyerId')
            const userId = parseInt(userIdFw, 10)
            const { match } = this.props
            const { params } = match
            const { id, rfqid } = params
            const handlersClick = async e => {
              this.toggleModal('modal-submit-reject')
            }
            styleButtonEventsNone(
              rolesCheck.roles,
              matchValuePer,
              statusRolesApp
            )
            let approvable = false
            if (approValWorkflow && approValWorkflow.levels) {
              approvable = approValWorkflow.levels[
                approValWorkflow.current_level
              ].approvers.some(
                approve => approve.id === userId && approve.status === 1
              )
            }
            const checkActions = this.funcShowbuttonAppRe() && approvable
            if (checkActions) {
              return (
                <Button className="theme-red" onClick={handlersClick}>
                  Reject
                </Button>
              )
            }
          }
          const renderButtonNoSelection = () => {
            const { formData, awardStatuses, dataProject } = this.state
            const {
              seal_type,
              rfq_award_status_id,
              auction_award_status_id,
              seal_status_name,
            } = formData
            const showButtonNoSel = this.funcShowButtonNoSelection()
            const awaSelection = this.matchValue(
              awardStatuses,
              rfq_award_status_id || auction_award_status_id
            )
            const handlersClick = () => {
              this.toggleModal('modal-no-selection-reason')
            }
            if (
              awaSelection === 'Awaiting Selection' &&
              (seal_status_name === 'Unsealed' || !seal_type) &&
              showButtonNoSel &&
              this.state.showButtonNoSelect &&
              dataProject.project_status_id == 2
            ) {
              return (
                <Button
                  className="theme-red"
                  onClick={handlersClick}
                  disabled={
                    this.state.eventListHaveApprove ||
                    this.state.isHavingListEventOpen
                  }
                >
                  No Selection
                </Button>
              )
            }
          }
          const renderButtonCancelReq = () => {
            const {
              rolesCheck,
              approvalNote,
              statusRolesApp,
              awardStatuses,
              formData,
            } = this.state
            const matchValuePer = this.matchValue(
              awardStatuses,
              formData.rfq_award_status_id || formData.auction_award_status_id
            )
            const resRoles = pageCompareEventApprovalController().assetCancelReq()
            const { check } = resRoles

            const buyerId = localStorage.getItem('buyerId')
            const createby = formData.created_by_id
              ? formData.created_by_id.toString()
              : ''
            const isCreate = buyerId === createby ? true : false
            const handlersClick = () => {
              this.toggleModal('cancel-request')
            }
            if (
              check &&
              matchValuePer === 'Awaiting Approve' &&
              isCreate &&
              this.state.showButtonCancel
            ) {
              return (
                <Button className="theme-red" onClick={handlersClick}>
                  Cancel Request
                </Button>
              )
            }
          }
          const funcButtonCopy = () => {
            const showCopy = this.funcCheckCopyRole()
            if (showCopy) {
              return (
                <Button
                  className="theme-blue"
                  onClick={() => {
                    this.copyRfqByID()
                  }}
                >
                  Copy
                </Button>
              )
            } else {
              return <span></span>
            }
          }
          return (
            <Section className="form-actions">
              <Section className="button-group">
                {funcButtonCopy()}
                {activeStep !== 0 && (
                  <Button
                    className="theme-border-gray"
                    onClick={() => this.previousStep()}
                  >
                    Back
                  </Button>
                )}
              </Section>
              <Section className="button-group">
                {activeStep == 0 && (
                  <Button
                    className="theme-border-gray"
                    onClick={() => {
                      const { match } = this.props
                      const { params } = match
                      const linkProjectDetail = `/sourcing-project-detail/${params.id}`
                      localStorage.setItem('isFromDetail', false)
                      this.state.isFromDetail === 'true'
                        ? this.props.history.push(linkProjectDetail)
                        : this.props.history.push(
                            ROUTE_PATH.SOURCING_BUYER.LINK
                          )
                    }}
                  >
                    {formData.is_cancel || statusRFQ !== 2 ? 'Back' : 'Cancel'}
                  </Button>
                )}
                {activeStep !== 0 && (
                  <Button
                    className="theme-border-gray"
                    onClick={() => {
                      const { match } = this.props
                      const { params } = match
                      const linkProjectDetail = `/sourcing-project-detail/${params.id}`
                      localStorage.setItem('isFromDetail', false)
                      this.state.isFromDetail === 'true'
                        ? this.props.history.push(linkProjectDetail)
                        : this.props.history.push(
                            ROUTE_PATH.SOURCING_BUYER.LINK
                          )
                    }}
                  >
                    Close
                  </Button>
                )}
                {this.renderCancelEvent(formData, statusRFQ)}
                {this.renderUnsealButton(formData)}
                {renderButtonNoSelection()}
                {renderButtonSubmitAward()}
                {!this.state.reSubmitAward
                  ? renderButtonReSubmitAward()
                  : this.refreshPage()}
                {renderButtonSubmitReject()}
                {renderButtonSubmitApprove()}
                {renderButtonCancelReq()}

                {/* Start Mocktup Start Here */}
                <Button
                  className="theme-red"
                  onClick={() => this.toggleModal('modal-submit-reject')}
                  //this.toggleModal('modal-submit-reject')
                >
                  Reject
                </Button>
                <Button
                  className="theme-green"
                  onClick={() => this.toggleModal('modals-approve-award')}
                >
                  Approve
                </Button>
              </Section>
            </Section>
          )
        }

        const renderAppWorkflow = () => {
          const {
            approValWorkflow,
            statusAppVal,
            awardStatuses,
            formData,
            dataProject,
          } = this.state
          const renderRequester = () => {
            const { approValWorkflow } = this.state
            const { levels } = approValWorkflow
            const filterRequester = filter(levels, v => v.level === 0)
            const { approvers } = filterRequester[0]
            return map(approvers, (value, index) => {
              const { name, status } = value

              return (
                <Fragment key={index}>
                  <div className={`approval-step-requester`}>
                    <Text
                      tootipValue={name}
                      useTootipFor="name"
                      useTootip={true}
                      useEllipsis={true}
                      style={{
                        color: 'white',
                      }}
                    >
                      {name}
                    </Text>
                    <p>{status === 0 ? 'Request' : 'Requested'}</p>
                  </div>
                  {levels.length > 1 && (
                    <Image src={ICONS['chevron-right-solid.svg']} />
                  )}
                </Fragment>
              )
            })
          }
          const renderStatus = (
            condition = '',
            id = '',
            name = '',
            email = '',
            phone = '',
            status = '',
            arr = []
          ) => {
            if (condition || id || name || email || phone || status || arr) {
              const renderElement = () => {
                const user_tooltip = name + '\n' + email + '\n' + phone
                if (status === 0) {
                  return (
                    <div
                      className={`approval-step-requester approval-step-pending cursor-pointer`}
                      onClick={() =>
                        this.renderModalContactInfo(name, email, phone)
                      }
                    >
                      <Text
                        useTootipFor="name"
                        useTootip={true}
                        useEllipsis={true}
                        style={{
                          color: '#FC8601',
                          cursor: 'pointer',
                        }}
                      >
                        {name}
                      </Text>
                      <p>Pending</p>
                    </div>
                  )
                } else if (status === 1) {
                  return (
                    <div
                      className={`approval-step-requester approval-step-approving cursor-pointer`}
                      onClick={() =>
                        this.renderModalContactInfo(name, email, phone)
                      }
                    >
                      <Text
                        useTootipFor="name"
                        useTootip={true}
                        useEllipsis={true}
                        style={{
                          color: '#FC8601',
                          cursor: 'pointer',
                        }}
                      >
                        {name}
                      </Text>
                      <p>Awaiting Approve</p>
                    </div>
                  )
                } else if (status === 2) {
                  return (
                    <div
                      className={`approval-step-requester approval-step-approved cursor-pointer`}
                      onClick={() =>
                        this.renderModalContactInfo(name, email, phone)
                      }
                    >
                      <Text
                        useTootipFor="name"
                        useTootip={true}
                        useEllipsis={true}
                        style={{
                          color: 'white',
                          cursor: 'pointer',
                        }}
                      >
                        {name}
                      </Text>
                      <p>Approved</p>
                    </div>
                  )
                } else if (status === 3) {
                  return (
                    <div
                      className={`approval-step-requester approval-step-reject cursor-pointer`}
                      onClick={() =>
                        this.renderModalContactInfo(name, email, phone)
                      }
                    >
                      <Text
                        useTootipFor="name"
                        useTootip={true}
                        useEllipsis={true}
                        style={{
                          color: 'white',
                          cursor: 'pointer',
                        }}
                      >
                        {name}
                      </Text>
                      <p>Rejected</p>
                    </div>
                  )
                } else if (status === 4) {
                  return (
                    <div
                      className={`approval-step-requester approval-step-Inactive cursor-pointer
                      `}
                      onClick={() =>
                        this.renderModalContactInfo(name, email, phone)
                      }
                    >
                      <Text
                        useTootipFor="name"
                        useTootip={true}
                        useEllipsis={true}
                        style={{
                          color: '#707070',
                          cursor: 'pointer',
                        }}
                      >
                        {name}
                      </Text>
                      <p>Inactive</p>
                    </div>
                  )
                } else if (status === 5) {
                  return (
                    <div
                      className={`approval-step-requester approval-step-approved cursor-pointer`}
                      onClick={() =>
                        this.renderModalContactInfo(name, email, phone)
                      }
                    >
                      <Text
                        useTootipFor="name"
                        useTootip={true}
                        useEllipsis={true}
                        style={{
                          color: 'white',
                          cursor: 'pointer',
                        }}
                      >
                        {name}
                      </Text>
                      <p>-</p>
                    </div>
                  )
                }
              }
              return renderElement()
            }
          }
          const renderStatusAnd = (arr = [], lastIndex) => {
            const { approValWorkflow } = this.state
            const { levels } = approValWorkflow
            const idKey = Date.now()
            if (arr) {
              const renderElement = () => {
                const renderOrAnd = () => {
                  return map(arr, (value, index) => {
                    const { id, name, email, status, phone } = value
                    const firstArr = index
                    const lastArr = arr.length - 1 === index
                    const arrayOnce = arr.length === 1
                    const renderStatus = () => {
                      if (status === 0) {
                        const funcContentPendingAll = () => {
                          if (firstArr === 0) {
                            return (
                              <div
                                className={`approval-step-requester approval-step-pending or-and-class-first-pending cursor-pointer`}
                                key={index}
                                onClick={() =>
                                  this.renderModalContactInfo(
                                    name,
                                    email,
                                    phone
                                  )
                                }
                              >
                                <Text
                                  useTootipFor="name"
                                  useTootip={true}
                                  useEllipsis={true}
                                  style={{
                                    color: '#FC8601',
                                    cursor: 'pointer',
                                  }}
                                >
                                  {name}
                                </Text>
                                <p>Pending</p>
                              </div>
                            )
                          }
                          if (lastArr) {
                            return (
                              <div
                                className={`approval-step-requester approval-step-pending or-and-class-last-pending cursor-pointer`}
                                key={index}
                                onClick={() =>
                                  this.renderModalContactInfo(
                                    name,
                                    email,
                                    phone
                                  )
                                }
                              >
                                <Text
                                  useTootipFor="name"
                                  useTootip={true}
                                  useEllipsis={true}
                                  style={{
                                    color: '#FC8601',
                                    cursor: 'pointer',
                                  }}
                                >
                                  {name}
                                </Text>
                                <p>Pending</p>
                              </div>
                            )
                          }
                          return (
                            <div
                              className={`approval-step-requester approval-step-pending or-and-class-pending cursor-pointer`}
                              key={index}
                            >
                              <Text
                                useTootipFor="name"
                                useTootip={true}
                                useEllipsis={true}
                                style={{
                                  color: '#FC8601',
                                  cursor: 'pointer',
                                }}
                              >
                                {name}
                              </Text>
                              <p>Pending</p>
                            </div>
                          )
                        }
                        const funcContentPendingOnce = () => {
                          return (
                            <div
                              className={`approval-step-requester approval-step-pending cursor-pointer`}
                              key={index}
                              onClick={() =>
                                this.renderModalContactInfo(name, email, phone)
                              }
                            >
                              <Text
                                useTootipFor="name"
                                useTootip={true}
                                useEllipsis={true}
                                style={{
                                  color: '#FC8601',
                                  cursor: 'pointer',
                                }}
                              >
                                {name}
                              </Text>
                              <p>Pending</p>
                            </div>
                          )
                        }
                        if (arrayOnce) {
                          return funcContentPendingOnce()
                        } else {
                          return funcContentPendingAll()
                        }
                      } else if (status === 1) {
                        const funcContentApprovalAll = () => {
                          if (firstArr === 0) {
                            return (
                              <div
                                className={`approval-step-requester approval-step-approving or-and-class-first-approving cursor-pointer`}
                                key={index}
                                onClick={() =>
                                  this.renderModalContactInfo(
                                    name,
                                    email,
                                    phone
                                  )
                                }
                              >
                                <Text
                                  useTootipFor="name"
                                  useTootip={true}
                                  useEllipsis={true}
                                  style={{
                                    color: '#FC8601',
                                    cursor: 'pointer',
                                  }}
                                >
                                  {name}
                                </Text>
                                <p>Awaiting Approve</p>
                              </div>
                            )
                          }
                          if (lastArr) {
                            return (
                              <div
                                className={`approval-step-requester approval-step-approving or-and-class-last-approving cursor-pointer`}
                                key={index}
                                onClick={() =>
                                  this.renderModalContactInfo(
                                    name,
                                    email,
                                    phone
                                  )
                                }
                              >
                                <Text
                                  useTootipFor="name"
                                  useTootip={true}
                                  useEllipsis={true}
                                  style={{
                                    color: '#FC8601',
                                    cursor: 'pointer',
                                  }}
                                >
                                  {name}
                                </Text>
                                <p>Awaiting Approve</p>
                              </div>
                            )
                          }
                          return (
                            <div
                              className={`approval-step-requester approval-step-approving or-and-class-approving cursor-pointer`}
                              key={index}
                              onClick={() =>
                                this.renderModalContactInfo(name, email, phone)
                              }
                            >
                              <Text
                                useTootipFor="name"
                                useTootip={true}
                                useEllipsis={true}
                                style={{
                                  color: '#FC8601',
                                  cursor: 'pointer',
                                }}
                              >
                                {name}
                              </Text>
                              <p>Awaiting Approve</p>
                            </div>
                          )
                        }
                        const funcContentApprovalOnce = () => {
                          return (
                            <div
                              className={`approval-step-requester approval-step-approving cursor-pointer`}
                              key={index}
                              onClick={() =>
                                this.renderModalContactInfo(name, email, phone)
                              }
                            >
                              <Text
                                useTootipFor="name"
                                useTootip={true}
                                useEllipsis={true}
                                style={{
                                  color: '#FC8601',
                                  cursor: 'pointer',
                                }}
                              >
                                {name}
                              </Text>
                              <p>Awaiting Approve</p>
                            </div>
                          )
                        }
                        if (arrayOnce) {
                          return funcContentApprovalOnce()
                        } else {
                          return funcContentApprovalAll()
                        }
                      } else if (status === 2) {
                        const funcContentApprovedAll = () => {
                          if (firstArr === 0) {
                            return (
                              <div
                                className={`approval-step-requester approval-step-approved or-and-class-first-approved cursor-pointer`}
                                key={index}
                                onClick={() =>
                                  this.renderModalContactInfo(
                                    name,
                                    email,
                                    phone
                                  )
                                }
                              >
                                <Text
                                  useTootipFor="name"
                                  useTootip={true}
                                  useEllipsis={true}
                                  style={{
                                    color: 'white',
                                    cursor: 'pointer',
                                  }}
                                >
                                  {name}
                                </Text>
                                <p>Approved</p>
                              </div>
                            )
                          }
                          if (lastArr) {
                            return (
                              <div
                                className={`approval-step-requester approval-step-approved or-and-class-last-approved cursor-pointer`}
                                key={index}
                                onClick={() =>
                                  this.renderModalContactInfo(
                                    name,
                                    email,
                                    phone
                                  )
                                }
                              >
                                <Text
                                  useTootipFor="name"
                                  useTootip={true}
                                  useEllipsis={true}
                                  style={{
                                    color: 'white',
                                    cursor: 'pointer',
                                  }}
                                >
                                  {name}
                                </Text>
                                <p>Approved</p>
                              </div>
                            )
                          }
                          return (
                            <div
                              className={`approval-step-requester approval-step-approved or-and-class-approved cursor-pointer`}
                              key={index}
                              onClick={() =>
                                this.renderModalContactInfo(name, email, phone)
                              }
                            >
                              <Text
                                useTootipFor="name"
                                useTootip={true}
                                useEllipsis={true}
                                style={{
                                  color: 'white',
                                  cursor: 'pointer',
                                }}
                              >
                                {name}
                              </Text>
                              <p>Approved</p>
                            </div>
                          )
                        }
                        const funcContentApprovedOnce = () => {
                          return (
                            <div
                              className={`approval-step-requester approval-step-approved cursor-pointer`}
                              key={index}
                              onClick={() =>
                                this.renderModalContactInfo(name, email, phone)
                              }
                            >
                              <Text
                                useTootipFor="name"
                                useTootip={true}
                                useEllipsis={true}
                                style={{
                                  color: 'white',
                                  cursor: 'pointer',
                                }}
                              >
                                {name}
                              </Text>
                              <p>Approved</p>
                            </div>
                          )
                        }
                        if (arrayOnce) {
                          return funcContentApprovedOnce()
                        } else {
                          return funcContentApprovedAll()
                        }
                      } else if (status === 3) {
                        const funcContentRejectAll = () => {
                          if (firstArr === 0) {
                            return (
                              <div
                                className={`approval-step-requester approval-step-reject or-and-class-first-reject cursor-pointer`}
                                key={index}
                                onClick={() =>
                                  this.renderModalContactInfo(
                                    name,
                                    email,
                                    phone
                                  )
                                }
                              >
                                <Text
                                  useTootipFor="name"
                                  useTootip={true}
                                  useEllipsis={true}
                                  style={{
                                    color: 'white',
                                    cursor: 'pointer',
                                  }}
                                >
                                  {name}
                                </Text>
                                <p>Rejected</p>
                              </div>
                            )
                          }
                          if (lastArr) {
                            return (
                              <div
                                className={`approval-step-requester approval-step-reject or-and-class-last-reject cursor-pointer`}
                                key={index}
                                onClick={() =>
                                  this.renderModalContactInfo(
                                    name,
                                    email,
                                    phone
                                  )
                                }
                              >
                                <Text
                                  useTootipFor="name"
                                  useTootip={true}
                                  useEllipsis={true}
                                  style={{
                                    color: 'white',
                                    cursor: 'pointer',
                                  }}
                                >
                                  {name}
                                </Text>
                                <p>Rejected</p>
                              </div>
                            )
                          }
                          return (
                            <div
                              className={`approval-step-requester approval-step-reject or-and-class-reject cursor-pointer`}
                              key={index}
                            >
                              <Text
                                useTootipFor="name"
                                useTootip={true}
                                useEllipsis={true}
                                style={{
                                  color: 'white',
                                  cursor: 'pointer',
                                }}
                              >
                                {name}
                              </Text>
                              <p>Rejected</p>
                            </div>
                          )
                        }
                        const funcContentRejectOnce = () => {
                          return (
                            <div
                              className={`approval-step-requester approval-step-reject cursor-pointer`}
                              key={index}
                              onClick={() =>
                                this.renderModalContactInfo(name, email, phone)
                              }
                            >
                              <Text
                                useTootipFor="name"
                                useTootip={true}
                                useEllipsis={true}
                                style={{
                                  color: 'white',
                                  cursor: 'pointer',
                                }}
                              >
                                {name}
                              </Text>
                              <p>Rejected</p>
                            </div>
                          )
                        }
                        if (arrayOnce) {
                          return funcContentRejectOnce()
                        } else {
                          return funcContentRejectAll()
                        }
                      } else if (status === 4) {
                        const funcContentInactiveAll = () => {
                          if (firstArr === 0) {
                            return (
                              <div
                                className={`approval-step-requester approval-step-Inactive or-and-class-first-Inactive cursor-pointer`}
                                key={index}
                                onClick={() =>
                                  this.renderModalContactInfo(
                                    name,
                                    email,
                                    phone
                                  )
                                }
                              >
                                <Text
                                  useTootipFor="name"
                                  useTootip={true}
                                  useEllipsis={true}
                                  style={{
                                    color: '#707070',
                                    cursor: 'pointer',
                                  }}
                                >
                                  {name}
                                </Text>
                                <p>Inactive</p>
                              </div>
                            )
                          }
                          if (lastArr) {
                            return (
                              <div
                                className={`approval-step-requester approval-step-Inactive or-and-class-last-Inactive cursor-pointer`}
                                key={index}
                                onClick={() =>
                                  this.renderModalContactInfo(
                                    name,
                                    email,
                                    phone
                                  )
                                }
                              >
                                <Text
                                  useTootipFor="name"
                                  useTootip={true}
                                  useEllipsis={true}
                                  style={{
                                    color: '#707070',
                                    cursor: 'pointer',
                                  }}
                                >
                                  {name}
                                </Text>
                                <p>Inactive</p>
                              </div>
                            )
                          }
                          return (
                            <div
                              className={`approval-step-requester approval-step-Inactive or-and-class-Inactive cursor-pointer`}
                              key={index}
                              onClick={() =>
                                this.renderModalContactInfo(name, email, phone)
                              }
                            >
                              <Text
                                useTootipFor="name"
                                useTootip={true}
                                useEllipsis={true}
                                style={{
                                  color: '#707070',
                                  cursor: 'pointer',
                                }}
                              >
                                {name}
                              </Text>
                              <p>Inactive</p>
                            </div>
                          )
                        }
                        const funcContentInactiveOnce = () => {
                          return (
                            <div
                              className={`approval-step-requester approval-step-Inactive cursor-pointer`}
                              key={index}
                              onClick={() =>
                                this.renderModalContactInfo(name, email, phone)
                              }
                            >
                              <Text
                                useTootipFor="name"
                                useTootip={true}
                                useEllipsis={true}
                                style={{
                                  color: '#707070',
                                  cursor: 'pointer',
                                }}
                              >
                                {name}
                              </Text>
                              <p>Inactive</p>
                            </div>
                          )
                        }
                        if (arrayOnce) {
                          return funcContentInactiveOnce()
                        } else {
                          return funcContentInactiveAll()
                        }
                      }
                    }
                    return renderStatus()
                  })
                }
                const arrRender = () => {
                  if (lastIndex) {
                    return ''
                  } else {
                    return <Image src={ICONS['chevron-right-solid.svg']} />
                  }
                }
                return (
                  <Fragment key={idKey}>
                    <div className="main-or-and">{renderOrAnd()}</div>
                    {arrRender()}
                  </Fragment>
                )
              }
              return renderElement()
            }
          }
          const renderStatusOr = (arr = [], lastIndex) => {
            const { approValWorkflow } = this.state
            const { levels } = approValWorkflow
            const idKey = Date.now()
            const funcRenderStatus = (status = '') => {
              if (status === 0) {
                return 'Pending'
              } else if (status === 1) {
                return 'Awaiting Approve'
              } else if (status === 2) {
                return 'Approved'
              } else if (status === 3) {
                return 'Rejected'
              } else if (status === 4) {
                return 'Inactive'
              } else if (status === 5) {
                return '-'
              }
            }
            if (arr) {
              const filterColor = arr[0]
              const renderElement = () => {
                const renderOrAnd = forStatus5 => {
                  return map(arr, (value, index) => {
                    const { id, name, email, status, phone } = value
                    const lastIndexIn = index === arr.length - 1
                    const renderStatus = status => {
                      if (status === 0) {
                        return (
                          <Fragment key={index}>
                            <div
                              className="cursor-pointer"
                              onClick={() =>
                                this.renderModalContactInfo(name, email, phone)
                              }
                            >
                              <Text
                                useTootipFor="name"
                                useTootip={true}
                                useEllipsis={true}
                                style={{
                                  color: '#FC8601',
                                  cursor: 'pointer',
                                }}
                              >
                                {name}
                              </Text>
                              <p>{funcRenderStatus(status)}</p>
                            </div>

                            {lastIndexIn ? (
                              ''
                            ) : (
                              <hr className="app-hr padding" />
                            )}
                          </Fragment>
                        )
                      } else if (status === 1) {
                        return (
                          <Fragment key={index}>
                            <div
                              className="cursor-pointer"
                              onClick={() =>
                                this.renderModalContactInfo(name, email, phone)
                              }
                            >
                              <Text
                                useTootipFor="name"
                                useTootip={true}
                                useEllipsis={true}
                                style={{
                                  color: '#FC8601',
                                  cursor: 'pointer',
                                }}
                              >
                                {name}
                              </Text>
                              <p>{funcRenderStatus(status)}</p>
                            </div>

                            {lastIndexIn ? (
                              ''
                            ) : (
                              <hr className="app-hr approving" />
                            )}
                          </Fragment>
                        )
                      } else if (status === 2) {
                        return (
                          <Fragment key={index}>
                            <div
                              className="cursor-pointer"
                              onClick={() =>
                                this.renderModalContactInfo(name, email, phone)
                              }
                            >
                              <Text
                                useTootipFor="name"
                                useTootip={true}
                                useEllipsis={true}
                                style={{
                                  color: 'white',
                                  cursor: 'pointer',
                                }}
                              >
                                {name}
                              </Text>
                              <p>{funcRenderStatus(status)}</p>
                            </div>

                            {lastIndexIn ? (
                              ''
                            ) : (
                              <hr className="app-hr approved" />
                            )}
                          </Fragment>
                        )
                      } else if (status === 3) {
                        return (
                          <Fragment key={index}>
                            <div
                              className="cursor-pointer"
                              onClick={() =>
                                this.renderModalContactInfo(name, email, phone)
                              }
                            >
                              <Text
                                useTootipFor="name"
                                useTootip={true}
                                useEllipsis={true}
                                style={{
                                  color: 'white',
                                  cursor: 'pointer',
                                }}
                              >
                                {name}
                              </Text>
                              <p>{funcRenderStatus(status)}</p>
                            </div>

                            {lastIndexIn ? (
                              ''
                            ) : (
                              <hr className="app-hr reject" />
                            )}
                          </Fragment>
                        )
                      } else if (status === 4) {
                        return (
                          <Fragment key={index}>
                            <div
                              className="cursor-pointer"
                              onClick={() =>
                                this.renderModalContactInfo(name, email, phone)
                              }
                            >
                              <Text
                                useTootipFor="name"
                                useTootip={true}
                                useEllipsis={true}
                                style={{
                                  color: '#707070',
                                  cursor: 'pointer',
                                }}
                              >
                                {name}
                              </Text>
                              <p>{funcRenderStatus(status)}</p>
                            </div>

                            {lastIndexIn ? (
                              ''
                            ) : (
                              <hr className="app-hr inactive" />
                            )}
                          </Fragment>
                        )
                      } else if (status === 5) {
                        if (forStatus5 === 0) {
                          return (
                            <Fragment key={index}>
                              <div
                                className="cursor-pointer"
                                onClick={() =>
                                  this.renderModalContactInfo(
                                    name,
                                    email,
                                    phone
                                  )
                                }
                              >
                                <Text
                                  useTootipFor="name"
                                  useTootip={true}
                                  useEllipsis={true}
                                  style={{
                                    color: '#FC8601',
                                    cursor: 'pointer',
                                  }}
                                >
                                  {name}
                                </Text>
                                <p>{funcRenderStatus(status)}</p>
                              </div>

                              {lastIndexIn ? (
                                ''
                              ) : (
                                <hr className="app-hr padding" />
                              )}
                            </Fragment>
                          )
                        } else if (forStatus5 === 1) {
                          return (
                            <Fragment key={index}>
                              <div
                                className="cursor-pointer"
                                onClick={() =>
                                  this.renderModalContactInfo(
                                    name,
                                    email,
                                    phone
                                  )
                                }
                              >
                                <Text
                                  useTootipFor="name"
                                  useTootip={true}
                                  useEllipsis={true}
                                  style={{
                                    color: '#FC8601',
                                    cursor: 'pointer',
                                  }}
                                >
                                  {name}
                                </Text>
                                <p>{funcRenderStatus(status)}</p>
                              </div>

                              {lastIndexIn ? (
                                ''
                              ) : (
                                <hr className="app-hr approving" />
                              )}
                            </Fragment>
                          )
                        } else if (forStatus5 === 2) {
                          return (
                            <Fragment key={index}>
                              <div
                                className="cursor-pointer"
                                onClick={() =>
                                  this.renderModalContactInfo(
                                    name,
                                    email,
                                    phone
                                  )
                                }
                              >
                                <Text
                                  useTootipFor="name"
                                  useTootip={true}
                                  useEllipsis={true}
                                  style={{
                                    color: 'white',
                                    cursor: 'pointer',
                                  }}
                                >
                                  {name}
                                </Text>
                                <p>{funcRenderStatus(status)}</p>
                              </div>

                              {lastIndexIn ? (
                                ''
                              ) : (
                                <hr className="app-hr approved" />
                              )}
                            </Fragment>
                          )
                        } else if (forStatus5 === 3) {
                          return (
                            <Fragment key={index}>
                              <div
                                className="cursor-pointer"
                                onClick={() =>
                                  this.renderModalContactInfo(
                                    name,
                                    email,
                                    phone
                                  )
                                }
                              >
                                <Text
                                  useTootipFor="name"
                                  useTootip={true}
                                  useEllipsis={true}
                                  style={{
                                    color: 'white',
                                    cursor: 'pointer',
                                  }}
                                >
                                  {name}
                                </Text>
                                <p>{funcRenderStatus(status)}</p>
                              </div>

                              {lastIndexIn ? (
                                ''
                              ) : (
                                <hr className="app-hr reject" />
                              )}
                            </Fragment>
                          )
                        } else if (forStatus5 === 4) {
                          return (
                            <Fragment key={index}>
                              <div
                                className="cursor-pointer"
                                onClick={() =>
                                  this.renderModalContactInfo(
                                    name,
                                    email,
                                    phone
                                  )
                                }
                              >
                                <Text
                                  useTootipFor="name"
                                  useTootip={true}
                                  useEllipsis={true}
                                  style={{
                                    color: '#707070',
                                    cursor: 'pointer',
                                  }}
                                >
                                  {name}
                                </Text>
                                <p>{funcRenderStatus(status)}</p>
                              </div>

                              {lastIndexIn ? (
                                ''
                              ) : (
                                <hr className="app-hr inactive" />
                              )}
                            </Fragment>
                          )
                        }
                      }
                    }
                    return renderStatus(status)
                  })
                }
                const funcrenderOrContent = () => {
                  if (filterColor.status === 0) {
                    return (
                      <div className="main-or-and approval-step-requester approval-step-pending cursor-pointer">
                        {renderOrAnd(filterColor.status)}
                      </div>
                    )
                  } else if (filterColor.status === 1) {
                    return (
                      <div className="main-or-and approval-step-requester approval-step-approving cursor-pointer">
                        {renderOrAnd(filterColor.status)}
                      </div>
                    )
                  } else if (filterColor.status === 2) {
                    return (
                      <div className="main-or-and approval-step-requester approval-step-approved cursor-pointer">
                        {renderOrAnd(filterColor.status)}
                      </div>
                    )
                  } else if (filterColor.status === 3) {
                    return (
                      <div className="main-or-and approval-step-requester approval-step-reject cursor-pointer">
                        {renderOrAnd(filterColor.status)}
                      </div>
                    )
                  } else if (filterColor.status === 4) {
                    return (
                      <div className="main-or-and approval-step-requester approval-step-Inactive cursor-pointer">
                        {renderOrAnd(filterColor.status)}
                      </div>
                    )
                  } else if (filterColor.status === 5) {
                    let status
                    arr.map(item => {
                      if (item.status !== 5) {
                        return (status = item.status)
                      }
                    })
                    if (status === 1) {
                      return (
                        <div className="main-or-and approval-step-requester approval-step-approving cursor-pointer">
                          {renderOrAnd(status)}
                        </div>
                      )
                    } else if (status === 2) {
                      return (
                        <div className="main-or-and approval-step-requester approval-step-approved cursor-pointer">
                          {renderOrAnd(status)}
                        </div>
                      )
                    } else if (status === 3) {
                      return (
                        <div className="main-or-and approval-step-requester approval-step-reject cursor-pointer">
                          {renderOrAnd(status)}
                        </div>
                      )
                    } else if (status === 4) {
                      return (
                        <div className="main-or-and approval-step-requester approval-step-Inactive cursor-pointer">
                          {renderOrAnd(status)}
                        </div>
                      )
                    }
                  }
                }
                const arrRender = () => {
                  if (lastIndex) {
                    return ''
                  } else {
                    return <Image src={ICONS['chevron-right-solid.svg']} />
                  }
                }
                return (
                  <Fragment key={idKey}>
                    {funcrenderOrContent()}
                    {arrRender()}
                  </Fragment>
                )
              }
              return renderElement()
            }
          }
          const approVallevel = () => {
            const { approValWorkflow } = this.state
            const { levels } = approValWorkflow

            const filterlevelsNotZero = filter(
              levels,
              (value, index) => value.level !== 0
            )
            const findObjOr = find(
              filterlevelsNotZero,
              (value, index) => value.condition === 'parallel_or'
            )
            const findObjAnd = find(
              filterlevelsNotZero,
              (value, index) => value.condition === 'parallel_and'
            )
            return map(filterlevelsNotZero, (value, index) => {
              const { condition, approvers } = value
              if (condition === 'serial') {
                return map(approvers, (vApprovers, kApprovers) => {
                  const { id, name, email, phone, status } = vApprovers
                  const arrRender = () => {
                    if (approvers.length == 1) {
                      if (index === filterlevelsNotZero.length - 1) {
                        return ''
                      } else {
                        return <Image src={ICONS['chevron-right-solid.svg']} />
                      }
                    } else if (kApprovers !== approvers.length - 1) {
                      return <Image src={ICONS['chevron-right-solid.svg']} />
                    } else if (kApprovers === approvers.length - 1) {
                      if (findObjOr || findObjAnd) {
                        return <Image src={ICONS['chevron-right-solid.svg']} />
                      } else {
                        return ''
                      }
                    }
                  }
                  return (
                    <Fragment key={kApprovers}>
                      {renderStatus(condition, id, name, email, phone, status)}
                      {arrRender()}
                    </Fragment>
                  )
                })
              } else if (condition === 'parallel_or') {
                const lastIndex = index === filterlevelsNotZero.length - 1
                return renderStatusOr(approvers, lastIndex)
              } else if (condition === 'parallel_and') {
                const lastIndex = index === filterlevelsNotZero.length - 1
                return renderStatusAnd(approvers, lastIndex)
              }
            })
          }
          const funcRenderButtonHistory = () => {
            const renderButton = () => {
              const handlesClick = e => {
                return this.toggleModal('modals-history-approval')
              }
              return (
                <Button className="theme-blue" onClick={handlesClick}>
                  History
                </Button>
              )
            }
            return (
              <Section className="form-row row-history">
                {renderButton()}
              </Section>
            )
          }
          const hideFileNote = this.funcHideAppWorkNoteFile()

          return (
            this.state.approValWorkflow &&
            this.state.approValWorkflow.levels.length !== 0 &&
            Number(this.state.savingType.res.award_price) >= 0 &&
            Number(this.state.savingType.res.award_price_fcy) !== 0 && (
              <Section className="form-wrapper">
                <Section className="form-group-title">
                  Approval Workflow
                </Section>
                {this.state.approvalHisRes.length !== 0 &&
                  funcRenderButtonHistory()}
                <Section className="form-row approval-step-main">
                  <Section className="form-col col-12 approval-step">
                    {renderRequester()}
                    {approVallevel()}
                  </Section>
                </Section>
                {hideFileNote && this.renderNote()}
              </Section>
            )
          )
        }
        if (statusRFQ) {
          const {
            rolesCheck,
            approvalNote,
            statusRolesApp,
            awardStatuses,
            formData,
          } = this.state
          this.matchValue(awardStatuses, formData.rfq_award_status_id)
          const checkRenderAppWorkFlow = () => {
            const { seal_status_name, seal_type } = formData
            const { unsealed } = sealStatus
            const showApp = this.funcHideAppWork()
            // hideapp = true ให้ renderAppWorkflow ?? สรุป hideapp หมายถึงอะไร
            if (showApp) {
              return renderAppWorkflow()
            }
          }
          return (
            <Section className="main-content">
              <Section className="content-body">
                {steps[activeStep].component}
                {renderStatusRFQ()}
                {this.renderRequestUnSealTable(formData)}
                {checkRenderAppWorkFlow()}

                {/* Start Mocktup */}
                <ApprovalWorkflow workflow={mockWorkflow} />
                {renderButtonAction()}
              </Section>
            </Section>
          )
        } else {
          return null
        }
      }
      return <React.Fragment>{funcRenderStatusRFQ()}</React.Fragment>
    }
    const renderModalReschedule = () => {
      return (
        <Modal
          id="reschedule"
          className="reschedule theme-blue"
          isOpen={
            modals
              .filter(modal => {
                return modal.name === 'reschedule'
              })
              .map(obj => obj.isOpen)[0]
          }
        >
          <Modal.Header>
            {statusRFQ === 4 ? ' Reopen Event' : ' Reschedule Event'}
          </Modal.Header>

          <Modal.Body>
            <Section
              className={`form-group ${
                this.state.isErrMsgStartDate && 'is-error'
              }`}
            >
              <label>Start Date</label>

              <Section className="form-group-control">
                <Section className="form-group-inner-wrapper">
                  <DatePickerInput
                    disabled={statusRFQ === 3 || statusRFQ === 4}
                    selected={newScheduleDate.start_date || null}
                    onChange={date => {
                      if (this._isMounted) {
                        this.setState({
                          newScheduleDate: {
                            ...newScheduleDate,
                            start_date: date,
                          },
                        })
                      }
                    }}
                    openToDate={new Date()}
                    selectsStart
                    minDate={new Date()}
                    showMonthDropdown
                    showYearDropdown
                    showTimeSelect
                    isClearable={!statusRFQ === 3 || !statusRFQ === 4}
                    dateFormat="MMMM d, yyyy h:mm aa"
                    timeIntervals={1}
                    dropdownMode="select"
                  />
                </Section>

                <Section className="message">
                  {this.state.isErrMsgStartDate && this.state.isErrMsgStartDate}
                </Section>
              </Section>
            </Section>

            <Section className={`form-group ${isErrMsgEndDate && 'is-error'}`}>
              <label>End Date</label>

              <Section className="form-group-control">
                <Section className="form-group-inner-wrapper">
                  <DatePickerInput
                    selected={newScheduleDate.end_date || null}
                    onChange={date => {
                      if (this._isMounted) {
                        this.setState({
                          newScheduleDate: {
                            ...newScheduleDate,
                            end_date: date,
                          },
                        })
                      }
                    }}
                    showTimeSelect
                    openToDate={
                      newScheduleDate.end_date < Date.now()
                        ? Date.now()
                        : newScheduleDate.end_date
                    }
                    minDate={
                      newScheduleDate.start_date < Date.now()
                        ? Date.now()
                        : newScheduleDate.start_date
                    }
                    showMonthDropdown
                    showYearDropdown
                    dateFormat="MMMM d, yyyy hh:mm aa"
                    timeIntervals={1}
                    dropdownMode="select"
                  />
                </Section>

                <Section className="message">
                  {isErrMsgEndDate && isErrMsgEndDate}
                </Section>
              </Section>
            </Section>
          </Modal.Body>

          <Modal.Footer>
            <Button
              className="theme-border-gray close"
              onClick={() => {
                const newScheduleDate = {
                  start_date: null,
                  end_date: null,
                }
                if (this._isMounted) {
                  this.setState(
                    {
                      newScheduleDate,
                      isErrMsgEndDate: '',
                      isErrMsgStartDate: '',
                    },
                    this.toggleModal()
                  )
                }
              }}
            >
              Cancel
            </Button>

            <Button
              className="theme-green save"
              onClick={e => {
                if (e.detail === 1) {
                  this.onSaveSchedule()
                }
              }}
            >
              Save
            </Button>
          </Modal.Footer>
        </Modal>
      )
    }
    const renderModalSupplierDescription = () => {
      const { eventType } = this.props.match.params
      return (
        <Modal
          id="supplier-description"
          className="theme-blue modal-supplier-description"
          isOpen={
            modals
              .filter(modal => {
                return modal.name === 'supplier-description'
              })
              .map(obj => obj.isOpen)[0]
          }
          modalWidth="768px"
        >
          <Modal.Header>Description</Modal.Header>
          {quotationDetail && (
            <Modal.Body>
              <Section className="form-group">
                <label>Description: </label>

                <Section className="form-group-control">
                  <Section className="form-group-inner-wrapper">
                    <InputTextarea
                      disabled={true}
                      value={quotationDetail.description}
                    ></InputTextarea>
                  </Section>

                  <Section className="message"></Section>
                </Section>
              </Section>

              <Section className="form-group">
                <label>Attachment: </label>
                <Section className="form-group-control">
                  {quotationDetail.event_item_file &&
                  quotationDetail.event_item_file.length > 0 ? (
                    // quotationDetail.event_item_file.map((e, i) => {
                    //   return (
                    //     <React.Fragment key={i}>
                    //       <Section className="form-group-inner-wrapper attachment-files">
                    //         <Section className="attached-file-list">
                    //           <a
                    //             target="_blank"
                    //             className="file-link removable"
                    //             rel="noopener noreferrer"
                    //           >
                    //             <span
                    //               className="file-name"
                    //               onClick={() => {
                    //                 this.setLoadingDownloadFile(e)
                    //                 this.downloadItem(e)
                    //               }}
                    //             >
                    //               {e.name}
                    //             </span>
                    //           </a>
                    //           {this.renderDownloadFile(e)}
                    //         </Section>
                    //       </Section>
                    //     </React.Fragment>
                    //   )
                    // })
                    <AttachedFile
                      // key={i}
                      id={'attached-file-item'}
                      isIcon={true}
                      isUpload={false}
                      onDownload={e => {
                        this.setLoadingDownloadFile(e)
                        this.downloadItem(e)
                      }}
                      fileList={quotationDetail.event_item_file}
                      loadingDownload={this.state.loadingDownloadFile}
                    />
                  ) : (
                    <React.Fragment>
                      <Section className="form-group-inner-wrapper attachment-files">
                        <Section className="attached-file-list">-</Section>
                      </Section>
                    </React.Fragment>
                  )}
                  {/* {Number(eventType) === 1 &&
                    (quotationDetail.rfq_buyer_item_file &&
                    quotationDetail.rfq_buyer_item_file.length > 0 ? (
                      quotationDetail.rfq_buyer_item_file.map((e, i) => {
                        return (
                          <React.Fragment key={i}>
                            <Section className="form-group-inner-wrapper attachment-files">
                              <Section className="attached-file-list">
                                <a
                                  target="_blank"
                                  className="file-link removable"
                                  rel="noopener noreferrer"
                                >
                                  <span
                                    className="file-name"
                                    onClick={() => {
                                      this.downloadItem(e)
                                    }}
                                  >
                                    {e.name}
                                  </span>
                                </a>
                              </Section>
                            </Section>
                          </React.Fragment>
                        )
                      })
                    ) : (
                      <React.Fragment>
                        <Section className="form-group-inner-wrapper attachment-files">
                          <Section className="attached-file-list">-</Section>
                        </Section>
                      </React.Fragment>
                    ))}
                  {Number(eventType) === 2 &&
                    (quotationDetail.auction_buyer_item_file &&
                    quotationDetail.auction_buyer_item_file.length > 0 ? (
                      quotationDetail.auction_buyer_item_file.map((e, i) => {
                        return (
                          <React.Fragment key={i}>
                            <Section className="form-group-inner-wrapper attachment-files">
                              <Section className="attached-file-list">
                                <a
                                  target="_blank"
                                  className="file-link removable"
                                  rel="noopener noreferrer"
                                >
                                  <span
                                    className="file-name"
                                    onClick={() => {
                                      this.downloadItem(e)
                                    }}
                                  >
                                    {e.name}
                                  </span>
                                </a>
                              </Section>
                            </Section>
                          </React.Fragment>
                        )
                      })
                    ) : (
                      <React.Fragment>
                        <Section className="form-group-inner-wrapper attachment-files">
                          <Section className="attached-file-list">-</Section>
                        </Section>
                      </React.Fragment>
                    ))} */}
                </Section>
              </Section>
            </Modal.Body>
          )}
          <Modal.Footer>
            <Button
              className="theme-green"
              onClick={() => {
                const newScheduleDate = {
                  start_date: null,
                  end_date: null,
                }
                if (this._isMounted) {
                  this.setState(
                    {
                      newScheduleDate,
                      isErrMsgEndDate: '',
                    },
                    this.toggleModal()
                  )
                }
              }}
            >
              Ok
            </Button>
          </Modal.Footer>
        </Modal>
      )
    }
    const renderModalApprovalContact = () => {
      return (
        <Modal
          className="theme-blue modals-approval-contact"
          isOpen={
            modals
              .filter(modal => {
                return modal.name === 'modals-approval-contact'
              })
              .map(obj => obj.isOpen)[0]
          }
          modalWidth="768px"
        >
          <Modal.Header>Contact Information</Modal.Header>
          <Modal.Body>
            <Section className="form-group">
              <label>Full Name: </label>
              <Section className="form-group-control">
                <Section className="form-group-inner-wrapper text">
                  {contactInformation.name}
                </Section>
              </Section>
            </Section>
            <Section className="form-group">
              <label>Email: </label>
              <Section className="form-group-control">
                <Section className="form-group-inner-wrapper text">
                  {contactInformation.email}
                </Section>
              </Section>
            </Section>
            <Section className="form-group">
              <label>Phone: </label>
              <Section className="form-group-control">
                <Section className="form-group-inner-wrapper text">
                  {contactInformation.phone}
                </Section>
              </Section>
            </Section>
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="theme-gray"
              onClick={() => {
                this.toggleModal()
              }}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      )
    }

    const renderModalPurchasingSite = () => {
      const { dataProject } = this.state
      const { purchasing_companies } = dataProject
      const funcRenderPurchasingCompanies = () => {
        if (purchasing_companies) {
          const callBacks = (e, i) => {
            const { name, code } = e
            return (
              <Table.TR key={i}>
                <Table.TD className="code">{code}</Table.TD>
                <Table.TD className="company">{name}</Table.TD>
              </Table.TR>
            )
          }
          return map(purchasing_companies, callBacks)
        }
      }
      return (
        <Modal
          className="purchasing-site buyer theme-blue"
          isOpen={
            modals
              .filter(modal => {
                return modal.name === 'purchasing'
              })
              .map(obj => obj.isOpen)[0]
          }
        >
          <Modal.Header>Purchasing Site</Modal.Header>
          <Modal.Body>
            <Section className="table-header-freeze-wrapper">
              <Table className="company-name header-freeze">
                <Table.TBODY>
                  <Table.TR>
                    <Table.TH className="code">COMPANY CODE</Table.TH>

                    <Table.TH className="company">COMPANY NAME</Table.TH>
                  </Table.TR>
                </Table.TBODY>
              </Table>
              <Table className="company-name split-row-color data-table">
                <Table.TBODY>{funcRenderPurchasingCompanies()}</Table.TBODY>
              </Table>
            </Section>
          </Modal.Body>

          <Modal.Footer>
            <Button
              className="theme-border-gray close"
              onClick={() => {
                this.toggleModal()
              }}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      )
    }
    const renderModalCancelEvent = () => {
      return this.renderModalCancelEvent(end_date)
    }
    const renderModalAttachment = () => {
      return (
        <Modal
          className="theme-blue modal-attachment"
          isOpen={
            modals
              .filter(modal => {
                return modal.name === 'attachment'
              })
              .map(obj => obj.isOpen)[0]
          }
          modalWidth="768px"
        >
          <Modal.Header>Attachment</Modal.Header>
          <Modal.Body>
            <Section className="form-group">
              <label>Attachment:</label>
              <Section className="form-group-control">
                {this.state.getSupplierEventFile &&
                this.state.getSupplierEventFile.length > 0
                  ? this.state.getSupplierEventFile.map((e, i) => {
                      return (
                        <Section className="form-group-inner-wrapper" key={i}>
                          <Section className="attached-file-list">
                            <a
                              target="_blank"
                              className="file-link removable"
                              rel="noopener noreferrer"
                            >
                              <span
                                onClick={() => {
                                  e.id
                                    ? this.downloadSupplierEventFile(e)
                                    : null
                                }}
                                className="file-name"
                              >
                                {e.name}
                              </span>
                            </a>
                          </Section>
                        </Section>
                      )
                    })
                  : '-'}

                <Section className="message"></Section>
              </Section>
            </Section>
          </Modal.Body>

          <Modal.Footer>
            <Button
              className="theme-green"
              onClick={() => {
                this.toggleModal()
              }}
            >
              Ok
            </Button>
          </Modal.Footer>
        </Modal>
      )
    }
    const renderModalNotetoBuyer = () => {
      return (
        <Modal
          className="theme-blue modal-note-to-buyer"
          isOpen={
            modals
              .filter(modal => {
                return modal.name === 'note-to-buyer'
              })
              .map(obj => obj.isOpen)[0]
          }
          modalWidth="768px"
        >
          <Modal.Header>Note to Buyer</Modal.Header>
          <Modal.Body>
            <Section className="form-group">
              <label>Note to Buyer:</label>
              <Section className="form-group-control">
                <Section className="form-group-inner-wrapper text">
                  {this.state.noteToBuyer &&
                    this.state.noteToBuyer.note_to_buyer}
                </Section>
              </Section>
            </Section>
          </Modal.Body>

          <Modal.Footer>
            <Button
              className="theme-green"
              onClick={() => {
                this.toggleModal()
              }}
            >
              Ok
            </Button>
          </Modal.Footer>
        </Modal>
      )
    }
    const renderModalRequestUnseal = () => {
      const handleOnChange = (position, e) => {
        let { tempTec, stackTec } = this.state
        if (tempTec[position].check) {
          tempTec[position].check = false
          const indexsStackTec = stackTec.findIndex(tec => e.id === tec.id)
          if (indexsStackTec !== -1) {
            stackTec.splice(indexsStackTec, 1)
          }
        } else {
          stackTec.push(e)
          tempTec[position].check = true
        }

        this.setState({ stackTec, tempTec })
      }

      const renderTecContacts = data => {
        if (data.length >= 1) {
          return data.map((data, index) => {
            return (
              <React.Fragment key={index}>
                <Table.TR>
                  <Table.TD className="requestunseal_date">
                    <Checkbox
                      key={data.id}
                      id={data.id}
                      value={data.check}
                      checked={data.check}
                      onChange={() => handleOnChange(index, data)}
                      disabled={data.request_at !== '' && true}
                    />
                  </Table.TD>
                  <Table.TD className="requestunseal_fullname">
                    <Text
                      tootipValue={data.name}
                      useTootipFor="date-fullname"
                      useTootip={true}
                    >
                      {data.name}
                    </Text>
                  </Table.TD>
                  <Table.TD className="requestunseal_email">
                    <Text
                      tootipValue={data.email}
                      useTootipFor="date-email"
                      useTootip={true}
                    >
                      {data.email}
                    </Text>
                  </Table.TD>
                </Table.TR>
              </React.Fragment>
            )
          })
        } else if (data.length <= 0) {
          return (
            <React.Fragment key={`empty_dat${data[0]}`}>
              <Table.TR>
                <div
                  style={{
                    display: 'flex',
                    marginTop: '2em',
                    fontSize: '1.5em',
                    width: '100%',
                    justifyContent: 'center',
                  }}
                >
                  <h3>Data not found</h3>
                </div>
              </Table.TR>
            </React.Fragment>
          )
        }
      }

      const onSearchTECChange = e => {
        const { paginationTecContacts } = this.state
        if (e && e.target) {
          paginationTecContacts.search = e.target.value
          if (this._isMounted) {
            return this.setState({ paginationTecContacts })
          }
        }
      }

      const onClickSearchTEC = () => {
        this.fetchTecContacts(this.state.paginationTecContacts.search, 1, true)
      }

      const onClickCancelSelectTEC = () => {
        let { dataInitTableTec } = this.state
        this.setState({ stackTec: [...dataInitTableTec] })
        this.toggleModal()
      }
      const onClickOKSelectTEC = async () => {
        let { stackTec } = this.state
        this.setState({ dataInitTableTec: [...stackTec] })

        this.toggleModal()
      }
      return (
        <Modal
          id="request_unseal"
          className="request-unseal theme-blue"
          isOpen={
            modals
              .filter(modal => {
                return modal.name === 'request-unseal'
              })
              .map(obj => obj.isOpen)[0]
          }
        >
          <Modal.Header>Request to Unseal</Modal.Header>
          <Modal.Body>
            <Section className="form-group">
              <Section className="form-group-control">
                <Section className="form-group-inner-wrapper modalInput">
                  <Input
                    id="search-tec"
                    type="text"
                    name="search-tec"
                    value={this.state.paginationTecContacts.search}
                    placeholder="Full name, Email."
                    onChange={onSearchTECChange}
                  />
                  <Button className="theme-blue" onClick={onClickSearchTEC}>
                    Search
                  </Button>
                </Section>
              </Section>
            </Section>
            <Section
              className="popup-sourcing table-header-freeze-wrapper"
              id="sourcing_request_unseal"
            >
              <Table className="sourcing">
                <Table.THEAD>
                  <Table.TR>
                    <Table.TH className="requestunseal_date">
                      <span></span>
                    </Table.TH>
                    <Table.TH className="requestunseal_email">
                      FULL NAME
                    </Table.TH>
                    <Table.TH className="requestunseal_email">EMAIL</Table.TH>
                  </Table.TR>
                </Table.THEAD>
                <Table.TBODY>
                  {renderTecContacts(this.state.tempTec)}
                  {this.state.loadingUserTecContacts && <Spinner />}
                </Table.TBODY>
              </Table>

              <Table className="sourcing split-row-color"></Table>
            </Section>
          </Modal.Body>
          <Modal.Footer>
            <Section className="form-actions">
              <Section className="button-group modalUnsealButton">
                <Button
                  onClick={onClickCancelSelectTEC}
                  className="theme-border-gray"
                >
                  Cancel
                </Button>
                <Button className="theme-green" onClick={onClickOKSelectTEC}>
                  Ok
                </Button>
              </Section>
            </Section>
          </Modal.Footer>
        </Modal>
      )
    }
    const renderModalConfirmRequestUnseal = () => {
      return (
        <ConfirmModalRequestUnseal
          modalsOpenConfirm={this.state.modalsOpenConfirm}
          funcOpenModalConfirm={this.funcOpenModalConfirm}
        />
      )
    }
    const renderModalTecUnseal = () => {
      return (
        <Modal
          className="theme-blue"
          isOpen={
            modals
              .filter(modal => {
                return modal.name === 'tec-unseal'
              })
              .map(obj => obj.isOpen)[0]
          }
          modalWidth="575px"
          size="sm"
        >
          <Modal.Header>Confirm</Modal.Header>
          <Modal.Body>
            <p className="default text-center">Are you sure to unseal?</p>
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="theme-border-gray"
              onClick={() => {
                this._clicksOneSubmit = 0
                this.toggleModal()
              }}
            >
              Cancel
            </Button>
            <Button className="theme-green" onClick={this.modalUnsealTec}>
              Confirm
            </Button>
          </Modal.Footer>
        </Modal>
      )
    }
    const renderModalHistoryApp = () => {
      const { approvalHisRes } = this.state
      const funcRenderInternalFile = valueFile => {
        const handlerClick = (e, v) => {
          if (e.detail === 1) {
            if (v.id) {
              return this.downloadInternalApprovalNote(v)
            }
          }
        }
        return map(valueFile, (value, index) => {
          const { id, file_name } = value
          return (
            <Section
              className="attached-file-list"
              key={index}
              style={{ padding: '0 13px', marginBottom: '0.5em' }}
            >
              <a
                target="_blank"
                className="file-link removable"
                rel="noopener noreferrer"
                style={{ margin: 'unset' }}
              >
                <span
                  className="file-name"
                  onClick={e => handlerClick(e, value)}
                  style={{ width: '100px' }}
                >
                  <Text
                    tootipValue={file_name}
                    useTootipFor="tootip-his-app"
                    useTootip={true}
                    style={{ cursor: 'pointer' }}
                  >
                    {file_name}
                  </Text>
                </span>
              </a>
            </Section>
          )
        })
      }
      const renderBodyContent = () => {
        const funcRenderHistory = () => {
          return map(approvalHisRes, (value, index) => {
            const {
              created_at,
              action_type_string,
              action_by,
              note_for_approver,
              file_request,
              reason,
              roles,
            } = value
            const date = dateMonDayYearTime(created_at)
            const actmty = action_type_string
            const actionBy = action_by
            const note = note_for_approver
            const styleRoles = () => {
              if (roles.length <= 1) {
                return {
                  display: 'flex',
                  width: '100px',
                  margin: 'auto',
                }
              } else {
                return {
                  display: 'flex',
                  width: '100%',
                  flexWrap: 'wrap',
                }
              }
            }
            const renderRolesAction = () => {
              return map(roles, (value, index) => {
                const styleRole = () => {
                  if (roles.length <= 1) {
                    return {
                      textAlign: 'center',
                    }
                  } else {
                    return {
                      marginRight: '0.5em',
                      textAlign: 'center',
                    }
                  }
                }
                const { name } = value
                return (
                  <p key={index} style={styleRole()}>
                    {name}
                  </p>
                )
              })
            }
            return (
              <Table.TR key={index}>
                <Table.TD
                  className="create-date"
                  style={{
                    flex: '0 0 20%',
                    maxHeight: 'unset',
                  }}
                >
                  <Text
                    tootipValue={date}
                    useTootipFor="sourcing-name"
                    useTootip={true}
                  >
                    {date}
                  </Text>
                </Table.TD>
                <Table.TD
                  className="create-date"
                  style={{
                    flex: '0 0 20%',
                    maxHeight: 'unset',
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                    }}
                  >
                    <p>{actmty}</p>
                    {reason && (
                      <Image
                        style={{
                          marginLeft: '0.5em',
                          width: '15px',
                          height: '15px',
                          cursor: 'pointer',
                        }}
                        tootipValue={reason}
                        src={ICONS['info-circle-solid.svg']}
                        useTootip={true}
                      />
                    )}
                  </div>
                </Table.TD>
                <Table.TD
                  className="create-date"
                  style={{
                    flex: '0 0 20%',
                    maxHeight: 'unset',
                  }}
                >
                  <Text
                    style={{ textAlign: 'center' }}
                    tootipValue={actionBy}
                    useTootipFor="actionBy"
                    useTootip={true}
                    useEllipsis={true}
                  >
                    {actionBy}
                  </Text>
                  <div>{renderRolesAction()}</div>
                </Table.TD>
                <Table.TD
                  className="create-date"
                  style={{
                    flex: '0 0 20%',
                    maxHeight: 'unset',
                  }}
                >
                  <Text
                    tootipValue={note}
                    useTootipFor="note"
                    useTootip={note ? true : false}
                    useEllipsis={note ? true : false}
                  >
                    {note ? note : '-'}
                  </Text>
                </Table.TD>
                <Table.TD
                  className="create-date"
                  style={{
                    flex: '0 0 20%',
                    padding: 'unset',
                    display: 'flex',
                    alignItems: 'center',
                    flexDirection: 'column',
                    maxHeight: 'unset',
                  }}
                >
                  <div style={{ marginTop: '10px' }}>
                    {file_request && file_request.length > 0 ? (
                      funcRenderInternalFile(file_request)
                    ) : (
                      <Section className="attached-file-list">-</Section>
                    )}
                  </div>
                </Table.TD>
              </Table.TR>
            )
          })
        }
        return (
          <Section
            style={{ justifyContent: 'center' }}
            className="table-header-freeze-wrapper"
          >
            <Table className="history-log-data header-freeze">
              <Table.TBODY>
                <Table.TR>
                  <Table.TH
                    style={{ flex: '0 0 20%', padding: '0 15px' }}
                    className="create-date"
                  >
                    DATE
                  </Table.TH>
                  <Table.TH
                    style={{ flex: '0 0 20%', padding: '0 15px' }}
                    className="create-date"
                  >
                    ACTIVITY
                  </Table.TH>
                  <Table.TH
                    style={{
                      flex: '0 0 20%',
                      padding: '0 15px',
                      justifyContent: 'center',
                    }}
                    className="create-date"
                  >
                    ACTION BY
                  </Table.TH>
                  <Table.TH
                    style={{ flex: '0 0 20%', padding: '0 15px' }}
                    className="create-date"
                  >
                    NOTE
                  </Table.TH>
                  <Table.TH
                    style={{ flex: '0 0 20%', padding: '0 15px' }}
                    className="create-date"
                  >
                    ATTACHMENT
                  </Table.TH>
                </Table.TR>
              </Table.TBODY>
            </Table>
            <Table className="history-log-data split-row-color css-table-his">
              <Table.TBODY>{funcRenderHistory()}</Table.TBODY>
            </Table>
          </Section>
        )
      }
      const handlersClose = () => {
        return this.toggleModal()
      }
      return (
        // className="purchasing-site buyer theme-blue modals-submit-award"
        <Modal
          className="history-log buyer theme-blue modals-submit-award"
          isOpen={
            modals
              .filter(modal => {
                return modal.name === 'modals-history-approval'
              })
              .map(obj => obj.isOpen)[0]
          }
        >
          <Modal.Header>History</Modal.Header>
          <Modal.Body>{renderBodyContent()}</Modal.Body>
          <Modal.Footer>
            <Button className="theme-gray close" onClick={handlersClose}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      )
    }
    const renderModalHistoryOfSupplier = () => {
      const { formData, itemBidHistory, itemBidClick, loadingBid } = this.state
      // console.log('bid Item', itemBidHistory)
      const renderItem = list => {
        if (list && list.length > 0) {
          return list.map((item, i) => {
            return (
              <Table.TR key={i}>
                <Table.TD className="create-date" style={{ flex: '0 0 5%' }}>
                  {i + 1}
                </Table.TD>
                <Table.TD className="create-date" style={{ flex: '0 0 15%' }}>
                  {item.name}
                </Table.TD>
                <Table.TD
                  className="descriptions"
                  style={{ whiteSpace: 'normal' }}
                >
                  {item.description}
                </Table.TD>
                <Table.TD className="create-date" style={{ flex: '0 0 10%' }}>
                  {item.qty}
                </Table.TD>
                <Table.TD className="create-date" style={{ flex: '0 0 10%' }}>
                  {item.uom}
                </Table.TD>
                <Table.TD className="create-date" style={{ flex: '0 0 15%' }}>
                  {item.unit_price}
                </Table.TD>
                <Table.TD className="create-date" style={{ flex: '0 0 15%' }}>
                  {item.total_price}
                </Table.TD>
              </Table.TR>
            )
          })
        }
      }
      const title = (info, index) => {
        return (
          <div className="title-accordion-summary">
            <div className="no">
              <b>NO. {index}</b> {dateMonDayYearTimeFull(info.bidding_time)}
            </div>
            <div className="bidding-amount">
              BIDDING AMOUNT{' '}
              <b>{formatNumberWithCommaN2Decimal(info.bidding_amount)}</b>
            </div>
          </div>
        )
      }
      const renderItemList = list => {
        return (
          <Section className="compare-event-table-wrapper">
            <Table className="history-log-data header-freeze">
              <Table.TBODY>
                <Table.TR>
                  <Table.TH className="create-date" style={{ flex: '0 0 5%' }}>
                    No.
                  </Table.TH>
                  <Table.TH className="create-date" style={{ flex: '0 0 15%' }}>
                    ITEM NAME
                  </Table.TH>
                  <Table.TH className="create-date">DESCRIPTION</Table.TH>
                  <Table.TH className="create-date" style={{ flex: '0 0 10%' }}>
                    QUANTITY
                  </Table.TH>
                  <Table.TH className="create-date" style={{ flex: '0 0 10%' }}>
                    UOM
                  </Table.TH>
                  <Table.TH className="create-date" style={{ flex: '0 0 15%' }}>
                    UNIT PRICE
                  </Table.TH>
                  <Table.TH className="create-date" style={{ flex: '0 0 15%' }}>
                    TOTAL PRICE
                  </Table.TH>
                </Table.TR>
              </Table.TBODY>
              <Table className="history-log-data split-row-color css-table-his">
                <Table.TBODY>{renderItem(list)}</Table.TBODY>
              </Table>
            </Table>
          </Section>
        )
      }
      const handlersClose = () => {
        return this.toggleModal()
      }
      const { role } = store.getState()
      return (
        this.state.modals
          .filter(modal => {
            return modal.name === 'modals-history-of-supplier'
          })
          .map(obj => obj.isOpen)[0] && (
          <ModalHistoryOfSupplier
            modals={modals}
            itemBidHistory={itemBidHistory}
            eventData={formData}
            itemBidClick={itemBidClick}
            role={role}
            handlersClose={handlersClose}
            loadingBid={loadingBid}
          />
        )
      )
    }
    const renderModalCancelReq = () => {
      let {
        formData,
        reasonCancelRequest,
        approvalFiels,
        isErrMsgCancelReqText,
      } = this.state
      const { event_no, name, id } = formData
      const domElmSubmitCaReq = document.getElementById('reason-cancel-request')
      const handlersCancel = () => {
        domElmSubmitCaReq.value = ''
        isErrMsgCancelReqText = ''
        if (this._isMounted) {
          this.setState({
            isErrMsgCancelReqText: '',
          })
        }
        this.toggleModal()
      }

      const validateCancelReq = () => {
        let isPass = true
        if (!domElmSubmitCaReq.value) {
          isErrMsgCancelReqText = STRING.INVALID
          isPass = false
        }
        if (this._isMounted) {
          this.setState({
            isErrMsgCancelReqText,
          })
        }
        return isPass
      }

      const handlersConfirm = async () => {
        const value = domElmSubmitCaReq.value
        const elm = document.getElementById('approval-note')
        const resText = elm ? elm.value : ''
        if (validateCancelReq() && !this.state.isLoading) {
          this.setState({ isLoading: true, isConfirming: true })
          const obj = {
            // rfq_id: id,
            detail: value,
            note_for_approver: resText,
            file_request: approvalFiels,
          }
          try {
            this.toggleModal()
            const res = await rfqController().postCancelRequest(obj, id)
            if (res) {
              domElmSubmitCaReq.value = ''
              this.getEventById(id)
              this.funcGetApprovalHistory(id)
              setTimeout(() => {
                this.funcGetSourcingProject(true)
                this.getApprovalWorkflow(id)
              }, 1000)
              this.funcGetSavingType()
              this.setState({
                approvalNote: '',
                approvalFiels: [],
                showButtonCancel: false,
                showButtonSubmit: true,
                showButtonNoSelect: true,
              })
              toast.success('Award Proposal has been cancelled')
            }
            this.setState({ isLoading: false })
          } catch (error) {
            this.setState({ isLoading: false })
            domElmSubmitCaReq.value = ''
          }
          setTimeout(() => {
            this.setState({ isConfirming: false })
          }, 800)
        }
      }
      return (
        <Modal
          className="theme-blue modal-cancel-event"
          isOpen={
            modals
              .filter(modal => {
                return modal.name === 'cancel-request'
              })
              .map(obj => obj.isOpen)[0]
          }
          modalWidth="768px"
        >
          <Modal.Header>Cancel Award Proposal</Modal.Header>
          <Modal.Body>
            <Section className="form-group">
              <label>Event No:</label>
              <Section className="form-group-control">
                <Section className="form-group-inner-wrapper text">
                  {event_no}
                </Section>
              </Section>
            </Section>

            <Section className="form-group">
              <label>Event Name:</label>
              <Section className="form-group-control">
                <Section className="form-group-inner-wrapper text">
                  {name}
                </Section>
              </Section>
            </Section>

            <Section
              className={`form-group ${isErrMsgCancelReqText && 'is-error'}`}
            >
              <label>Reason:</label>
              <Section className="form-group-control">
                <Section className="form-group-inner-wrapper">
                  <InputTextarea
                    id="reason-cancel-request"
                    onChange={e => {
                      if (this._isMounted) {
                        this.setState({
                          isErrMsgCancelReqText: '',
                        })
                      }
                    }}
                  />
                </Section>
                <Section className="message">
                  {isErrMsgCancelReqText && isErrMsgCancelReqText}
                </Section>
              </Section>
            </Section>
          </Modal.Body>
          <Modal.Footer>
            <Button
              id="cancel-req"
              className="theme-gray"
              onClick={handlersCancel}
            >
              Cancel
            </Button>
            <Button
              id="confirm-req"
              className="theme-green"
              onClick={handlersConfirm}
              disabled={this.state.isConfirming}
            >
              Confirm
            </Button>
          </Modal.Footer>
        </Modal>
      )
    }
    const renderModalSubmitReject = () => {
      let {
        formData,
        approvalNote,
        approvalFiels,
        isErrMsgRejectText,
      } = this.state
      const { event_no, name, id } = formData
      const domElmSubmitRe = document.getElementById('reason-submit-reject')
      const handlersCancel = () => {
        domElmSubmitRe.value = ''
        this.toggleModal()
      }

      const validateSubmitReject = () => {
        let isPass = true
        if (!domElmSubmitRe.value) {
          isErrMsgRejectText = STRING.INVALID
          isPass = false
        }
        if (this._isMounted) {
          this.setState({
            isErrMsgRejectText,
          })
        }
        return isPass
      }

      const handlersConfirm = async () => {
        const value = domElmSubmitRe.value
        const elm = document.getElementById('approval-note')
        const resText = elm ? elm.value : ''
        if (validateSubmitReject() && !this.state.isLoading) {
          this.setState({ isLoading: true })
          const obj = {
            // rfq_id: id,
            reject_reason: value,
            note_for_approver: resText,
            file_request: approvalFiels,
          }
          try {
            const res = await rfqController().postRejectApprove(obj, id)
            if (res === '51511: approved by other approver') {
              domElmSubmitRe.value = ''
              toast.error('Approved by other approver')
              approvalNote = ''
              approvalFiels = []
              this.toggleModal()
              this.getEventById(id)
              this.funcGetApprovalHistory(id)
              this.getApprovalWorkflow(id)
              this.funcGetSourcingProject()
              this.setState({ approvalNote, approvalFiels })
            } else if (res === '51513: rejected by other approver') {
              domElmSubmitRe.value = ''
              toast.error('Rejected by other approver')
              approvalNote = ''
              approvalFiels = []
              this.toggleModal()
              this.getEventById(id)
              this.funcGetApprovalHistory(id)
              this.getApprovalWorkflow(id)
              this.funcGetSourcingProject()
              this.setState({ approvalNote, approvalFiels })
            } else if (res) {
              domElmSubmitRe.value = ''
              toast.success('Award Proposal has been rejected')
              approvalNote = ''
              approvalFiels = []
              this.toggleModal()
              this.getEventById(id)
              this.funcGetApprovalHistory(id)
              this.getApprovalWorkflow(id)
              this.funcGetSourcingProject()
              this.setState({ approvalNote, approvalFiels })
            }
            this.setState({ isLoading: false })
          } catch (error) {
            domElmSubmitRe.value = ''
            this.toggleModal()
            this.setState({ isLoading: false })
          }
        }
      }
      return (
        <Modal
          className="theme-blue modal-submit-reject"
          isOpen={
            modals
              .filter(modal => {
                return modal.name === 'modal-submit-reject'
              })
              .map(obj => obj.isOpen)[0]
          }
          modalWidth="768px"
        >
          <Modal.Header>Reject Award Proposal</Modal.Header>
          <Modal.Body>
            <Section className="form-group">
              <label>Event No:</label>
              <Section className="form-group-control">
                <Section className="form-group-inner-wrapper text">
                  {event_no}
                </Section>
              </Section>
            </Section>

            <Section className="form-group">
              <label>Event Name:</label>
              <Section className="form-group-control">
                <Section className="form-group-inner-wrapper text">
                  {name}
                </Section>
              </Section>
            </Section>

            <Section
              className={`form-group ${isErrMsgRejectText && 'is-error'}`}
            >
              <label>Reason:</label>
              <Section className="form-group-control">
                <Section className="form-group-inner-wrapper">
                  <InputTextarea
                    id="reason-submit-reject"
                    onChange={e => {
                      if (this._isMounted) {
                        this.setState({
                          isErrMsgRejectText: '',
                        })
                      }
                    }}
                  />
                </Section>
                <Section className="message">
                  {isErrMsgRejectText && isErrMsgRejectText}
                </Section>
              </Section>
            </Section>
          </Modal.Body>
          <Modal.Footer>
            <Button
              id="cancel-req"
              className="theme-gray"
              onClick={handlersCancel}
            >
              Cancel
            </Button>
            <Button
              id="confirm-req"
              className="theme-green"
              onClick={handlersConfirm}
            >
              Confirm
            </Button>
          </Modal.Footer>
        </Modal>
      )
    }
    const renderModalEditExchangeRate = () => {
      // const exchange_rate = Numeral(this.state.exchangeRate).format('0,0.0000')
      return (
        <Modal
          className="theme-blue"
          isOpen={
            modals
              .filter(modal => {
                return modal.name === 'modal-edit-exchange-rate'
              })
              .map(obj => obj.isOpen)[0]
          }
          modalWidth="575px"
          size="sm"
        >
          <Modal.Header>Edit Exchange Rate</Modal.Header>
          <Modal.Body>
            <Section className="form-group" mt="1rem">
              <label
                style={{
                  maxWidth: 'none',
                  flexBasis: 'auto',
                }}
              >
                Exchange Rate ({formData.currency})
              </label>
              <Section className="form-group-control">
                <Section className="form-group-inner-wrapper">
                  <NumberFormat
                    name={`exchange_rate`}
                    value={this.state.exchangeRate}
                    customInput={Input}
                    decimalScale={4}
                    placeholder="0.0000"
                    thousandSeparator={true}
                    onValueChange={e => {
                      this.setState({
                        exchangeRate: `${e.floatValue}`,
                      })
                    }}
                    onBlur={() => {
                      if (parseFloat(this.state.exchangeRate) < 0.0001) {
                        this.setState({
                          exchangeRate: '',
                        })
                      }
                    }}
                  />
                </Section>
                <Section className="message"></Section>
              </Section>
            </Section>
          </Modal.Body>

          <Modal.Footer>
            <Button
              className="theme-gray"
              onClick={() => {
                this.toggleModal()
              }}
            >
              Cancel
            </Button>
            <Button
              className="theme-green"
              onClick={() => {
                this.onChangeExchangeRate()
              }}
            >
              Confirm
            </Button>
          </Modal.Footer>
        </Modal>
      )
    }

    const handlersClose = () => {
      this.toggleModal()
    }

    return (
      <React.Fragment>
        <Loading
          loading={this.state.isLoading}
          spinner={this.state.isLoading}
        />
        <SourcingCompareEventBuyerStyle>
          {renderPageTitle()}
          {renderPageContent()}
        </SourcingCompareEventBuyerStyle>
        {renderModalReschedule()}
        {renderModalSupplierDescription()}
        {renderModalApprovalContact()}
        {renderModalPurchasingSite()}
        {renderModalCancelEvent()}
        {renderModalAttachment()}
        {renderModalNotetoBuyer()}
        {renderModalRequestUnseal()}
        {renderModalConfirmRequestUnseal()}
        {renderModalTecUnseal()}
        {renderModalHistoryApp()}
        {renderModalHistoryOfSupplier()}
        {renderModalCancelReq()}
        {renderModalSubmitReject()}
        {renderModalEditExchangeRate()}
        {this.renderModalAllowSelect()}
        {this.modalItemsNotFully()}
        {this.renderModalClearAll()}
        {this.renderModalSubmitAward()}
        {this.renderModalOfApproveButton()}
        {this.renderModalReSubmitAward()}
        {this.renderModalCheckAward()}
        {this.renderModalNoSelectionReason()}
      </React.Fragment>
    )
  }
  render = () => this.renderSourcingCompareEvent()
}

const mapStateToProps = state => {
  return {
    user: state.user,
  }
}
export const SourcingCompareEventContainer = connect(mapStateToProps)(
  SourcingCompareEventBuyerContainers
)
